import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};



export type ActiveContractReport = {
  __typename?: 'ActiveContractReport';
  PropertyID?: Maybe<Scalars['Float']>;
  PropertyName?: Maybe<Scalars['String']>;
  CompanyID?: Maybe<Scalars['Float']>;
  CompanyName?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  BookStartDate?: Maybe<Scalars['DateTime']>;
  ContractNo?: Maybe<Scalars['String']>;
  ContractDate?: Maybe<Scalars['DateTime']>;
  BrandName?: Maybe<Scalars['String']>;
  DefaultStartDate?: Maybe<Scalars['DateTime']>;
  DefaultExpiryDate?: Maybe<Scalars['DateTime']>;
  RecordStatus?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  ContractLotNo?: Maybe<Scalars['String']>;
  TotalRentalArea?: Maybe<Scalars['Float']>;
  OUM?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  RentalRate?: Maybe<Scalars['Float']>;
  RentalAmount?: Maybe<Scalars['Float']>;
  Currency?: Maybe<Scalars['String']>;
};

export type ActiveUnits = {
  __typename?: 'ActiveUnits';
  unitId?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
  floorNo?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Float']>;
  tenantName?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  blockName?: Maybe<Scalars['String']>;
  rentalId?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
};

export type AddNewContactInputModel = {
  bookId?: Maybe<Scalars['Float']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['Float']>;
  mobilePhone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type AgeingAnalysisOutput = {
  __typename?: 'AgeingAnalysisOutput';
  legendData?: Maybe<Array<Scalars['String']>>;
  chartData?: Maybe<Array<ChartData>>;
  outstandingAmt?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  AccountName?: Maybe<Scalars['String']>;
  Age1Amt?: Maybe<Scalars['Float']>;
  Age2Amt?: Maybe<Scalars['Float']>;
  Age3Amt?: Maybe<Scalars['Float']>;
  Age4Amt?: Maybe<Scalars['Float']>;
  Age5Amt?: Maybe<Scalars['Float']>;
  Age6Amt?: Maybe<Scalars['Float']>;
  Age7Amt?: Maybe<Scalars['Float']>;
  OutstandingAmt?: Maybe<Scalars['Float']>;
};

export type ApiGatewayEntity = {
  __typename?: 'ApiGatewayEntity';
  id: Scalars['Float'];
  apiCallToken?: Maybe<Scalars['String']>;
  softwareCode?: Maybe<Scalars['String']>;
};

export enum ApplicationEnum {
  ServiceRequest = 'ServiceRequest',
  Common = 'Common',
  CommonSetup = 'CommonSetup',
  One = 'One'
}

export type ApproveOrRejectOutput = {
  __typename?: 'ApproveOrRejectOutput';
  result?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type AttachementOutput = {
  __typename?: 'AttachementOutput';
  attachmentId: Scalars['Float'];
  mediaType?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  uniqueFileName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  base64File?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
};

export type AttachmentEntity = {
  __typename?: 'AttachmentEntity';
  attachmentId: Scalars['Float'];
  accountId: Scalars['Float'];
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
  mediaType: Scalars['String'];
  resourceUrl?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  isPrivate?: Maybe<Scalars['Boolean']>;
  uniqueFileName: Scalars['String'];
  filePath?: Maybe<Scalars['String']>;
  suffix: Scalars['String'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  posTrx: PosTrxEntity;
};

export type AttachmentInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  accountId: Scalars['Float'];
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
  mediaType: Scalars['String'];
  resourceUrl?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  isPrivate?: Maybe<Scalars['Boolean']>;
  uniqueFileName: Scalars['String'];
  filePath?: Maybe<Scalars['String']>;
  suffix: Scalars['String'];
};

export type AttachmentsInputType = {
  attachmentId?: Maybe<Scalars['Float']>;
  file: Scalars['Upload'];
};

export type BillSchedule = {
  __typename?: 'BillSchedule';
  rentlId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  contractLotNo?: Maybe<Scalars['String']>;
  leaseableArea?: Maybe<Scalars['Float']>;
  billItem?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
};

export type BookIds = {
  __typename?: 'BookIds';
  bookId?: Maybe<Array<Scalars['Float']>>;
};

export type BookingFormInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  tenantId?: Maybe<Scalars['Float']>;
  unitList: Array<UnitDetails>;
  tenant?: Maybe<TenantInputType>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  bookingDate: Scalars['DateTime'];
  validityDays: Scalars['Float'];
  bookingFees: Scalars['Float'];
  bookingType: Scalars['String'];
  remarks: Scalars['String'];
  attachments?: Maybe<Array<AttachmentsInputType>>;
};

export type BookingStatistics = {
  __typename?: 'BookingStatistics';
  ActiveArea?: Maybe<Scalars['Float']>;
  ActiveCount?: Maybe<Scalars['Float']>;
  SubmittedArea?: Maybe<Scalars['Float']>;
  SubmittedCount?: Maybe<Scalars['Float']>;
  ApprovedArea?: Maybe<Scalars['Float']>;
  ApprovedCount?: Maybe<Scalars['Float']>;
  RejectedArea?: Maybe<Scalars['Float']>;
  RejectedCount?: Maybe<Scalars['Float']>;
  GrandTotalArea?: Maybe<Scalars['Float']>;
  GrandTotalCount?: Maybe<Scalars['Float']>;
  TitleCN?: Maybe<Scalars['String']>;
  PropertyID?: Maybe<Scalars['Float']>;
};

export type BookingSummary = {
  __typename?: 'BookingSummary';
  NewCount?: Maybe<Scalars['Float']>;
  ApprovedCount?: Maybe<Scalars['Float']>;
  SubmittedCount?: Maybe<Scalars['Float']>;
  RejectedCount?: Maybe<Scalars['Float']>;
  SignCount?: Maybe<Scalars['Float']>;
};

export type BrandAllocDuringPrepData = {
  __typename?: 'BrandAllocDuringPrepData';
  unitId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  programName?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  blockName?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
  floorNo?: Maybe<Scalars['String']>;
  leaseArea?: Maybe<Scalars['String']>;
  aBrandName?: Maybe<Scalars['String']>;
  bBrandName?: Maybe<Scalars['String']>;
  cBrandName?: Maybe<Scalars['String']>;
};

export type BusinessInsightOutput = {
  __typename?: 'BusinessInsightOutput';
  monthlyRentalFee?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  contractNo?: Maybe<Scalars['String']>;
  contractLotNo?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  defaultStartDate?: Maybe<Scalars['DateTime']>;
  defaultExpiryDate?: Maybe<Scalars['DateTime']>;
  totalRentArea?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  thisMonthAmt?: Maybe<Scalars['Float']>;
  lastMonthAmt?: Maybe<Scalars['Float']>;
  ytdAmt?: Maybe<Scalars['Float']>;
  years?: Maybe<Scalars['Float']>;
  reviewAmount?: Maybe<Scalars['Float']>;
  reviewAmt5Perc?: Maybe<Scalars['Float']>;
  reviewAmt15Perc?: Maybe<Scalars['Float']>;
  approvedAmt?: Maybe<Scalars['Float']>;
  submittedAmt?: Maybe<Scalars['Float']>;
  rejectedAmt?: Maybe<Scalars['Float']>;
  weekNumber?: Maybe<Scalars['Float']>;
};

export type CcRate = {
  __typename?: 'CCRate';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['String']>;
};

export type ChargeDetailEntity = {
  __typename?: 'ChargeDetailEntity';
  contractChargeDetailId: Scalars['Float'];
  contractChargeId: Scalars['Float'];
  rentalId: Scalars['Float'];
  categoryId?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  increaseStartDate?: Maybe<Scalars['DateTime']>;
  increasePeriod?: Maybe<Scalars['Float']>;
  increaseMethod?: Maybe<Scalars['String']>;
  increaseValue?: Maybe<Scalars['Float']>;
  revenueMethod?: Maybe<Scalars['String']>;
  revenuePercentage?: Maybe<Scalars['Float']>;
  minAmount?: Maybe<Scalars['Float']>;
  maxAmount?: Maybe<Scalars['Float']>;
  priceMethod?: Maybe<Scalars['String']>;
  isReviewEdit?: Maybe<Scalars['String']>;
  rentStandardType?: Maybe<Scalars['String']>;
  referPrice?: Maybe<Scalars['Float']>;
  referPriceString?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  posTradeSales: PosTradeSalesEntity;
  popUpLstElement: PopupLstElementEntity;
};

export type ChargeDetailView = {
  __typename?: 'ChargeDetailView';
  contractChargeId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  rentStandardType?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  revenueMethod?: Maybe<Scalars['String']>;
  revenuePercentage?: Maybe<Scalars['Float']>;
};

export type ChartData = {
  __typename?: 'ChartData';
  value?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type CheckDataInputModel = {
  userId?: Maybe<Scalars['Float']>;
  checkDate?: Maybe<Scalars['DateTime']>;
  propertyId?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  checkItems?: Maybe<Array<CheckItems>>;
};

export type CheckItems = {
  remark?: Maybe<Scalars['String']>;
  checkItemId?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
  forfeit?: Maybe<Scalars['Float']>;
  typeId?: Maybe<Scalars['Float']>;
  attachment?: Maybe<Array<Scalars['Upload']>>;
};

export type CommonConfigDocCodeFormatData = {
  __typename?: 'CommonConfigDocCodeFormatData';
  docCodeFormatId: Scalars['Float'];
  companyId: Scalars['Float'];
  docCodeId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  formatOrder: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  janSpelling: Scalars['String'];
  febSpelling: Scalars['String'];
  marSpelling: Scalars['String'];
  aprSpelling: Scalars['String'];
  maySpelling: Scalars['String'];
  junSpelling: Scalars['String'];
  julSpelling: Scalars['String'];
  augSpelling: Scalars['String'];
  sepSpelling: Scalars['String'];
  octSpelling: Scalars['String'];
  novSpelling: Scalars['String'];
  decSpelling: Scalars['String'];
  format?: Maybe<Scalars['String']>;
  codeWidth?: Maybe<Scalars['Float']>;
  padded?: Maybe<Scalars['String']>;
  baseOnNo?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type CommonConfigDocCodeHistoryData = {
  __typename?: 'CommonConfigDocCodeHistoryData';
  docCodeHistoryId: Scalars['Float'];
  docCodeId: Scalars['String'];
  companyId: Scalars['Float'];
  docCodeRule: Scalars['String'];
  serialNum?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  serialFilter?: Maybe<Scalars['String']>;
};

export type CommonConfigDocCodeTempData = {
  __typename?: 'CommonConfigDocCodeTempData';
  docCodeTempId: Scalars['Float'];
  docCodeId: Scalars['String'];
  serialNo: Scalars['String'];
  status: Scalars['String'];
  updateDate: Scalars['DateTime'];
  serialFilter?: Maybe<Scalars['String']>;
  companyId: Scalars['Float'];
  useNewCode?: Maybe<Scalars['String']>;
};

export type CommonSetupAccountData = {
  __typename?: 'CommonSetupAccountData';
  accountId: Scalars['Float'];
  addressId?: Maybe<Scalars['Float']>;
  accountNo: Scalars['String'];
  district?: Maybe<Scalars['Float']>;
  fax?: Maybe<Scalars['String']>;
  industryTypeId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  identityNo?: Maybe<Scalars['String']>;
  isVip?: Maybe<Scalars['String']>;
  isPrivilege?: Maybe<Scalars['String']>;
  isCompany: Scalars['String'];
  parentAccountId?: Maybe<Scalars['Float']>;
  developerClass?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  alternateEmail?: Maybe<Scalars['String']>;
  webSite?: Maybe<Scalars['String']>;
  supplyRegionId?: Maybe<Scalars['Float']>;
  companySizeId?: Maybe<Scalars['Float']>;
  preferredLanguage?: Maybe<Scalars['String']>;
  referrerId?: Maybe<Scalars['Float']>;
  professionId?: Maybe<Scalars['Float']>;
  designationId?: Maybe<Scalars['Float']>;
  salutationId?: Maybe<Scalars['Float']>;
  activeLevelId?: Maybe<Scalars['Float']>;
  nationalityId?: Maybe<Scalars['Float']>;
  raceId?: Maybe<Scalars['Float']>;
  brandName?: Maybe<Scalars['String']>;
  customerTypeId?: Maybe<Scalars['Float']>;
  mobilePhone?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatusId?: Maybe<Scalars['Float']>;
  sexId?: Maybe<Scalars['Float']>;
  birthday?: Maybe<Scalars['DateTime']>;
  identityTypeId?: Maybe<Scalars['Float']>;
  educationLevelId?: Maybe<Scalars['Float']>;
  officePhone?: Maybe<Scalars['String']>;
  contactname?: Maybe<Scalars['String']>;
  taxRegistrationNo?: Maybe<Scalars['String']>;
  isMailer?: Maybe<Scalars['String']>;
  isSms?: Maybe<Scalars['String']>;
  isEmail?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['Float']>;
  groupCompanyId?: Maybe<Scalars['Float']>;
  enterpriseNature?: Maybe<Scalars['Float']>;
  isTrouble?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['Float']>;
  post?: Maybe<Scalars['Float']>;
  customerSource?: Maybe<Scalars['Float']>;
  relationship?: Maybe<Scalars['Float']>;
  accountGroupId?: Maybe<Scalars['Float']>;
  rentalContract: Array<LeaseContRentalContractData>;
  contact?: Maybe<Array<CommonSetupContactData>>;
  posSubmission: Array<PosSubmissionEntity>;
  turnover: Array<TurnoverSummaryEntity>;
  professionData?: Maybe<PopupLstElementEntity>;
  country?: Maybe<CommonSetupPopuplstElemData>;
  race?: Maybe<CommonSetupPopuplstElemData>;
  sex?: Maybe<CommonSetupPopuplstElemData>;
  industry?: Maybe<CommonSetupPopuplstElemData>;
  designation?: Maybe<CommonSetupPopuplstElemData>;
  identityType?: Maybe<CommonSetupPopuplstElemData>;
  tenantGroup?: Maybe<CommonSetupAccountGroupData>;
  bookData: Array<LeaseMercBookData>;
};

export type CommonSetupAccountGroupData = {
  __typename?: 'CommonSetupAccountGroupData';
  accountGroupId: Scalars['Float'];
  accountGroupNo?: Maybe<Scalars['String']>;
  accountGroupName?: Maybe<Scalars['String']>;
  accountGroupDesc?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  account: CommonSetupAccountData;
};

export type CommonSetupBankAccountData = {
  __typename?: 'CommonSetupBankAccountData';
  bankAccountId: Scalars['Float'];
  companyId: Scalars['Float'];
  accountNo?: Maybe<Scalars['String']>;
  accountTypeId: Scalars['Float'];
  currencyId: Scalars['Float'];
  bankCode: Scalars['String'];
  overdraftLimit?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  isCheckOverdraft?: Maybe<Scalars['String']>;
  reconciliationMode?: Maybe<Scalars['String']>;
  authorizedNameA?: Maybe<Scalars['String']>;
  authorizedNameB?: Maybe<Scalars['String']>;
  authorizedIcnob?: Maybe<Scalars['String']>;
  authorizedIcnoa?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['Float']>;
  glAccountCode?: Maybe<Scalars['String']>;
  bankDetail: CommonSetupBankData;
};

export type CommonSetupBankData = {
  __typename?: 'CommonSetupBankData';
  bankId: Scalars['Float'];
  addressId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  bankName?: Maybe<Scalars['String']>;
  bankNo?: Maybe<Scalars['String']>;
  parentBankId?: Maybe<Scalars['Float']>;
};

export enum CommonSetupClass {
  Common = 'Common'
}

export type CommonSetupCompanyDataEntity = {
  __typename?: 'CommonSetupCompanyDataEntity';
  companyId: Scalars['Float'];
  isSystemOwner?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['Float']>;
  orderNum?: Maybe<Scalars['Float']>;
  addressId?: Maybe<Scalars['Float']>;
  industryId?: Maybe<Scalars['Float']>;
  timezoneId?: Maybe<Scalars['Float']>;
  currencyId?: Maybe<Scalars['Float']>;
  currencyExchPackageId?: Maybe<Scalars['Float']>;
  logoImageId?: Maybe<Scalars['Float']>;
  parentProcurementId?: Maybe<Scalars['Float']>;
  procurementLevel?: Maybe<Scalars['Float']>;
  zipCode?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  registerNo?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  acronym?: Maybe<Scalars['String']>;
  mapY?: Maybe<Scalars['Float']>;
  mapX?: Maybe<Scalars['Float']>;
  mapType?: Maybe<Scalars['String']>;
  mapLevel?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  companyProfile?: Maybe<Scalars['String']>;
  baseCurrencyId?: Maybe<Scalars['Float']>;
  irdAddress?: Maybe<Scalars['String']>;
  firstLogo?: Maybe<Scalars['String']>;
  dayoffSetting?: Maybe<Scalars['String']>;
  financeAccount?: Maybe<Scalars['String']>;
  areaId?: Maybe<Scalars['Float']>;
  salaryTemplateId?: Maybe<Scalars['Float']>;
  dayoffSetId?: Maybe<Scalars['Float']>;
  levelName?: Maybe<Scalars['String']>;
  levelId?: Maybe<Scalars['Float']>;
  applicationCode?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Float']>;
  stateId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  cityName?: Maybe<Scalars['String']>;
  detailAddress2?: Maybe<Scalars['String']>;
  logoImage?: Maybe<Scalars['String']>;
  employerTaxNumber?: Maybe<Scalars['String']>;
  employerEpfNumber?: Maybe<Scalars['String']>;
  employerSocsoNumber?: Maybe<Scalars['String']>;
  payrollCutoffDay?: Maybe<Scalars['Float']>;
  workingHoursADay?: Maybe<Scalars['Float']>;
  workDayTypeId?: Maybe<Scalars['Float']>;
  workingDaysAMonth?: Maybe<Scalars['Float']>;
  payEligibleForOt?: Maybe<Scalars['Float']>;
  costCenterId?: Maybe<Scalars['String']>;
  isGenerateEmployeeNo: Scalars['Boolean'];
  taxAgencyBranch?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  companyCode?: Maybe<Scalars['String']>;
  personinCharge?: Maybe<Scalars['Float']>;
  scCalendarId?: Maybe<Scalars['Float']>;
  scNumber?: Maybe<Scalars['Float']>;
  hrdfRate?: Maybe<Scalars['Float']>;
  clubName?: Maybe<Scalars['String']>;
  registrationNo?: Maybe<Scalars['String']>;
  verifiedDate?: Maybe<Scalars['DateTime']>;
  reportingType?: Maybe<Scalars['Float']>;
  branchCode?: Maybe<Scalars['String']>;
  baseId?: Maybe<Scalars['Float']>;
  isHq?: Maybe<Scalars['Boolean']>;
  groupRegistrationNo?: Maybe<Scalars['String']>;
  epfInCharge?: Maybe<Scalars['Float']>;
  socsoInCharge?: Maybe<Scalars['Float']>;
  taxInCharge?: Maybe<Scalars['Float']>;
  currencyData?: Maybe<CommonSetupCurrencyDataEntity>;
  property?: Maybe<Array<LeaseProSetPropertyData>>;
  user?: Maybe<Array<CommonSetupUserData>>;
  resources?: Maybe<Array<CommonSetupProjectResData>>;
  parent?: Maybe<CommonSetupCompanyDataEntity>;
  child?: Maybe<CommonSetupCompanyDataEntity>;
};

export type CommonSetupContactData = {
  __typename?: 'CommonSetupContactData';
  contactId: Scalars['Float'];
  email?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  salutationId?: Maybe<Scalars['Float']>;
  titleId?: Maybe<Scalars['Float']>;
  instanceMessenger?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  passportNo?: Maybe<Scalars['String']>;
  identityTypeId?: Maybe<Scalars['Float']>;
  identityNo?: Maybe<Scalars['String']>;
  maritalStatusId?: Maybe<Scalars['Float']>;
  sexId?: Maybe<Scalars['Float']>;
  educationLevelId?: Maybe<Scalars['Float']>;
  nationalityId?: Maybe<Scalars['Float']>;
  raceId?: Maybe<Scalars['Float']>;
  income?: Maybe<Scalars['String']>;
  webSite?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['Float']>;
  spouseName?: Maybe<Scalars['String']>;
  weddingAnniversary?: Maybe<Scalars['DateTime']>;
  age?: Maybe<Scalars['Float']>;
  introducer?: Maybe<Scalars['String']>;
  religionId?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Float']>;
  parentContactId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  post?: Maybe<Scalars['Float']>;
  relationship?: Maybe<Scalars['Float']>;
  accountId: Scalars['Float'];
  account: CommonSetupAccountData;
  profession?: Maybe<CommonSetupPopuplstElemData>;
};

export type CommonSetupCountryData = {
  __typename?: 'CommonSetupCountryData';
  countryId: Scalars['Float'];
  countryCode?: Maybe<Scalars['String']>;
  isoCode?: Maybe<Scalars['String']>;
  isDefault: Scalars['String'];
  name: Scalars['String'];
  currencyId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type CommonSetupCurrencyDataEntity = {
  __typename?: 'CommonSetupCurrencyDataEntity';
  currencyId: Scalars['Float'];
  isBaseCurrency: Scalars['String'];
  description: Scalars['String'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
  subScale: Scalars['Float'];
  symbol: Scalars['String'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  companyData: CommonSetupCompanyDataEntity;
};

export type CommonSetupDeptData = {
  __typename?: 'CommonSetupDeptData';
  deptId: Scalars['Float'];
  companyId: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentDeptId?: Maybe<Scalars['Float']>;
  addressId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  deptNo: Scalars['String'];
  orderNum?: Maybe<Scalars['Float']>;
  isProjectAnalysis?: Maybe<Scalars['String']>;
  financialAccounts?: Maybe<Scalars['String']>;
  financeAccount?: Maybe<Scalars['String']>;
};

export type CommonSetupDocExtendData = {
  __typename?: 'CommonSetupDocExtendData';
  docExtendId: Scalars['Float'];
  applicationCode?: Maybe<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  popupLstElementId?: Maybe<Scalars['Float']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Float']>;
  fdbFile?: Maybe<FdbFile>;
  fileContent?: Maybe<FdbFileContent>;
};

export enum CommonSetupName {
  MaxFileSize = 'MaxFileSize'
}

export type CommonSetupPopuplstElemData = {
  __typename?: 'CommonSetupPopuplstElemData';
  popupLstElementId: Scalars['Float'];
  applicationCode?: Maybe<Scalars['String']>;
  popupLstId: Scalars['Float'];
  parentPopupLstElementId?: Maybe<Scalars['Float']>;
  isDefault: Scalars['String'];
  isSystem?: Maybe<Scalars['String']>;
  elementCode?: Maybe<Scalars['String']>;
  titleCn?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleStringCode: Scalars['String'];
  rank?: Maybe<Scalars['Float']>;
  isSearchable: Scalars['String'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  popType?: Maybe<Scalars['String']>;
  accountCountry: CommonSetupAccountData;
  accountRace: CommonSetupAccountData;
  accountSex: CommonSetupAccountData;
  accountIndustry: CommonSetupAccountData;
  accountDesignation: CommonSetupAccountData;
  accountIdentityType: CommonSetupAccountData;
  contactPersonOfProfession: CommonSetupContactData;
};

export enum CommonSetupPopuplstTypeEnum {
  Designation = 'Designation'
}

export type CommonSetupProjectResData = {
  __typename?: 'CommonSetupProjectResData';
  resourcesId: Scalars['Float'];
  parentId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  parentCompanyId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['String']>;
  refPrimaryKey?: Maybe<Scalars['String']>;
  projectRoleUser?: Maybe<Array<CommonSetupProjectRoleUserData>>;
  property?: Maybe<LeaseProSetPropertyData>;
  imageData?: Maybe<Array<LeaseProSetImageDataEntity>>;
  companyData?: Maybe<CommonSetupCompanyDataEntity>;
};

export type CommonSetupProjectRoleUserData = {
  __typename?: 'CommonSetupProjectRoleUserData';
  projectRoleUserId: Scalars['Float'];
  resourcesId: Scalars['Float'];
  userId: Scalars['Float'];
  roleId: Scalars['Float'];
  recordStatus?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  isTempRole?: Maybe<Scalars['Boolean']>;
  resources: CommonSetupProjectResData;
  user: CommonSetupUserData;
};

export type CommonSetupTaxData = {
  __typename?: 'CommonSetupTaxData';
  taxId: Scalars['Float'];
  taxCode: Scalars['String'];
  taxTitle: Scalars['String'];
  taxRate: Scalars['Float'];
  taxStringCode: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  type?: Maybe<Scalars['String']>;
  isInclusive: Scalars['String'];
  claim?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  glAccountCode?: Maybe<Scalars['String']>;
};

export type CommonSetupUserData = {
  __typename?: 'CommonSetupUserData';
  userId: Scalars['Float'];
  privClassId: Scalars['Float'];
  refTable: Scalars['String'];
  refRecordId: Scalars['Float'];
  loginName: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  languageSelect: Scalars['String'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  defaultProjectId?: Maybe<Scalars['String']>;
  adUserName?: Maybe<Scalars['String']>;
  communicatorUserName?: Maybe<Scalars['String']>;
  isManager: Scalars['String'];
  regionalSetting: Scalars['String'];
  lastLoginAppCode?: Maybe<Scalars['String']>;
  lastLoginAttempt?: Maybe<Scalars['DateTime']>;
  loginAttempt?: Maybe<Scalars['Float']>;
  licenseCheck?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  defaultMenuTemplateId: Scalars['Float'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  defaultReportTemplateId?: Maybe<Scalars['Float']>;
  licenseType?: Maybe<Scalars['Float']>;
  restrictIp?: Maybe<Scalars['Boolean']>;
  defaultLetterTemplateId?: Maybe<Scalars['Float']>;
  allowTranslate?: Maybe<Scalars['Boolean']>;
  workDesktopTemplateId?: Maybe<Scalars['Float']>;
  employeeId?: Maybe<Scalars['Float']>;
  userName?: Maybe<Scalars['String']>;
  expiryDays?: Maybe<Scalars['Float']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  isExpiry?: Maybe<Scalars['Boolean']>;
  isRepairPassword?: Maybe<Scalars['Boolean']>;
  isUserExpiry?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  handPhone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  raceId?: Maybe<Scalars['String']>;
  religionId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  familyAddress?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  isUser?: Maybe<Scalars['Boolean']>;
  identityTypeId?: Maybe<Scalars['Float']>;
  identityNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
  deptId?: Maybe<Scalars['Float']>;
  dataScopeTypeId?: Maybe<Scalars['Float']>;
  lockTime?: Maybe<Scalars['DateTime']>;
  dataScopeTypeCode?: Maybe<Scalars['String']>;
  department?: Maybe<CommonSetupDeptData>;
  userRole?: Maybe<Array<CorePermissionRoleUserData>>;
  companyData?: Maybe<CommonSetupCompanyDataEntity>;
  projectRoleUser?: Maybe<Array<CommonSetupProjectRoleUserData>>;
  privilAccessData: Array<LeaseMercPrivilAccessData>;
  departmentData?: Maybe<CommonSetupDeptData>;
};

export type CommonSetupUserOperationMenuEntity = {
  __typename?: 'CommonSetupUserOperationMenuEntity';
  id: Scalars['Float'];
  sysKey?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  levelNum?: Maybe<Scalars['String']>;
  appCode?: Maybe<Scalars['String']>;
  moduleCode?: Maybe<Scalars['String']>;
  functionCode?: Maybe<Scalars['String']>;
  actionGroup?: Maybe<Scalars['String']>;
  actionCode?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  descText?: Maybe<Scalars['String']>;
  userRole?: Maybe<Array<CorePermissionRoleUserData>>;
};

export type ContChargesView = {
  __typename?: 'ContChargesView';
  RTContractID?: Maybe<Scalars['Float']>;
  contractChargeId: Scalars['Float'];
  itemName?: Maybe<Scalars['String']>;
  calculateMethodName?: Maybe<Scalars['String']>;
  billFrequencyNameCN?: Maybe<Scalars['String']>;
  billFrequencyNameEN?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  calculateMethod?: Maybe<Scalars['String']>;
  differenceMethodName?: Maybe<Scalars['String']>;
  frequencyModeNameCN?: Maybe<Scalars['String']>;
  frequencyModeNameEN?: Maybe<Scalars['String']>;
  rentStandardType?: Maybe<Scalars['String']>;
  extraCreditTerms?: Maybe<Scalars['String']>;
  ExtraGracePeroid?: Maybe<Scalars['String']>;
  isFirstDayBilling?: Maybe<Scalars['String']>;
  refBillItemName?: Maybe<Scalars['String']>;
  minChargeAmt?: Maybe<Scalars['Float']>;
  maxChargeAmt?: Maybe<Scalars['Float']>;
};

export type ContactPersonInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  isPrimaryContact: Scalars['Boolean'];
  contactName: Scalars['String'];
  contactDesignation: Scalars['Float'];
  contactPhone: Scalars['String'];
  contactEmail: Scalars['String'];
  contactDesignationText: Scalars['String'];
};

export type ContractAttachments = {
  __typename?: 'ContractAttachments';
  base64File?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
};

export type ContractDetailsOutput = {
  __typename?: 'ContractDetailsOutput';
  category?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  rentFree?: Maybe<Array<ContractRentFreeOutput>>;
};

export type ContractInfo = {
  __typename?: 'ContractInfo';
  RentalID: Scalars['Float'];
  ParentID?: Maybe<Scalars['Float']>;
  CompanyID?: Maybe<Scalars['Float']>;
  PropertyID?: Maybe<Scalars['Float']>;
  PropertyName?: Maybe<Scalars['String']>;
  PropertyNo?: Maybe<Scalars['String']>;
  ContractNo?: Maybe<Scalars['String']>;
  ContractLotNo?: Maybe<Scalars['String']>;
  RentalGUID?: Maybe<Scalars['String']>;
  RentalTypeID?: Maybe<Scalars['Float']>;
  RentalType?: Maybe<Scalars['String']>;
  ElementCode?: Maybe<Scalars['String']>;
  TitleCN?: Maybe<Scalars['String']>;
  RentalStatus?: Maybe<Scalars['String']>;
  DefaultStartDate?: Maybe<Scalars['DateTime']>;
  DefaultExpiryDate?: Maybe<Scalars['DateTime']>;
  TerminateDate?: Maybe<Scalars['DateTime']>;
  ValidDate?: Maybe<Scalars['DateTime']>;
  LeasedStartDate?: Maybe<Scalars['DateTime']>;
  LeasedEndDate?: Maybe<Scalars['DateTime']>;
  ContractDate?: Maybe<Scalars['DateTime']>;
  RefTable?: Maybe<Scalars['String']>;
  RefRecordID?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  Version?: Maybe<Scalars['String']>;
  ProspectID?: Maybe<Scalars['Float']>;
  AccountID?: Maybe<Scalars['Float']>;
  DebtorID?: Maybe<Scalars['Float']>;
  AccountName?: Maybe<Scalars['String']>;
  ContactID?: Maybe<Scalars['Float']>;
  ContactName?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  AccountTaxRegistrationNo?: Maybe<Scalars['String']>;
  AccountIsCompany?: Maybe<Scalars['Boolean']>;
  BillAddressID?: Maybe<Scalars['Float']>;
  BillAddressName?: Maybe<Scalars['String']>;
  DebtorNo?: Maybe<Scalars['String']>;
  IndustryID?: Maybe<Scalars['Float']>;
  BrandIndustry?: Maybe<Scalars['String']>;
  BrandID?: Maybe<Scalars['Float']>;
  BrandName?: Maybe<Scalars['String']>;
  LevelCode?: Maybe<Scalars['String']>;
  TypeCode?: Maybe<Scalars['String']>;
  ShopName?: Maybe<Scalars['String']>;
  AgentID?: Maybe<Scalars['Float']>;
  AgentName?: Maybe<Scalars['String']>;
  TotalRentalArea?: Maybe<Scalars['Float']>;
  TotalAmt?: Maybe<Scalars['Float']>;
  ManagementExpensesAmt?: Maybe<Scalars['Float']>;
  LeaseAmt?: Maybe<Scalars['Float']>;
  ValidPrice?: Maybe<Scalars['Float']>;
  GenerateBillTypeCode?: Maybe<Scalars['String']>;
  MonthlyDaysCode?: Maybe<Scalars['String']>;
  IsGenerateFreeBill?: Maybe<Scalars['String']>;
  CreditTerms?: Maybe<Scalars['Float']>;
  GracePeriod?: Maybe<Scalars['Float']>;
  IsSendStatement?: Maybe<Scalars['Boolean']>;
  IfcaPos?: Maybe<Scalars['Boolean']>;
  PosType?: Maybe<Scalars['String']>;
  CollectionBy?: Maybe<Scalars['String']>;
  BalancePeriod?: Maybe<Scalars['String']>;
  BalancePeriodNum?: Maybe<Scalars['Float']>;
  LiquidationPeriod?: Maybe<Scalars['String']>;
  DeductionRatio?: Maybe<Scalars['Float']>;
  LatestBalanceAmt?: Maybe<Scalars['Float']>;
  MonthRentalFeeAmt?: Maybe<Scalars['Float']>;
  YearRentalFeeAmt?: Maybe<Scalars['Float']>;
  NoticeContractExpireDays?: Maybe<Scalars['Float']>;
  FitmentStartDate?: Maybe<Scalars['DateTime']>;
  FitmentEndDate?: Maybe<Scalars['DateTime']>;
  NextRentReviewDate?: Maybe<Scalars['DateTime']>;
  ReceiptCompanyID?: Maybe<Scalars['Float']>;
  ReceiptCompany?: Maybe<Scalars['String']>;
  YearlyRentalAmt?: Maybe<Scalars['Float']>;
  YearlyNetRentalAmt?: Maybe<Scalars['Float']>;
  YearlyRentalRate?: Maybe<Scalars['Float']>;
  YearlyNetRentalRate?: Maybe<Scalars['Float']>;
  MonthlyRentalAmt?: Maybe<Scalars['Float']>;
  MonthlyNetRentalAmt?: Maybe<Scalars['Float']>;
  MonthlyRentalRate?: Maybe<Scalars['Float']>;
  MonthlyNetRentalRate?: Maybe<Scalars['Float']>;
  DailyRentalAmt?: Maybe<Scalars['Float']>;
  DailyNetRentalAmt?: Maybe<Scalars['Float']>;
  DailyRentalRate?: Maybe<Scalars['Float']>;
  DailyNetRentalRate?: Maybe<Scalars['Float']>;
  ContractDateRange?: Maybe<Scalars['Float']>;
  Status: Scalars['String'];
  RecordStatus: Scalars['String'];
  RecordStatusSort: Scalars['Float'];
  Remark?: Maybe<Scalars['String']>;
  TerminateByID?: Maybe<Scalars['Float']>;
  TerminateReasonID?: Maybe<Scalars['Float']>;
  TerminateByName?: Maybe<Scalars['String']>;
  CompanyName?: Maybe<Scalars['String']>;
  SettlementWFStatus: Scalars['String'];
  CreateUserID: Scalars['Float'];
  CreateUser?: Maybe<Scalars['String']>;
  CreateDate?: Maybe<Scalars['DateTime']>;
  ModifyUserID?: Maybe<Scalars['Float']>;
  ModifyUser?: Maybe<Scalars['String']>;
  ModifyDate?: Maybe<Scalars['DateTime']>;
  CommissionID?: Maybe<Scalars['Float']>;
  RentalNo?: Maybe<Scalars['String']>;
  RentalDate?: Maybe<Scalars['DateTime']>;
  ContractBy?: Maybe<Scalars['String']>;
  StampingDate?: Maybe<Scalars['DateTime']>;
  CurrencyID?: Maybe<Scalars['Float']>;
  TenantTypeID?: Maybe<Scalars['Float']>;
  ISRenewal?: Maybe<Scalars['Boolean']>;
  ISInsurance?: Maybe<Scalars['String']>;
  RentFreePeriods?: Maybe<Scalars['String']>;
};

export type ContractRentFreeOutput = {
  __typename?: 'ContractRentFreeOutput';
  rentFreeStartDate?: Maybe<Scalars['DateTime']>;
  rentFreeEndDate?: Maybe<Scalars['DateTime']>;
  rentFreeItemName?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

export type ContractStatusOutput = {
  __typename?: 'ContractStatusOutput';
  rentalId?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
};

export type ContractbyPropertyInput = {
  propertyId: Scalars['Float'];
  status?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type ContractsAndOpportunities = {
  __typename?: 'ContractsAndOpportunities';
  TotalActiveContracts?: Maybe<Scalars['Float']>;
  ExpiringThisMonth?: Maybe<Scalars['Float']>;
  ExpiringNextMonth?: Maybe<Scalars['Float']>;
  ExpiringFollowingMonth?: Maybe<Scalars['Float']>;
  Booking?: Maybe<Scalars['Float']>;
  LetterOfferPendingApproval?: Maybe<Scalars['Float']>;
  PropertyID?: Maybe<Scalars['Float']>;
};

export type ContractsAndOpportunitiesTable = {
  __typename?: 'ContractsAndOpportunitiesTable';
  ContractNo?: Maybe<Scalars['String']>;
  AccountName?: Maybe<Scalars['String']>;
  ContractLotNo?: Maybe<Scalars['String']>;
  TotalRentalArea?: Maybe<Scalars['Float']>;
  TotalAmt?: Maybe<Scalars['Float']>;
  BookAmt?: Maybe<Scalars['Float']>;
  RecordStatus?: Maybe<Scalars['String']>;
  DefaultStartDate?: Maybe<Scalars['DateTime']>;
  DefaultExpiryDate?: Maybe<Scalars['DateTime']>;
  PropertyID?: Maybe<Scalars['Float']>;
  ProspectID?: Maybe<Scalars['Float']>;
  AccountID?: Maybe<Scalars['Float']>;
};

export type CorePermissionRoleData = {
  __typename?: 'CorePermissionRoleData';
  roleId: Scalars['Float'];
  roleName: Scalars['String'];
  roleDescription?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
  createUserId?: Maybe<Scalars['Float']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  recordStatus?: Maybe<Scalars['Float']>;
  warningTypeIds?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  dataScopeTypeId?: Maybe<Scalars['Float']>;
};

export type CorePermissionRoleOperationData = {
  __typename?: 'CorePermissionRoleOperationData';
  rowId: Scalars['Float'];
  roleId: Scalars['Float'];
  actionCode: Scalars['String'];
  applicationCode: Scalars['String'];
  moduleCode: Scalars['String'];
  menuCode: Scalars['String'];
  functionCode: Scalars['String'];
  actionGroupCode: Scalars['String'];
};

export type CorePermissionRoleUserData = {
  __typename?: 'CorePermissionRoleUserData';
  userId: Scalars['Float'];
  roleId: Scalars['Float'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  dataScopeTypeId?: Maybe<Scalars['Float']>;
  dataScopeTypeCode?: Maybe<Scalars['String']>;
  roleUser?: Maybe<CommonSetupUserData>;
  roleData?: Maybe<CorePermissionRoleData>;
  operationMenu?: Maybe<CommonSetupUserOperationMenuEntity>;
};

export type CoreTodoItemData = {
  __typename?: 'CoreTodoItemData';
  todoId: Scalars['String'];
  todoName?: Maybe<Scalars['String']>;
  todoCode?: Maybe<Scalars['String']>;
  application?: Maybe<Scalars['String']>;
  module?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  todoTypeId?: Maybe<Scalars['String']>;
  todoTypeCode?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['Float']>;
  taskId?: Maybe<Scalars['Float']>;
  jsonData?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
  createUser?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<Scalars['Float']>;
};

export type CoreTodoRecordData = {
  __typename?: 'CoreTodoRecordData';
  recordId: Scalars['String'];
  todoId?: Maybe<Scalars['String']>;
  todoName?: Maybe<Scalars['String']>;
  todoCode?: Maybe<Scalars['String']>;
  todoRecord?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  roleId?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['Float']>;
  createTime?: Maybe<Scalars['DateTime']>;
  readTime?: Maybe<Scalars['DateTime']>;
  recordStatus?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['String']>;
  handleUser?: Maybe<Scalars['Float']>;
  handleTime?: Maybe<Scalars['DateTime']>;
  createUser?: Maybe<Scalars['Float']>;
  recrodType?: Maybe<Scalars['Float']>;
  todoTypeCode?: Maybe<Scalars['String']>;
  fromUserId?: Maybe<Scalars['Float']>;
  lastSendMsgDate?: Maybe<Scalars['DateTime']>;
};

export type CoreWarningItemData = {
  __typename?: 'CoreWarningItemData';
  warningId: Scalars['String'];
  warningName?: Maybe<Scalars['String']>;
  warningCode?: Maybe<Scalars['String']>;
  application?: Maybe<Scalars['String']>;
  module?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  warningTypeId?: Maybe<Scalars['String']>;
  warningTypeCode?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
  createUser?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<Scalars['Float']>;
  operationStatus?: Maybe<Scalars['Float']>;
  roleId?: Maybe<Scalars['Float']>;
};

export type CoreWarningRecordData = {
  __typename?: 'CoreWarningRecordData';
  recordId: Scalars['String'];
  warningId?: Maybe<Scalars['String']>;
  warningName?: Maybe<Scalars['String']>;
  warningCode?: Maybe<Scalars['String']>;
  warningRecord?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  roleId?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['Float']>;
  createTime?: Maybe<Scalars['DateTime']>;
  readTime?: Maybe<Scalars['DateTime']>;
  recordStatus?: Maybe<Scalars['Float']>;
  application?: Maybe<Scalars['String']>;
};

export type CoreWorkflowFlowAppConfig = {
  __typename?: 'CoreWorkflowFlowAppConfig';
  flowAppConfigId: Scalars['Float'];
  templateId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  submitUserId?: Maybe<Scalars['Float']>;
  approveUserId?: Maybe<Scalars['Float']>;
  isEndFlow?: Maybe<Scalars['Boolean']>;
  flowAppType?: Maybe<Scalars['Float']>;
};

export type CoreWorkflowFlowRoleData = {
  __typename?: 'CoreWorkflowFlowRoleData';
  roleId: Scalars['String'];
  flowId?: Maybe<Scalars['String']>;
  refRoleTable?: Maybe<Scalars['String']>;
  refRoleId?: Maybe<Scalars['Float']>;
  roleRemark?: Maybe<Scalars['String']>;
};

export type CoreWorkflowInstanceData = {
  __typename?: 'CoreWorkflowInstanceData';
  instanceId: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['String']>;
  bizKey?: Maybe<Scalars['String']>;
  bizTable?: Maybe<Scalars['String']>;
  orgKey?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['Float']>;
  projectName?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  runStatus?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startUserId?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  resourcesId?: Maybe<Scalars['Float']>;
  sendInterval?: Maybe<Scalars['Float']>;
  sendMsgUserIds?: Maybe<Scalars['String']>;
  sendMsgEmail?: Maybe<Scalars['String']>;
};

export type CoreWorkflowInstanceFlowData = {
  __typename?: 'CoreWorkflowInstanceFlowData';
  instanceFlowId: Scalars['String'];
  instanceId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  activity?: Maybe<Scalars['String']>;
  activityName?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  parentFlowId?: Maybe<Scalars['String']>;
  containerFlowId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  prevFlowId?: Maybe<Scalars['String']>;
  isGroup?: Maybe<Scalars['Float']>;
  isNotice?: Maybe<Scalars['Boolean']>;
  isExpire?: Maybe<Scalars['Boolean']>;
  expireDay?: Maybe<Scalars['Float']>;
  runStatus?: Maybe<Scalars['String']>;
  submitDate?: Maybe<Scalars['DateTime']>;
  approveDate?: Maybe<Scalars['DateTime']>;
  noticeType?: Maybe<Scalars['Float']>;
  isSendMail?: Maybe<Scalars['Boolean']>;
  sendMailType?: Maybe<Scalars['Float']>;
  customMsgUser?: Maybe<Scalars['String']>;
  approveUserType?: Maybe<Scalars['Float']>;
  isBySuperiorApp?: Maybe<Scalars['Boolean']>;
  customAppUser?: Maybe<Scalars['String']>;
  flowAppConfigId?: Maybe<Scalars['Float']>;
  isRemind?: Maybe<Scalars['Boolean']>;
  remindDate?: Maybe<Scalars['Float']>;
  remindContent?: Maybe<Scalars['String']>;
  expiredHandleData?: Maybe<Scalars['Float']>;
  expiredHandleType?: Maybe<Scalars['Float']>;
  flowLevel?: Maybe<Scalars['Float']>;
  isSimulation?: Maybe<Scalars['Boolean']>;
  isAfterNotice?: Maybe<Scalars['Boolean']>;
  isAfterSendMail?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  isAfterSms?: Maybe<Scalars['Boolean']>;
  sendInterval?: Maybe<Scalars['Float']>;
  lastSendMsgDate?: Maybe<Scalars['DateTime']>;
};

export type CoreWorkflowInstanceRoleData = {
  __typename?: 'CoreWorkflowInstanceRoleData';
  instanceRoleId: Scalars['String'];
  instanceFlowId?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  refRoleTable?: Maybe<Scalars['String']>;
  refRoleId?: Maybe<Scalars['Float']>;
  refUserId?: Maybe<Scalars['Float']>;
  isApprove?: Maybe<Scalars['Float']>;
};

export type CoreWorkflowRunLogData = {
  __typename?: 'CoreWorkflowRunLogData';
  logId: Scalars['String'];
  instanceId?: Maybe<Scalars['String']>;
  instanceFlowId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['String']>;
  runStatus?: Maybe<Scalars['String']>;
  logType?: Maybe<Scalars['String']>;
  logTime?: Maybe<Scalars['DateTime']>;
  approveContents?: Maybe<Scalars['String']>;
  approveUserId?: Maybe<Scalars['Float']>;
  todoRecord?: Maybe<Scalars['String']>;
};

export type CoreWorkflowTemplateData = {
  __typename?: 'CoreWorkflowTemplateData';
  templateId: Scalars['String'];
  templateName?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
  createUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  resourcesId?: Maybe<Scalars['Float']>;
  sendInterval?: Maybe<Scalars['Float']>;
  sendMsgUserIds?: Maybe<Scalars['String']>;
  sendMsgEmail?: Maybe<Scalars['String']>;
};

export type CoreWorkflowTemplateFlowData = {
  __typename?: 'CoreWorkflowTemplateFlowData';
  flowId: Scalars['String'];
  activity?: Maybe<Scalars['String']>;
  activityName?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  parentFlowId?: Maybe<Scalars['String']>;
  containerFlowId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  targetTemplateId?: Maybe<Scalars['String']>;
  isGroup?: Maybe<Scalars['Float']>;
  isNotice?: Maybe<Scalars['Boolean']>;
  isExpire?: Maybe<Scalars['Boolean']>;
  expireDay?: Maybe<Scalars['Float']>;
  desciption?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
  createUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  noticeType?: Maybe<Scalars['Float']>;
  isSendMail?: Maybe<Scalars['Boolean']>;
  sendMailType?: Maybe<Scalars['Float']>;
  customMsgUser?: Maybe<Scalars['String']>;
  approveUserType?: Maybe<Scalars['Float']>;
  isBySuperiorApp?: Maybe<Scalars['Boolean']>;
  customAppUser?: Maybe<Scalars['String']>;
  flowAppConfigId?: Maybe<Scalars['Float']>;
  isRemind?: Maybe<Scalars['Boolean']>;
  remindDate?: Maybe<Scalars['Float']>;
  remindContent?: Maybe<Scalars['String']>;
  expiredHandleData?: Maybe<Scalars['Float']>;
  expiredHandleType?: Maybe<Scalars['Float']>;
  flowLevel?: Maybe<Scalars['Float']>;
  isAfterNotice?: Maybe<Scalars['Boolean']>;
  isAfterSendMail?: Maybe<Scalars['Boolean']>;
  isSms?: Maybe<Scalars['Boolean']>;
  isAfterSms?: Maybe<Scalars['Boolean']>;
  sendInterval?: Maybe<Scalars['Float']>;
};

export type CustomerView = {
  __typename?: 'CustomerView';
  addressString?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['Float']>;
};

export type DailySalesOutput = {
  __typename?: 'DailySalesOutput';
  rentalId?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  rejectCount?: Maybe<Scalars['Float']>;
  totalNettSalesAmt?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Float']>;
  posId?: Maybe<Scalars['Float']>;
  posName?: Maybe<Scalars['String']>;
  posNumber?: Maybe<Scalars['Float']>;
  recordStatus?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  uniqueFileName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  base64File?: Maybe<Scalars['String']>;
  attachmentId?: Maybe<Scalars['Float']>;
  refId?: Maybe<Scalars['Float']>;
  nettSalesSum?: Maybe<Scalars['Float']>;
  submittedCount?: Maybe<Scalars['Float']>;
  approvedCount?: Maybe<Scalars['Float']>;
  tenantWithGto?: Maybe<Scalars['Float']>;
  debtorId?: Maybe<Scalars['Float']>;
  submissionId?: Maybe<Scalars['Float']>;
  everyday?: Maybe<Scalars['DateTime']>;
  endOfMonth?: Maybe<Scalars['Float']>;
  totalVoucherCount?: Maybe<Scalars['Float']>;
  totalBillCount?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['Float']>;
  isHasRejected?: Maybe<Scalars['Boolean']>;
  turnoverSummaryId?: Maybe<Scalars['Float']>;
  startMonth?: Maybe<Scalars['Float']>;
};


export type DocCodeHistoryModel = {
  __typename?: 'DocCodeHistoryModel';
  docCodeHistoryId?: Maybe<Scalars['Float']>;
  docCodeId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
  docCodeRule?: Maybe<Scalars['String']>;
  serialNum?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  serialFilter?: Maybe<Scalars['String']>;
};

export type DocCodeTempModel = {
  __typename?: 'DocCodeTempModel';
  docCodeTempId?: Maybe<Scalars['Float']>;
  docCodeId?: Maybe<Scalars['String']>;
  serialNo?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['DateTime']>;
  serialFilter?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
  useNewCode?: Maybe<Scalars['String']>;
};

export type DocDbNameLikeness = {
  __typename?: 'DocDBNameLikeness';
  dbName?: Maybe<Scalars['String']>;
  likeness?: Maybe<Scalars['Float']>;
};

export type DocExtendOutput = {
  __typename?: 'DocExtendOutput';
  docExtendId?: Maybe<Scalars['Float']>;
  applicationCode?: Maybe<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  popupLstElementId?: Maybe<Scalars['Float']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Float']>;
};

export type EditOpportunityFormInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<Scalars['Float']>;
  brand?: Maybe<Scalars['Float']>;
  closingRate?: Maybe<Scalars['Float']>;
  askingRentalArea: Scalars['Float'];
  askingMonthlyRentalAmt: Scalars['Float'];
  urgency?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  pic?: Maybe<Scalars['Float']>;
  designation?: Maybe<Scalars['Float']>;
  mobileNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  preferredStart?: Maybe<Scalars['DateTime']>;
  preferredEnd?: Maybe<Scalars['DateTime']>;
  logo?: Maybe<Array<AttachmentsInputType>>;
  attachments?: Maybe<Array<AttachmentsInputType>>;
  attachmentsToDelete?: Maybe<Array<Scalars['String']>>;
};

export type ExpiringContractReport = {
  __typename?: 'ExpiringContractReport';
  CompanyID?: Maybe<Scalars['Float']>;
  CompanyName?: Maybe<Scalars['String']>;
  PropertyID?: Maybe<Scalars['Float']>;
  PropertyName?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Float']>;
  TenantName?: Maybe<Scalars['String']>;
  ContractID?: Maybe<Scalars['Float']>;
  BrandID?: Maybe<Scalars['Float']>;
  BrandName?: Maybe<Scalars['String']>;
  TotalArea?: Maybe<Scalars['Float']>;
  LeaseAmt?: Maybe<Scalars['Float']>;
  MonthlyNetRentalRate?: Maybe<Scalars['Float']>;
  ContractNo?: Maybe<Scalars['String']>;
  ContractLotNo?: Maybe<Scalars['String']>;
  ContractStatus?: Maybe<Scalars['String']>;
  ContractDate?: Maybe<Scalars['DateTime']>;
  ContractStartDate?: Maybe<Scalars['DateTime']>;
  ContractEndDate?: Maybe<Scalars['DateTime']>;
  TerminateDate?: Maybe<Scalars['DateTime']>;
  OUM?: Maybe<Scalars['String']>;
  Currency?: Maybe<Scalars['String']>;
  ContractRealEndDate?: Maybe<Scalars['DateTime']>;
};

export type FdbFile = {
  __typename?: 'FdbFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  folderId: Scalars['String'];
  recordStatus: Scalars['Boolean'];
  createDate?: Maybe<Scalars['DateTime']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  createUser?: Maybe<Scalars['String']>;
  modifyUser?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  fileContent?: Maybe<FdbFileContent>;
};

export type FdbFileContent = {
  __typename?: 'FdbFileContent';
  fileId: Scalars['String'];
  fileContent?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Float']>;
  base64File?: Maybe<Scalars['String']>;
};

export type FdbFileTask = {
  __typename?: 'FdbFileTask';
  id: Scalars['Float'];
  fileId: Scalars['String'];
  operate: Scalars['Float'];
};

export type FileOutput = {
  __typename?: 'FileOutput';
  fileId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  base64File?: Maybe<Scalars['String']>;
  fileContent?: Maybe<Scalars['String']>;
};

export type Files = {
  File?: Maybe<Scalars['Upload']>;
};

export type FilesOutput = {
  __typename?: 'FilesOutput';
  base64File?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
};

export type FloorVersionData = {
  __typename?: 'FloorVersionData';
  floorVersionId: Scalars['Float'];
  applicationModule: Scalars['String'];
  applicationId: Scalars['Float'];
  plazaId: Scalars['Float'];
  floorId: Scalars['Float'];
  effectDate: Scalars['DateTime'];
  floorMapping?: Maybe<Scalars['String']>;
  backGround?: Maybe<Scalars['String']>;
  unTypeID?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type FrwkMsgCenterMsgHdr = {
  __typename?: 'FrwkMsgCenterMsgHdr';
  msglId: Scalars['String'];
  templaeId?: Maybe<Scalars['String']>;
  msgClassId: Scalars['String'];
  senderId?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  msgSubject?: Maybe<Scalars['String']>;
  msgContent?: Maybe<Scalars['String']>;
  msgContentText?: Maybe<Scalars['String']>;
  msgPriorLevel?: Maybe<Scalars['String']>;
  msgImportDegree?: Maybe<Scalars['String']>;
  requestSendTime?: Maybe<Scalars['DateTime']>;
  factSendTime?: Maybe<Scalars['DateTime']>;
  receiveDate?: Maybe<Scalars['DateTime']>;
  messageSort?: Maybe<Scalars['String']>;
  errorInfo?: Maybe<Scalars['String']>;
  busnessTable?: Maybe<Scalars['String']>;
  busnessTableRecordId?: Maybe<Scalars['String']>;
  isHtmlFormat?: Maybe<Scalars['Float']>;
  prsType?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  emailWayFlag?: Maybe<Scalars['Float']>;
  smsWayFlag?: Maybe<Scalars['Float']>;
  createMan?: Maybe<Scalars['String']>;
  createDept?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
};

export type FrwkMsgCenterMsgReceiveDtl = {
  __typename?: 'FrwkMsgCenterMsgReceiveDtl';
  receiveId: Scalars['String'];
  msgId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  readStatus?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  createMan?: Maybe<Scalars['String']>;
  createDept?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['DateTime']>;
  receiverType?: Maybe<Scalars['String']>;
};

export type GeneralColumns = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
};

export type LeaseArAllocationData = {
  __typename?: 'LeaseArAllocationData';
  allocId: Scalars['Float'];
  billId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  receiptId?: Maybe<Scalars['Float']>;
  allocAmt: Scalars['Float'];
  allocDate: Scalars['DateTime'];
  refundId?: Maybe<Scalars['Float']>;
  currencyId: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  baseAmt: Scalars['Float'];
  adjustmentId?: Maybe<Scalars['Float']>;
  isBounce?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus: Scalars['String'];
  allocById?: Maybe<Scalars['Float']>;
  allocType?: Maybe<Scalars['String']>;
  bill: LeaseArTrxData;
  adjustment?: Maybe<LeaseArTrxData>;
  receipt: LeaseArReceiptData;
};

export type LeaseArBillGroupData = {
  __typename?: 'LeaseArBillGroupData';
  billGroupId: Scalars['Float'];
  companyId: Scalars['Float'];
  propertyId: Scalars['Float'];
  accountId?: Maybe<Scalars['Float']>;
  debtorId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Float']>;
  bookId?: Maybe<Scalars['Float']>;
  documentTypeId?: Maybe<Scalars['Float']>;
  documentNo: Scalars['String'];
  documentDate: Scalars['DateTime'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  billCount: Scalars['Float'];
  currencyId?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  chargeAmt: Scalars['Float'];
  taxAmt?: Maybe<Scalars['Float']>;
  documentAmt: Scalars['Float'];
  documentDesc?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  documentNoType?: Maybe<Scalars['String']>;
  voidById?: Maybe<Scalars['Float']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidRemark?: Maybe<Scalars['String']>;
};

export type LeaseArBillItemData = {
  __typename?: 'LeaseArBillItemData';
  billItemId: Scalars['Float'];
  lineSeq?: Maybe<Scalars['Float']>;
  itemName: Scalars['String'];
  itemCode?: Maybe<Scalars['String']>;
  billClassId?: Maybe<Scalars['Float']>;
  billGroupId?: Maybe<Scalars['Float']>;
  allocGroup?: Maybe<Scalars['String']>;
  interestRateType?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  isExcludeHoliday?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['Float']>;
  billingDay: Scalars['Float'];
  roundType?: Maybe<Scalars['String']>;
  rounding?: Maybe<Scalars['String']>;
  isRebate?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  reportHeaderId?: Maybe<Scalars['Float']>;
  purposeTypeId?: Maybe<Scalars['Float']>;
  revenueCodeId?: Maybe<Scalars['Float']>;
  isContra?: Maybe<Scalars['String']>;
  isAmortization?: Maybe<Scalars['String']>;
  interestTypeId?: Maybe<Scalars['Float']>;
  gracePeriod: Scalars['Float'];
  isExport?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  billCode?: Maybe<Scalars['String']>;
  interestSpecId?: Maybe<Scalars['Float']>;
  orderSeq?: Maybe<Scalars['Float']>;
  billItemSeq?: Maybe<Scalars['Float']>;
  glAccountCode?: Maybe<Scalars['String']>;
  documentTypeId?: Maybe<Scalars['Float']>;
  LeaseContDepositData: Array<LeaseContDepositData>;
  taxData: CommonSetupTaxData;
  charge: Array<LeaseContContChargesData>;
  billItemSpec?: Maybe<Array<LeaseArBillItemSpecData>>;
};

export type LeaseArBillItemSpecData = {
  __typename?: 'LeaseArBillItemSpecData';
  billItemDetailId: Scalars['Float'];
  billId?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  billItemId: Scalars['Float'];
  propertyId: Scalars['Float'];
  billItemType?: Maybe<Scalars['String']>;
  minimumCharges?: Maybe<Scalars['Float']>;
  maximumCharges?: Maybe<Scalars['Float']>;
  defaultFrequency?: Maybe<Scalars['Float']>;
  defaultFrequencyMode?: Maybe<Scalars['String']>;
  calculateMethod?: Maybe<Scalars['String']>;
  partialMethod?: Maybe<Scalars['String']>;
  chargeTo?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Float']>;
  priceMode?: Maybe<Scalars['String']>;
  readItemId?: Maybe<Scalars['Float']>;
  taxId?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  isFirstDayBilling?: Maybe<Scalars['String']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  decimalPosition?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  parentBillItemDetailId?: Maybe<Scalars['Float']>;
  conditionValue?: Maybe<Scalars['String']>;
  billingDay: Scalars['Float'];
  creditTerms?: Maybe<Scalars['Float']>;
  perStep?: Maybe<Scalars['String']>;
  perMonth?: Maybe<Scalars['String']>;
  meter: Array<LeaseMeterMeterMasterData>;
  billItem: LeaseArBillItemData;
};

export type LeaseArBillScheduleData = {
  __typename?: 'LeaseArBillScheduleData';
  billScheduleId: Scalars['Float'];
  debtorBillItemId?: Maybe<Scalars['Float']>;
  billItemId: Scalars['Float'];
  billId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  unitDesc?: Maybe<Scalars['String']>;
  propertyId: Scalars['Float'];
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  scheduleDate?: Maybe<Scalars['DateTime']>;
  currencyId: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  trxStartDate?: Maybe<Scalars['DateTime']>;
  trxEndDate?: Maybe<Scalars['DateTime']>;
  documentAmt?: Maybe<Scalars['Float']>;
  isPost?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  sourceUnitPrice?: Maybe<Scalars['Float']>;
  sourceQty?: Maybe<Scalars['Float']>;
  formula?: Maybe<Scalars['String']>;
  discountAmt?: Maybe<Scalars['Float']>;
  postType?: Maybe<Scalars['String']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  taxId?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  creditTerms?: Maybe<Scalars['Float']>;
  isRentFree?: Maybe<Scalars['String']>;
  rentalId?: Maybe<Scalars['Float']>;
  isAmorSchedule?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Float']>;
  isFromContract?: Maybe<Scalars['String']>;
  rentFreeBillScheduleId?: Maybe<Scalars['Float']>;
  makeupAmt?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Float']>;
  isFirstPayment?: Maybe<Scalars['String']>;
  debtorId?: Maybe<Scalars['Float']>;
  meterCharge: LeaseMeterMeterChargesData;
  leaseArTrxData: LeaseArTrxData;
  billItemData: LeaseArBillItemData;
  tax: CommonSetupTaxData;
};

export type LeaseArDebtorBankData = {
  __typename?: 'LeaseArDebtorBankData';
  debtorBankId: Scalars['Float'];
  bankId?: Maybe<Scalars['Float']>;
  accountNo?: Maybe<Scalars['String']>;
  accountOwner?: Maybe<Scalars['String']>;
  propertyId: Scalars['Float'];
  rentalId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus: Scalars['String'];
  bankDetail: CommonSetupBankData;
};

export type LeaseArDebtorData = {
  __typename?: 'LeaseArDebtorData';
  debtorId: Scalars['Float'];
  propertyId: Scalars['Float'];
  accountId: Scalars['Float'];
  debtorNo: Scalars['String'];
  debtorType: Scalars['String'];
  lastInterestDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  businessLotNo?: Maybe<Scalars['String']>;
  unitLotNo?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  lastClosingDate?: Maybe<Scalars['DateTime']>;
  account: CommonSetupAccountData;
  rental: Array<LeaseContRentalContractData>;
  leaseArDebtorItemData: Array<LeaseArDebtorItemData>;
  property?: Maybe<LeaseProSetPropertyData>;
  posSubmission: Array<PosSubmissionEntity>;
  turnover: Array<TurnoverSummaryEntity>;
  activeRentalContract?: Maybe<LeaseContRentalContractData>;
  MeterTypeListing?: Maybe<Array<MeterListing>>;
  TodaySubmittedSales?: Maybe<DailySalesOutput>;
  totalOutstandingOfMeter: Scalars['Float'];
  DailySalesSummary?: Maybe<DailySalesOutput>;
  lastestRentalContract?: Maybe<LeaseContRentalContractData>;
};


export type LeaseArDebtorDataPosSubmissionArgs = {
  IsLimitDays?: Maybe<Scalars['Boolean']>;
  SubmissionId?: Maybe<Scalars['Float']>;
  Status?: Maybe<Array<Scalars['String']>>;
  Date?: Maybe<Scalars['DateTime']>;
};

export type LeaseArDebtorItemData = {
  __typename?: 'LeaseArDebtorItemData';
  debtorItemId: Scalars['Float'];
  debtorId: Scalars['Float'];
  refTable: Scalars['String'];
  refRecordId: Scalars['Float'];
  unitLotNo: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  businessLotNo?: Maybe<Scalars['String']>;
  debtor: LeaseArDebtorData;
  rental: LeaseContRentalContractData;
};

export type LeaseArDiscountData = {
  __typename?: 'LeaseArDiscountData';
  discountId: Scalars['Float'];
  rtContractId: Scalars['Float'];
  unitId?: Maybe<Scalars['Float']>;
  unitDesc?: Maybe<Scalars['String']>;
  discountAmt?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  discountMode?: Maybe<Scalars['String']>;
  propertyId: Scalars['Float'];
  billItemId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  leaseArDiscountItemData?: Maybe<Array<LeaseArDiscountItemData>>;
  rental: LeaseContRentalContractData;
  billItem: LeaseArBillItemData;
  property: LeaseProSetPropertyData;
};

export type LeaseArDiscountItemData = {
  __typename?: 'LeaseArDiscountItemData';
  discountItemId: Scalars['Float'];
  discountId: Scalars['Float'];
  billScheduleId: Scalars['Float'];
  currentDisAmt: Scalars['Float'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  discount: LeaseArDiscountData;
};

export type LeaseArJournalData = {
  __typename?: 'LeaseArJournalData';
  apJournalId: Scalars['Float'];
  companyId: Scalars['Float'];
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  payableType: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  currencyId: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  documentAmt: Scalars['Float'];
  baseAmt: Scalars['Float'];
  balanceAmt: Scalars['Float'];
  taxId?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  requestUserId?: Maybe<Scalars['Float']>;
  voidById?: Maybe<Scalars['Float']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidRemark?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  accountId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  bankAccountId?: Maybe<Scalars['Float']>;
  debtorBankAccountId?: Maybe<Scalars['Float']>;
  bookId?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Float']>;
  paidById?: Maybe<Scalars['Float']>;
  paidDate?: Maybe<Scalars['DateTime']>;
  paidRemark?: Maybe<Scalars['String']>;
  documentTypeId?: Maybe<Scalars['Float']>;
  debtorId?: Maybe<Scalars['Float']>;
  tenant: CommonSetupAccountData;
  requestBy: CommonSetupUserData;
  bank: CommonSetupBankAccountData;
  tenantBank?: Maybe<LeaseArDebtorBankData>;
  rental: LeaseContRentalContractData;
  refundReason: PopupLstElementEntity;
};

export type LeaseArPricePolicyItemData = {
  __typename?: 'LeaseArPricePolicyItemData';
  pricePolicyDetailId: Scalars['Float'];
  billItemDetailId?: Maybe<Scalars['Float']>;
  readFrom?: Maybe<Scalars['Float']>;
  readTo?: Maybe<Scalars['Float']>;
  isFormula?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  formulaValue?: Maybe<Scalars['String']>;
  formulaTable?: Maybe<Scalars['String']>;
  conditionDesc?: Maybe<Scalars['String']>;
  conditionValue?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  parentPricePolicyId?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  pricePolicies?: Maybe<Array<LeaseArPricePolicyItemData>>;
  parentPricePolicy?: Maybe<LeaseArPricePolicyItemData>;
};

export type LeaseArReceiptData = {
  __typename?: 'LeaseArReceiptData';
  receiptId: Scalars['Float'];
  companyId?: Maybe<Scalars['Float']>;
  docNo: Scalars['String'];
  paidBy?: Maybe<Scalars['String']>;
  referenceNo?: Maybe<Scalars['String']>;
  allocSpecId?: Maybe<Scalars['Float']>;
  receiptType: Scalars['String'];
  payMethod?: Maybe<Scalars['Float']>;
  documentDate: Scalars['DateTime'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  currencyId: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  documentAmt?: Maybe<Scalars['Float']>;
  baseAmt?: Maybe<Scalars['Float']>;
  allocBalance?: Maybe<Scalars['Float']>;
  bankCharge?: Maybe<Scalars['Float']>;
  taxInvoiceNo?: Maybe<Scalars['String']>;
  taxInvoiceDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserId?: Maybe<Scalars['Float']>;
  voidRemark?: Maybe<Scalars['String']>;
  chequeIssueDate?: Maybe<Scalars['DateTime']>;
  chequeExpiryDate?: Maybe<Scalars['DateTime']>;
  actualAmt?: Maybe<Scalars['Float']>;
  actualBaseAmt?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  accountId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  receivableAmt?: Maybe<Scalars['Float']>;
  fieldBoolean1?: Maybe<Scalars['String']>;
  bankAccountId?: Maybe<Scalars['Float']>;
  bookId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Float']>;
  verifyById?: Maybe<Scalars['Float']>;
  verifyDate?: Maybe<Scalars['DateTime']>;
  verifyRemark?: Maybe<Scalars['String']>;
  debtorId?: Maybe<Scalars['Float']>;
  receiptById?: Maybe<Scalars['Float']>;
  allocation: Array<LeaseArAllocationData>;
};

export type LeaseArSpecData = {
  __typename?: 'LeaseArSpecData';
  specId: Scalars['Float'];
  age1?: Maybe<Scalars['Float']>;
  age2?: Maybe<Scalars['Float']>;
  age3?: Maybe<Scalars['Float']>;
  age4?: Maybe<Scalars['Float']>;
  age5?: Maybe<Scalars['Float']>;
  age6?: Maybe<Scalars['Float']>;
  reminder1?: Maybe<Scalars['Float']>;
  reminder2?: Maybe<Scalars['Float']>;
  reminder3?: Maybe<Scalars['Float']>;
  reminder4?: Maybe<Scalars['Float']>;
  reminderFreqType?: Maybe<Scalars['String']>;
  gracePeroid?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  minimumCharge?: Maybe<Scalars['Float']>;
  isExcludeHoliday?: Maybe<Scalars['String']>;
  isExcludePaymentday?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['Float']>;
  parameterType?: Maybe<Scalars['String']>;
  applicationId?: Maybe<Scalars['Float']>;
  loanCreditTerms?: Maybe<Scalars['Float']>;
  minReminderAmt?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  isRepeatPrint?: Maybe<Scalars['String']>;
  isChangeDocAmount?: Maybe<Scalars['String']>;
  isTax?: Maybe<Scalars['String']>;
  isManualDoc?: Maybe<Scalars['String']>;
  isManualDocNo?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  interestStandAmt?: Maybe<Scalars['Float']>;
  standCalcProjectIDs?: Maybe<Scalars['String']>;
  isCalcFloatInterest?: Maybe<Scalars['String']>;
  isInterestChargeable?: Maybe<Scalars['String']>;
  isSendReminder?: Maybe<Scalars['String']>;
  arInterestSetId?: Maybe<Scalars['Float']>;
  specName?: Maybe<Scalars['String']>;
  specCode?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['String']>;
  reminder5?: Maybe<Scalars['Float']>;
  reminder6?: Maybe<Scalars['Float']>;
  reminder7?: Maybe<Scalars['Float']>;
  reminder8?: Maybe<Scalars['Float']>;
  properties?: Maybe<Array<LeaseProSetPropertyData>>;
};

export type LeaseArTrxData = {
  __typename?: 'LeaseArTrxData';
  billId: Scalars['Float'];
  companyId: Scalars['Float'];
  unitId?: Maybe<Scalars['Float']>;
  unitDesc?: Maybe<Scalars['String']>;
  billItemId: Scalars['Float'];
  documentNo?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  documentDesc?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  currencyId: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  documentAmt: Scalars['Float'];
  balanceAmt: Scalars['Float'];
  chargePercent?: Maybe<Scalars['Float']>;
  isDispute?: Maybe<Scalars['String']>;
  voidRemark?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidById?: Maybe<Scalars['Float']>;
  creditTerms?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  chargeAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  isRebate?: Maybe<Scalars['String']>;
  propertyCompanyId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  documentTypeId?: Maybe<Scalars['Float']>;
  isFromContract?: Maybe<Scalars['String']>;
  trxStartDate?: Maybe<Scalars['DateTime']>;
  trxEndDate?: Maybe<Scalars['DateTime']>;
  bookId?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Float']>;
  billScheduleId?: Maybe<Scalars['Float']>;
  debtorId?: Maybe<Scalars['Float']>;
  billGroupId?: Maybe<Scalars['Float']>;
  chargeId?: Maybe<Scalars['Float']>;
  documentNoType?: Maybe<Scalars['String']>;
  leaseArAllocationData: Array<LeaseArAllocationData>;
  leaseArBillScheduleData: LeaseArBillScheduleData;
  adjustment?: Maybe<LeaseArAllocationData>;
  billItemData: LeaseArBillItemData;
  account: CommonSetupAccountData;
  reason: PopupLstElementEntity;
};

export type LeaseBrandView = {
  __typename?: 'LeaseBrandView';
  brandId?: Maybe<Scalars['Float']>;
  brandName?: Maybe<Scalars['String']>;
  qualification?: Maybe<Scalars['String']>;
  levelId?: Maybe<Scalars['Float']>;
  levelCode?: Maybe<Scalars['String']>;
  brandLevel?: Maybe<Scalars['String']>;
  industryId?: Maybe<Scalars['Float']>;
  industryCode?: Maybe<Scalars['String']>;
  brandIndustry?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['Float']>;
  typeCode?: Maybe<Scalars['String']>;
  libraryType?: Maybe<Scalars['String']>;
  popularityId?: Maybe<Scalars['Float']>;
  popularityCode?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['String']>;
  developId?: Maybe<Scalars['Float']>;
  developCode?: Maybe<Scalars['String']>;
  developModel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  recordStatus?: Maybe<Scalars['String']>;
};

export type LeaseContContChargesData = {
  __typename?: 'LeaseContContChargesData';
  contractChargeId: Scalars['Float'];
  rtContractId: Scalars['Float'];
  billItemId: Scalars['Float'];
  billItemDetailId?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Float']>;
  billingFrequency?: Maybe<Scalars['String']>;
  frequencyMode?: Maybe<Scalars['String']>;
  maxScheduleNum?: Maybe<Scalars['Float']>;
  isFirstDayBilling?: Maybe<Scalars['String']>;
  extraGracePeroid?: Maybe<Scalars['Float']>;
  extraCreditTerms?: Maybe<Scalars['Float']>;
  addressId?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  discountAmt?: Maybe<Scalars['Float']>;
  calculateMethod?: Maybe<Scalars['String']>;
  priceMode?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  interestRateType?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<Scalars['Float']>;
  originalAmount?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  increaseAmount?: Maybe<Scalars['Float']>;
  increasePeriod?: Maybe<Scalars['Float']>;
  increaseMethod?: Maybe<Scalars['String']>;
  increaseFrequencyMode?: Maybe<Scalars['String']>;
  increaseRate?: Maybe<Scalars['Float']>;
  isRentFree?: Maybe<Scalars['String']>;
  isReviewEdit?: Maybe<Scalars['String']>;
  iscpi?: Maybe<Scalars['String']>;
  interestTypeId?: Maybe<Scalars['Float']>;
  rentalUnitId?: Maybe<Scalars['Float']>;
  method?: Maybe<Scalars['String']>;
  pricingpolicyChargesId?: Maybe<Scalars['Float']>;
  rentFreeStartDate?: Maybe<Scalars['DateTime']>;
  rentFreeEndDate?: Maybe<Scalars['DateTime']>;
  increaseFirstYear?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['String']>;
  differenceMethod?: Maybe<Scalars['String']>;
  differenceFrequency?: Maybe<Scalars['String']>;
  differencePayDay?: Maybe<Scalars['Float']>;
  rentStandardType?: Maybe<Scalars['String']>;
  lastBillingDate?: Maybe<Scalars['DateTime']>;
  minChargeAmt?: Maybe<Scalars['Float']>;
  maxChargeAmt?: Maybe<Scalars['Float']>;
  dailyChargeAmt?: Maybe<Scalars['Float']>;
  dailyChargeRate?: Maybe<Scalars['Float']>;
  dailyNetChargeAmt?: Maybe<Scalars['Float']>;
  dailyNetChargeRate?: Maybe<Scalars['Float']>;
  monthlyChargeAmt?: Maybe<Scalars['Float']>;
  monthlyChargeRate?: Maybe<Scalars['Float']>;
  monthlyNetChargeAmt?: Maybe<Scalars['Float']>;
  monthlyNetChargeRate?: Maybe<Scalars['Float']>;
  totalChargeAmt?: Maybe<Scalars['Float']>;
  totalFreeAmt?: Maybe<Scalars['Float']>;
  totalNetChargeAmt?: Maybe<Scalars['Float']>;
  yearlyChargeAmt?: Maybe<Scalars['Float']>;
  yearlyChargeRate?: Maybe<Scalars['Float']>;
  yearlyNetChargeAmt?: Maybe<Scalars['Float']>;
  yearlyNetChargeRate?: Maybe<Scalars['Float']>;
  billingDay?: Maybe<Scalars['Float']>;
  billingDay2?: Maybe<Scalars['Float']>;
  refRecordId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refBillItemId?: Maybe<Scalars['Float']>;
  rentalContract?: Maybe<LeaseContRentalContractData>;
  billItem?: Maybe<LeaseArBillItemData>;
};

export type LeaseContContRentFreeData = {
  __typename?: 'LeaseContContRentFreeData';
  rentFreeId: Scalars['Float'];
  rtContractId: Scalars['Float'];
  rentFreeStartDate: Scalars['DateTime'];
  rentFreeEndDate: Scalars['DateTime'];
  remarks?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  contractChargeId: Scalars['Float'];
};

export type LeaseContDepositData = {
  __typename?: 'LeaseContDepositData';
  depositId: Scalars['Float'];
  rentalId?: Maybe<Scalars['Float']>;
  billId?: Maybe<Scalars['Float']>;
  billItemId: Scalars['Float'];
  documentNo?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentDesc?: Maybe<Scalars['String']>;
  documentAmt: Scalars['Float'];
  isHistory?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  rental: LeaseContRentalContractData;
  billItem: LeaseArBillItemData;
};

export type LeaseContRentReviewData = {
  __typename?: 'LeaseContRentReviewData';
  rentReviewId: Scalars['Float'];
  rentalId: Scalars['Float'];
  reviewdate: Scalars['DateTime'];
  remarks?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  assignedId?: Maybe<Scalars['Float']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  nextDiscussDate?: Maybe<Scalars['DateTime']>;
  rental?: Maybe<LeaseContRentalContractData>;
  assign?: Maybe<LeaseMercAgentData>;
};

export type LeaseContRentalContractData = {
  __typename?: 'LeaseContRentalContractData';
  rentalId: Scalars['Float'];
  companyId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  propertyId: Scalars['Float'];
  prospectId?: Maybe<Scalars['Float']>;
  agentId?: Maybe<Scalars['Float']>;
  commissionId?: Maybe<Scalars['Float']>;
  rentalNo?: Maybe<Scalars['String']>;
  rentalDate?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  rentalTypeId?: Maybe<Scalars['Float']>;
  jointName?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  reserveSeq?: Maybe<Scalars['Float']>;
  reserveDate?: Maybe<Scalars['DateTime']>;
  reserveDesc?: Maybe<Scalars['String']>;
  reserveStartDate?: Maybe<Scalars['DateTime']>;
  reserveExpiryDate?: Maybe<Scalars['DateTime']>;
  contractLotNo?: Maybe<Scalars['String']>;
  contractDate?: Maybe<Scalars['DateTime']>;
  contractNo?: Maybe<Scalars['String']>;
  contractBy?: Maybe<Scalars['String']>;
  stampingDate?: Maybe<Scalars['DateTime']>;
  lawyerRefNo?: Maybe<Scalars['String']>;
  defaultStartDate?: Maybe<Scalars['DateTime']>;
  defaultExpiryDate?: Maybe<Scalars['DateTime']>;
  currencyId?: Maybe<Scalars['Float']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidById?: Maybe<Scalars['Float']>;
  voidRemak?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['String']>;
  billEndDate?: Maybe<Scalars['DateTime']>;
  totalAmt?: Maybe<Scalars['Float']>;
  topParentId?: Maybe<Scalars['Float']>;
  otherClause?: Maybe<Scalars['String']>;
  leaseAmt?: Maybe<Scalars['Float']>;
  mailingAddress?: Maybe<Scalars['String']>;
  terminateDate?: Maybe<Scalars['DateTime']>;
  terminateById?: Maybe<Scalars['Float']>;
  terminateReasonId?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  validPrice?: Maybe<Scalars['Float']>;
  paymentAmt?: Maybe<Scalars['Float']>;
  paymentAmtDate?: Maybe<Scalars['DateTime']>;
  totalRentalArea?: Maybe<Scalars['Float']>;
  fitmentStartDate?: Maybe<Scalars['DateTime']>;
  fitmentEndDate?: Maybe<Scalars['DateTime']>;
  terminationChargeMode?: Maybe<Scalars['String']>;
  rentFreePeriods?: Maybe<Scalars['String']>;
  rentFreeStartDate1?: Maybe<Scalars['DateTime']>;
  rentFreeEndDate1?: Maybe<Scalars['DateTime']>;
  rentFreeStartDate2?: Maybe<Scalars['DateTime']>;
  rentFreeEndDate2?: Maybe<Scalars['DateTime']>;
  paymentPlan?: Maybe<Scalars['String']>;
  isExplicit?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  tenantTypeId?: Maybe<Scalars['Float']>;
  managementExpensesAmt?: Maybe<Scalars['Float']>;
  salesManId?: Maybe<Scalars['Float']>;
  lawyerName?: Maybe<Scalars['String']>;
  isRenewal?: Maybe<Scalars['String']>;
  rentalCapAmt?: Maybe<Scalars['Float']>;
  rentReviewDate?: Maybe<Scalars['DateTime']>;
  nextRentReviewDate?: Maybe<Scalars['DateTime']>;
  rentReviewRemark?: Maybe<Scalars['String']>;
  toDoId?: Maybe<Scalars['Float']>;
  isInsurance?: Maybe<Scalars['String']>;
  creditTerms?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  arInterestSetId?: Maybe<Scalars['Float']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  lastInterestDate?: Maybe<Scalars['DateTime']>;
  brandId?: Maybe<Scalars['Float']>;
  monthRentalFeeAmt?: Maybe<Scalars['Float']>;
  yearRentalFeeAmt?: Maybe<Scalars['Float']>;
  leaseDocumentsId?: Maybe<Scalars['Float']>;
  generateBillTypeCode?: Maybe<Scalars['String']>;
  monthlyDaysCode?: Maybe<Scalars['String']>;
  isGenerateFreeBill?: Maybe<Scalars['String']>;
  rentalType?: Maybe<Scalars['String']>;
  turnoverTypeId?: Maybe<Scalars['Float']>;
  isAdvanceBalance?: Maybe<Scalars['String']>;
  liquidationPeriod?: Maybe<Scalars['String']>;
  balancePeriod?: Maybe<Scalars['String']>;
  balancePeriodNum?: Maybe<Scalars['Float']>;
  baseLiquidation?: Maybe<Scalars['Float']>;
  baseBalance?: Maybe<Scalars['Float']>;
  membershipRate?: Maybe<Scalars['Float']>;
  billAddressId?: Maybe<Scalars['Float']>;
  isFirstDayBilling?: Maybe<Scalars['String']>;
  rentalGuid?: Maybe<Scalars['String']>;
  debtorNo?: Maybe<Scalars['String']>;
  downLoadMark?: Maybe<Scalars['Float']>;
  validDate?: Maybe<Scalars['DateTime']>;
  leaseClauseId?: Maybe<Scalars['Float']>;
  rentalStatus?: Maybe<Scalars['String']>;
  billAddressName?: Maybe<Scalars['String']>;
  isSendStatement?: Maybe<Scalars['String']>;
  collectMoneyMode?: Maybe<Scalars['String']>;
  rowId?: Maybe<Scalars['Float']>;
  receiptCompanyId?: Maybe<Scalars['Float']>;
  settlementWfStatus?: Maybe<Scalars['String']>;
  ifcaPos?: Maybe<Scalars['String']>;
  collectionBy?: Maybe<Scalars['String']>;
  posType?: Maybe<Scalars['String']>;
  settlementRemark?: Maybe<Scalars['String']>;
  deductionRatio?: Maybe<Scalars['Float']>;
  latestBalanceAmt?: Maybe<Scalars['Float']>;
  lastSettlementDate?: Maybe<Scalars['DateTime']>;
  lastClearingDate?: Maybe<Scalars['DateTime']>;
  nextSettlementDate?: Maybe<Scalars['DateTime']>;
  nextClearingDate?: Maybe<Scalars['DateTime']>;
  noticeContractExpireDays?: Maybe<Scalars['Float']>;
  dailyNetRentalAmt?: Maybe<Scalars['Float']>;
  dailyNetRentalRate?: Maybe<Scalars['Float']>;
  dailyRentalAmt?: Maybe<Scalars['Float']>;
  dailyRentalRate?: Maybe<Scalars['Float']>;
  industryId?: Maybe<Scalars['Float']>;
  monthlyNetRentalAmt?: Maybe<Scalars['Float']>;
  monthlyNetRentalRate?: Maybe<Scalars['Float']>;
  monthlyRentalAmt?: Maybe<Scalars['Float']>;
  monthlyRentalRate?: Maybe<Scalars['Float']>;
  shopName?: Maybe<Scalars['String']>;
  yearlyNetRentalAmt?: Maybe<Scalars['Float']>;
  yearlyNetRentalRate?: Maybe<Scalars['Float']>;
  yearlyRentalAmt?: Maybe<Scalars['Float']>;
  yearlyRentalRate?: Maybe<Scalars['Float']>;
  debtorId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  debtor: LeaseArDebtorData;
  leaseContRentalUnitData: Array<LeaseContRentalUnitData>;
  leaseContDepositData: Array<LeaseContDepositData>;
  account: CommonSetupAccountData;
  posSubmission?: Maybe<Array<PosSubmissionEntity>>;
  meterCharges?: Maybe<Array<LeaseMeterMeterChargesData>>;
  duePeriod?: Maybe<Scalars['String']>;
  agent?: Maybe<LeaseMercAgentData>;
  contact?: Maybe<CommonSetupContactData>;
  brand?: Maybe<LeaseMercBrandData>;
  charge?: Maybe<Array<LeaseContContChargesData>>;
  creditCard?: Maybe<Array<LeaseJmCreditRelatData>>;
  terminatedBy?: Maybe<CommonSetupUserData>;
  terminatedReason?: Maybe<PopupLstElementEntity>;
  moveUnit: LeaseIoMoveUnit;
  turnover?: Maybe<Array<TurnoverSummaryEntity>>;
  prospect: Array<LeaseMercProspectData>;
  property?: Maybe<LeaseProSetPropertyData>;
  CategoryNameList?: Maybe<Array<DailySalesOutput>>;
  PosNameList?: Maybe<Array<DailySalesOutput>>;
  unit?: Maybe<Array<LeaseProSetUnitData>>;
  rentalContractAttachment?: Maybe<Array<DocExtendOutput>>;
  IsHasGTO?: Maybe<Scalars['Boolean']>;
  billSchedule?: Maybe<Array<BillSchedule>>;
  rentFree?: Maybe<Array<RentFreeOutput>>;
  turnOver?: Maybe<Array<TurnOverOutput>>;
  contractStatus?: Maybe<ContractStatusOutput>;
};

export type LeaseContRentalUnitData = {
  __typename?: 'LeaseContRentalUnitData';
  rentalUnitId: Scalars['Float'];
  rentalId: Scalars['Float'];
  refTable: Scalars['String'];
  refRecordId: Scalars['Float'];
  unitArea?: Maybe<Scalars['Float']>;
  rentArea?: Maybe<Scalars['Float']>;
  feeArea?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  moveInDate?: Maybe<Scalars['DateTime']>;
  moveOutDate?: Maybe<Scalars['DateTime']>;
  conditionValue?: Maybe<Scalars['String']>;
  rentalBillItemDetailId?: Maybe<Scalars['Float']>;
  revenueBillItemDetailId?: Maybe<Scalars['Float']>;
  actualMoveInDate?: Maybe<Scalars['DateTime']>;
  actualMoveOutDate?: Maybe<Scalars['DateTime']>;
  moveInRemark?: Maybe<Scalars['String']>;
  moveOutRemark?: Maybe<Scalars['String']>;
  moveOutUserId?: Maybe<Scalars['Float']>;
  moveInUserId?: Maybe<Scalars['Float']>;
  openDate?: Maybe<Scalars['DateTime']>;
  openUserId?: Maybe<Scalars['Float']>;
  openRemark?: Maybe<Scalars['String']>;
  actualOpenDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  brandId?: Maybe<Scalars['Float']>;
  brandRate?: Maybe<Scalars['String']>;
  leaseClauseId?: Maybe<Scalars['Float']>;
  revenueQuotaDetailId?: Maybe<Scalars['Float']>;
  rental: LeaseContRentalContractData;
  unit: LeaseProSetUnitData;
};

export type LeaseCtSettlement = {
  __typename?: 'LeaseCtSettlement';
  settlementId: Scalars['Float'];
  rentalId?: Maybe<Scalars['Float']>;
  totalReceiptAmt?: Maybe<Scalars['Float']>;
  totalAdvanceAmt?: Maybe<Scalars['Float']>;
  totalDepositAmt?: Maybe<Scalars['Float']>;
  totalDocumentAmt?: Maybe<Scalars['Float']>;
  totalDeducteAmt?: Maybe<Scalars['Float']>;
  totalInvoiceAmt?: Maybe<Scalars['Float']>;
  totalArrearsAmt?: Maybe<Scalars['Float']>;
  totalPenaltyAmt?: Maybe<Scalars['Float']>;
  rebateBalanceAmt?: Maybe<Scalars['Float']>;
  confirmableReceiptAmt?: Maybe<Scalars['Float']>;
  totalRefundableAmt?: Maybe<Scalars['Float']>;
  pendingRefundAmt?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  currentInvoiceAmt?: Maybe<Scalars['Float']>;
  currentReceiptAmt?: Maybe<Scalars['Float']>;
  adjRefundableAmt?: Maybe<Scalars['Float']>;
  finalRefundableAmt?: Maybe<Scalars['Float']>;
  settlementById?: Maybe<Scalars['Float']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  totalAdjustmentAmt?: Maybe<Scalars['Float']>;
  totalRefundAmt?: Maybe<Scalars['Float']>;
  rental?: Maybe<LeaseContRentalContractData>;
};

export type LeaseDecoraFitoutData = {
  __typename?: 'LeaseDecoraFitoutData';
  fitoutId: Scalars['Float'];
  fitoutNo?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  fitoutCompany?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  approveUserId?: Maybe<Scalars['Float']>;
  approveDate?: Maybe<Scalars['DateTime']>;
  approveRemark?: Maybe<Scalars['String']>;
  fitoutUnitNo?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  serviceCompanyId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  rental?: Maybe<LeaseContRentalContractData>;
  account?: Maybe<CommonSetupAccountData>;
};

export type LeaseGlBillItemMappingData = {
  __typename?: 'LeaseGlBillItemMappingData';
  glAccountId: Scalars['Float'];
  billItemId: Scalars['Float'];
  itemName?: Maybe<Scalars['String']>;
  glAccountCode?: Maybe<Scalars['String']>;
  propertyId: Scalars['Float'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type LeaseGlVoucher = {
  __typename?: 'LeaseGlVoucher';
  voucherId: Scalars['Float'];
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
  documentNo?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  refType?: Maybe<Scalars['String']>;
  rentalId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  exported?: Maybe<Scalars['Float']>;
  exportDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type LeaseGlVoucherItem = {
  __typename?: 'LeaseGlVoucherItem';
  voucherItemId: Scalars['Float'];
  voucherId: Scalars['Float'];
  acctCode?: Maybe<Scalars['String']>;
  debitAmt?: Maybe<Scalars['Float']>;
  creditAmt?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
  paymentMode?: Maybe<Scalars['Float']>;
  chequeStartDate?: Maybe<Scalars['DateTime']>;
  refNo?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  module?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LeaseIoMove = {
  __typename?: 'LeaseIoMove';
  moveId: Scalars['Float'];
  propertyId: Scalars['Float'];
  rentalGuid: Scalars['String'];
  rentalStartDate: Scalars['DateTime'];
  rentalEndDate: Scalars['DateTime'];
  moveInUnitLotNo?: Maybe<Scalars['String']>;
  openingUnitLotNo?: Maybe<Scalars['String']>;
  moveOutUnitLotNo?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type LeaseIoMoveLog = {
  __typename?: 'LeaseIoMoveLog';
  moveLogId: Scalars['Float'];
  propertyId: Scalars['Float'];
  unitLotNo?: Maybe<Scalars['String']>;
  moveType: Scalars['String'];
  moveById: Scalars['Float'];
  moveDate: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  rentalGuid: Scalars['String'];
};

export type LeaseIoMoveLogItem = {
  __typename?: 'LeaseIoMoveLogItem';
  moveLogItemId: Scalars['Float'];
  unitId: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type LeaseIoMoveUnit = {
  __typename?: 'LeaseIoMoveUnit';
  moveUnitId: Scalars['Float'];
  propertyId: Scalars['Float'];
  accountId: Scalars['Float'];
  rentalId: Scalars['Float'];
  rentalUnitId: Scalars['Float'];
  unitId: Scalars['Float'];
  rentalStartDate: Scalars['DateTime'];
  rentalEndDate: Scalars['DateTime'];
  moveInPlanDate: Scalars['DateTime'];
  moveInDate?: Maybe<Scalars['DateTime']>;
  moveInById?: Maybe<Scalars['Float']>;
  moveInRemark?: Maybe<Scalars['String']>;
  openingPlanDate: Scalars['DateTime'];
  openingDate?: Maybe<Scalars['DateTime']>;
  openingById?: Maybe<Scalars['Float']>;
  openingRemark?: Maybe<Scalars['String']>;
  moveOutPlanDate: Scalars['DateTime'];
  moveOutDate?: Maybe<Scalars['DateTime']>;
  moveOutById?: Maybe<Scalars['Float']>;
  moveOutRemark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  moveId: Scalars['Float'];
  property: Array<LeaseProSetPropertyData>;
  rental?: Maybe<Array<LeaseContRentalContractData>>;
};

export type LeaseJmCreditRelatData = {
  __typename?: 'LeaseJmCreditRelatData';
  relatId: Scalars['Float'];
  propertyId?: Maybe<Scalars['Float']>;
  contId?: Maybe<Scalars['Float']>;
  creditTmpId?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  rentalContract?: Maybe<LeaseContRentalContractData>;
  creditCardDetail?: Maybe<LeaseStCreditCardTemp>;
};

export type LeaseLpLeaseClauseData = {
  __typename?: 'LeaseLpLeaseClauseData';
  leaseClauseId: Scalars['Float'];
  propertyId: Scalars['Float'];
  businessTypeId?: Maybe<Scalars['Float']>;
  validDate?: Maybe<Scalars['DateTime']>;
  rentYear?: Maybe<Scalars['Float']>;
  rentFreeMonth?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  rentIncreaseMethod?: Maybe<Scalars['String']>;
  rentIncreaseRate?: Maybe<Scalars['Float']>;
  rentIncreaseAmount?: Maybe<Scalars['Float']>;
  rentIncreaseFirseYear?: Maybe<Scalars['Float']>;
  rentIncreaseEveryYear?: Maybe<Scalars['Float']>;
  manageIncreaseMethod?: Maybe<Scalars['String']>;
  manageIncreaseRate?: Maybe<Scalars['Float']>;
  manageIncreaseAmount?: Maybe<Scalars['Float']>;
  manageIncreaseFirseYear?: Maybe<Scalars['Float']>;
  manageIncreaseEveryYear?: Maybe<Scalars['Float']>;
  depositType?: Maybe<Scalars['String']>;
  depositAmount?: Maybe<Scalars['Float']>;
  depositMinAmount?: Maybe<Scalars['Float']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  payMode?: Maybe<Scalars['String']>;
  rentCalculateMethod?: Maybe<Scalars['String']>;
  rentFrequencyMode?: Maybe<Scalars['String']>;
  manageCalculateMethod?: Maybe<Scalars['String']>;
  manageFrequencyMode?: Maybe<Scalars['String']>;
  increaseValue?: Maybe<Scalars['Float']>;
  manageIncreaseValue?: Maybe<Scalars['Float']>;
  businessType?: Maybe<PopupLstElementEntity>;
};

export type LeaseLpPricePolicyData = {
  __typename?: 'LeaseLpPricePolicyData';
  pricePolicyId: Scalars['Float'];
  propertyId?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  workFlowState?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
  priceTitle?: Maybe<Scalars['String']>;
  unitData?: Maybe<Array<LeaseLpPricePolicyUnitData>>;
  policyCoverage?: Maybe<Array<PolicyCoverage>>;
  total?: Maybe<Array<Total>>;
};

export type LeaseLpPricePolicyUnitData = {
  __typename?: 'LeaseLpPricePolicyUnitData';
  pricePolicyUnitId: Scalars['Float'];
  pricePolicyId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  floorPrice?: Maybe<Scalars['Float']>;
  conferPrice?: Maybe<Scalars['Float']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['Float']>;
  pricePolicy?: Maybe<LeaseLpPricePolicyData>;
  unitDetail?: Maybe<LeaseProSetUnitData>;
};

export type LeaseLpRevenueQuotaData = {
  __typename?: 'LeaseLpRevenueQuotaData';
  revenueQuotaId: Scalars['Float'];
  propertyId: Scalars['Float'];
  revenueQuotaName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  totalArea?: Maybe<Scalars['Float']>;
  rentTotalAmount?: Maybe<Scalars['Float']>;
  manageTotalAmount?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus?: Maybe<Scalars['String']>;
  revenueQuotaDetail?: Maybe<Array<LeaseLpRevenueQuotaDetailData>>;
  property: LeaseProSetPropertyData;
};

export type LeaseLpRevenueQuotaDetailData = {
  __typename?: 'LeaseLpRevenueQuotaDetailData';
  revenueQuotaDetailId: Scalars['Float'];
  revenueQuotaId?: Maybe<Scalars['Float']>;
  businessTypeId?: Maybe<Scalars['Float']>;
  rentPrice?: Maybe<Scalars['Float']>;
  managePrice?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  rentTotalAmount?: Maybe<Scalars['Float']>;
  manageTotalAmount?: Maybe<Scalars['Float']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus?: Maybe<Scalars['String']>;
  revenueQuota?: Maybe<LeaseLpRevenueQuotaData>;
  businessType?: Maybe<PopupLstElementEntity>;
};

export type LeaseMarCampaignData = {
  __typename?: 'LeaseMarCampaignData';
  campaignId: Scalars['Float'];
  apportionId?: Maybe<Scalars['Float']>;
  campaignTypeId: Scalars['Float'];
  campaignCostShareId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Float']>;
  budget?: Maybe<Scalars['Float']>;
  expense?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  approveUserId?: Maybe<Scalars['Float']>;
  approveDate?: Maybe<Scalars['DateTime']>;
  approveRemark?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  billItemId?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  budgetMode: Scalars['String'];
  innerAllocExpense?: Maybe<Scalars['Float']>;
  markUpRate?: Maybe<Scalars['Float']>;
  markUpAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  allocBalance?: Maybe<Scalars['Float']>;
  eventItemData: Array<LeaseMarCampaignItemData>;
  apportionmentMethod: PopupLstElementEntity;
  eventType: PopupLstElementEntity;
  eventNature: PopupLstElementEntity;
  billItemName: LeaseArBillItemData;
  attachment?: Maybe<Array<DocExtendOutput>>;
};

export type LeaseMarCampaignItemData = {
  __typename?: 'LeaseMarCampaignItemData';
  campaignItemId: Scalars['Float'];
  chargeItemId: Scalars['Float'];
  budgetAmout?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  bugdetPercentage?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  campaign: LeaseMarCampaignData;
  chargeItem: PopupLstElementEntity;
};

export type LeaseMercActivityData = {
  __typename?: 'LeaseMercActivityData';
  activityId: Scalars['Float'];
  parentId?: Maybe<Scalars['Float']>;
  activityTypeId?: Maybe<Scalars['Float']>;
  activityTypeCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  activityContent?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['String']>;
  assignedToId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  meetingNumber?: Maybe<Scalars['String']>;
  meetingPassword?: Maybe<Scalars['String']>;
  meetingTypeId?: Maybe<Scalars['Float']>;
  showTimeAsId?: Maybe<Scalars['Float']>;
  plannedDate?: Maybe<Scalars['DateTime']>;
  actualDate?: Maybe<Scalars['DateTime']>;
  completedDate?: Maybe<Scalars['DateTime']>;
  completePercent?: Maybe<Scalars['Float']>;
  officiateUser?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  priorityId?: Maybe<Scalars['Float']>;
  isPrivate?: Maybe<Scalars['Float']>;
  assignedToRefTable?: Maybe<Scalars['String']>;
  assignedToRefRecordId?: Maybe<Scalars['Float']>;
  nextScheduleDate?: Maybe<Scalars['DateTime']>;
  refRecordUrl?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  sourceId?: Maybe<Scalars['Float']>;
  agent?: Maybe<LeaseMercAgentData>;
  prospect: Array<LeaseMercProspectData>;
  activityType?: Maybe<PopupLstElementEntity>;
};

export type LeaseMercAgentData = {
  __typename?: 'LeaseMercAgentData';
  agentId: Scalars['Float'];
  userId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  agentRankId?: Maybe<Scalars['Float']>;
  isAgency?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
  parentAgentId?: Maybe<Scalars['Float']>;
  agentCompanyId?: Maybe<Scalars['Float']>;
  rentalRate?: Maybe<Scalars['Float']>;
  creditorId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  user?: Maybe<CommonSetupUserData>;
  activityData?: Maybe<LeaseMercActivityData>;
  privilAccessData: Array<LeaseMercPrivilAccessData>;
};

export type LeaseMercBookData = {
  __typename?: 'LeaseMercBookData';
  bookId: Scalars['Float'];
  bookNo?: Maybe<Scalars['String']>;
  propertyId: Scalars['Float'];
  prospectId?: Maybe<Scalars['Float']>;
  versionNo?: Maybe<Scalars['String']>;
  defaultStartDate?: Maybe<Scalars['DateTime']>;
  defaultExpiryDate?: Maybe<Scalars['DateTime']>;
  rentalArea?: Maybe<Scalars['Float']>;
  bookStartDate?: Maybe<Scalars['DateTime']>;
  bookExpiryDate?: Maybe<Scalars['DateTime']>;
  bookDate?: Maybe<Scalars['DateTime']>;
  totalAmt?: Maybe<Scalars['Float']>;
  bookAmt?: Maybe<Scalars['Float']>;
  currencyId?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  cancelBookDate?: Maybe<Scalars['DateTime']>;
  cancelUserId?: Maybe<Scalars['Float']>;
  cancelRemark?: Maybe<Scalars['String']>;
  rentFreePeriods?: Maybe<Scalars['String']>;
  rentFreeStartDate?: Maybe<Scalars['DateTime']>;
  rentFreeEndDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  accountId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  videoalidityDay?: Maybe<Scalars['Float']>;
  bookLotNo?: Maybe<Scalars['String']>;
  unitIds?: Maybe<Scalars['String']>;
  billItemCode: Scalars['String'];
  debtorId?: Maybe<Scalars['Float']>;
  debtor?: Maybe<LeaseArDebtorData>;
  personInCharge?: Maybe<CommonSetupUserData>;
  prospect?: Maybe<LeaseMercProspectData>;
  prospectData: Array<LeaseMercProspectData>;
  bookItems?: Maybe<Array<LeaseMercBookItemData>>;
  account?: Maybe<CommonSetupAccountData>;
  property?: Maybe<LeaseProSetPropertyData>;
  attachment?: Maybe<Array<DocExtendOutput>>;
};

export type LeaseMercBookItemData = {
  __typename?: 'LeaseMercBookItemData';
  bookItemId: Scalars['Float'];
  bookId: Scalars['Float'];
  unitId: Scalars['Float'];
  rentalArea?: Maybe<Scalars['Float']>;
  quoteStartDate?: Maybe<Scalars['DateTime']>;
  quoteExpiryDate?: Maybe<Scalars['DateTime']>;
  billItemDetailId?: Maybe<Scalars['Float']>;
  frequencyMode?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  bookData?: Maybe<LeaseMercBookData>;
  unit?: Maybe<LeaseProSetUnitData>;
};

export type LeaseMercBrandData = {
  __typename?: 'LeaseMercBrandData';
  brandId: Scalars['Float'];
  brandName: Scalars['String'];
  qualification?: Maybe<Scalars['String']>;
  levelId?: Maybe<Scalars['Float']>;
  popularityId?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  modifyDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createUserId: Scalars['Float'];
  industryId?: Maybe<Scalars['Float']>;
  typeId?: Maybe<Scalars['Float']>;
  developId?: Maybe<Scalars['Float']>;
  rentalContract?: Maybe<LeaseContRentalContractData>;
  prospect?: Maybe<LeaseMercProspectData>;
  brandIndustry?: Maybe<PopupLstElementEntity>;
};

export type LeaseMercBrandIntDetailData = {
  __typename?: 'LeaseMercBrandIntDetailData';
  brandIntentionDetailId: Scalars['Float'];
  unitBrandTypeCode?: Maybe<Scalars['String']>;
  bunkId: Scalars['Float'];
  propertyId?: Maybe<Scalars['Float']>;
  blockId?: Maybe<Scalars['Float']>;
  blockName?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  bunkDesc?: Maybe<Scalars['String']>;
  buildUpArea?: Maybe<Scalars['Float']>;
  parentDetailId?: Maybe<Scalars['Float']>;
  earliestBrandId?: Maybe<Scalars['Float']>;
  earliestBrandName?: Maybe<Scalars['String']>;
  earliestLevelCn?: Maybe<Scalars['String']>;
  earliestDefaultExpiryDate?: Maybe<Scalars['DateTime']>;
  aBrandName?: Maybe<Scalars['String']>;
  bBrandName?: Maybe<Scalars['String']>;
  cBrandName?: Maybe<Scalars['String']>;
  aBrandCode?: Maybe<Scalars['Float']>;
  bBrandCode?: Maybe<Scalars['Float']>;
  cBrandCode?: Maybe<Scalars['Float']>;
  aIsLibrary?: Maybe<Scalars['String']>;
  bIsLibrary?: Maybe<Scalars['String']>;
  cIsLibrary?: Maybe<Scalars['String']>;
  adjustABrandId?: Maybe<Scalars['Float']>;
  adjustABrandName?: Maybe<Scalars['String']>;
  adjustLevelCn?: Maybe<Scalars['String']>;
  adjustDate?: Maybe<Scalars['DateTime']>;
  advance?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  brandIntention: LeaseMercBrandIntentionData;
};

export type LeaseMercBrandIntentionData = {
  __typename?: 'LeaseMercBrandIntentionData';
  brandIntentionId: Scalars['Float'];
  propertyId: Scalars['Float'];
  parentId?: Maybe<Scalars['Float']>;
  documentDate: Scalars['DateTime'];
  typeCode: Scalars['String'];
  programName: Scalars['String'];
  programDesc?: Maybe<Scalars['String']>;
  bunkNumber?: Maybe<Scalars['Float']>;
  brandNumber?: Maybe<Scalars['Float']>;
  rentalArea?: Maybe<Scalars['Float']>;
  libraryBrandRate?: Maybe<Scalars['Float']>;
  libraryBrandScale?: Maybe<Scalars['Float']>;
  actualLibraryBrandRate?: Maybe<Scalars['Float']>;
  aRate?: Maybe<Scalars['Float']>;
  bRate?: Maybe<Scalars['Float']>;
  cRate?: Maybe<Scalars['Float']>;
  dRate?: Maybe<Scalars['Float']>;
  aPlazaRate?: Maybe<Scalars['Float']>;
  bPlazaRate?: Maybe<Scalars['Float']>;
  cPlazaRate?: Maybe<Scalars['Float']>;
  dPlazaRate?: Maybe<Scalars['Float']>;
  kindAActualRate?: Maybe<Scalars['Float']>;
  kindBActualRate?: Maybe<Scalars['Float']>;
  kindCActualRate?: Maybe<Scalars['Float']>;
  kindDActualRate?: Maybe<Scalars['Float']>;
  changeUserId?: Maybe<Scalars['Float']>;
  changeDate?: Maybe<Scalars['DateTime']>;
  leaseDocumentsId?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  pRecordStatus?: Maybe<Scalars['String']>;
  kRecordStatus?: Maybe<Scalars['String']>;
  brandIntDetailData?: Maybe<Array<LeaseMercBrandIntDetailData>>;
  property?: Maybe<LeaseProSetPropertyData>;
};

export type LeaseMercBrandProvideFormatData = {
  __typename?: 'LeaseMercBrandProvideFormatData';
  provideFormatId: Scalars['Float'];
  provideFormatName?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  propertyId: Scalars['Float'];
  plazaRate: Scalars['Float'];
  itemData: Array<LeaseMercBrandProvideFormatItemData>;
};

export type LeaseMercBrandProvideFormatItemData = {
  __typename?: 'LeaseMercBrandProvideFormatItemData';
  provideFormatItemId: Scalars['Float'];
  popupLstElementId: Scalars['Float'];
  unitId: Scalars['Float'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  provideFormat: LeaseMercBrandProvideFormatData;
  tradeCategory?: Maybe<PopupLstElementEntity>;
  unit?: Maybe<LeaseProSetUnitData>;
};

export type LeaseMercPrivilAccessData = {
  __typename?: 'LeaseMercPrivilAccessData';
  privilegeAccessId: Scalars['Float'];
  refRecordId: Scalars['Float'];
  accessRight?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createDate: Scalars['DateTime'];
  modifyDate: Scalars['DateTime'];
  createUserId: Scalars['Float'];
  accessRoleRefNo: Scalars['Float'];
  operationType: Scalars['String'];
  refPKColumn: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  accessRoleType: Scalars['String'];
  modifyUserId: Scalars['Float'];
  assignedTo?: Maybe<LeaseMercAgentData>;
  assignedBy?: Maybe<CommonSetupUserData>;
};

export type LeaseMercProspectData = {
  __typename?: 'LeaseMercProspectData';
  prospectId: Scalars['Float'];
  companyId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  agentId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  probabilityId?: Maybe<Scalars['Float']>;
  prospectNo?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['String']>;
  ratingDesc?: Maybe<Scalars['String']>;
  firstDate?: Maybe<Scalars['DateTime']>;
  noOfVisits?: Maybe<Scalars['Float']>;
  lastDate?: Maybe<Scalars['DateTime']>;
  failReason?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  introducer?: Maybe<Scalars['String']>;
  authorizeExpiryDate?: Maybe<Scalars['DateTime']>;
  failTypeId?: Maybe<Scalars['Float']>;
  cancelDate?: Maybe<Scalars['DateTime']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  videoalidityDay?: Maybe<Scalars['Float']>;
  prospectStartDate?: Maybe<Scalars['DateTime']>;
  estimateAmtId?: Maybe<Scalars['Float']>;
  interestLevelId?: Maybe<Scalars['Float']>;
  ratingDescName?: Maybe<Scalars['String']>;
  defaultStartDate?: Maybe<Scalars['DateTime']>;
  defaultExpiryDate?: Maybe<Scalars['DateTime']>;
  brandId?: Maybe<Scalars['Float']>;
  askingRentalArea?: Maybe<Scalars['Float']>;
  urgency?: Maybe<Scalars['String']>;
  targetClosingDate?: Maybe<Scalars['DateTime']>;
  askingMonthlyRentalAmt?: Maybe<Scalars['Float']>;
  account?: Maybe<CommonSetupAccountData>;
  agent?: Maybe<LeaseMercAgentData>;
  popUpLstElement?: Maybe<PopupLstElementEntity>;
  sourceData?: Maybe<PopupLstElementEntity>;
  interestLevelData?: Maybe<PopupLstElementEntity>;
  activityData?: Maybe<Array<LeaseMercActivityData>>;
  contractData?: Maybe<Array<LeaseContRentalContractData>>;
  bookData?: Maybe<Array<LeaseMercBookData>>;
  privilAccessDataView?: Maybe<Array<PrivilAccessDataView>>;
  brandData?: Maybe<LeaseMercBrandData>;
  profileAttachment?: Maybe<AttachementOutput>;
};

export type LeaseMercProspectUnitData = {
  __typename?: 'LeaseMercProspectUnitData';
  prospectUnitId: Scalars['Float'];
  prospectId: Scalars['Float'];
  unitId: Scalars['Float'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
};

export type LeaseMeterMeterChargesData = {
  __typename?: 'LeaseMeterMeterChargesData';
  meterChargeId: Scalars['Float'];
  unitId?: Maybe<Scalars['Float']>;
  billScheduleId?: Maybe<Scalars['Float']>;
  previousDate: Scalars['DateTime'];
  previousReading: Scalars['Float'];
  currentDate: Scalars['DateTime'];
  currentReading: Scalars['Float'];
  usageRate: Scalars['Float'];
  voidDate?: Maybe<Scalars['DateTime']>;
  voidRemark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  apJournalId?: Maybe<Scalars['Float']>;
  meterCharges?: Maybe<Scalars['Float']>;
  isShare?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  liftMethod?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Float']>;
  meterReadingId?: Maybe<Scalars['Float']>;
  meterId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  billSchedule: LeaseArBillScheduleData;
  meter: LeaseMeterMeterMasterData;
  rental?: Maybe<LeaseContRentalContractData>;
  unit: LeaseProSetUnitData;
};

export type LeaseMeterMeterMasterData = {
  __typename?: 'LeaseMeterMeterMasterData';
  meterId: Scalars['Float'];
  propertyId: Scalars['Float'];
  unitId?: Maybe<Scalars['Float']>;
  meterTypeId: Scalars['Float'];
  meterClass: Scalars['String'];
  apportionMethod?: Maybe<Scalars['String']>;
  calculateMethod?: Maybe<Scalars['String']>;
  wastage?: Maybe<Scalars['Float']>;
  multiplyFactor: Scalars['Float'];
  meterNo: Scalars['String'];
  previousReading?: Maybe<Scalars['Float']>;
  previousDate?: Maybe<Scalars['DateTime']>;
  currentReading?: Maybe<Scalars['Float']>;
  currentDate?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['String'];
  maxReading?: Maybe<Scalars['Float']>;
  billItemDetailId?: Maybe<Scalars['Float']>;
  tempDebtorId?: Maybe<Scalars['Float']>;
  tempBillItemDetailId?: Maybe<Scalars['Float']>;
  rentalId?: Maybe<Scalars['Float']>;
  parentMeterId?: Maybe<Scalars['Float']>;
  purposeType: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  referenceNo?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  accountId?: Maybe<Scalars['Float']>;
  meterName?: Maybe<Scalars['String']>;
  meterCode?: Maybe<Scalars['String']>;
  leaseMeterMeterChargesData: Array<LeaseMeterMeterChargesData>;
  meterType: LeaseMeterMeterTypeData;
  billItemDetail: LeaseArBillItemSpecData;
  meterReadings: Array<LeaseMeterMeterReadingData>;
  unit: Array<LeaseProSetUnitData>;
  apportionMethodCode: Scalars['String'];
  calculateMethodCode: Scalars['String'];
  latestMeterReading?: Maybe<LeaseMeterMeterReadingData>;
};

export type LeaseMeterMeterReadingData = {
  __typename?: 'LeaseMeterMeterReadingData';
  meterReadingId: Scalars['Float'];
  meterId: Scalars['Float'];
  readingDate: Scalars['DateTime'];
  wastageRate?: Maybe<Scalars['Float']>;
  currentReading: Scalars['Float'];
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  readingType?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  meter: LeaseMeterMeterMasterData;
  attachment?: Maybe<AttachmentEntity>;
};

export type LeaseMeterMeterTypeData = {
  __typename?: 'LeaseMeterMeterTypeData';
  meterTypeId: Scalars['Float'];
  propertyId?: Maybe<Scalars['Float']>;
  billItemDetailId?: Maybe<Scalars['Float']>;
  billItemId?: Maybe<Scalars['Float']>;
  typeNo?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  alertParameter?: Maybe<Scalars['Float']>;
  alertMethod?: Maybe<Scalars['String']>;
  alertReading?: Maybe<Scalars['Float']>;
  alertRate?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  leaseMeterMeterMasterData: Array<LeaseMeterMeterMasterData>;
  totalMasterMeterReading: Scalars['Float'];
  totalSubMeterUsage: Scalars['Float'];
  totalUnitMeterWithRental: Scalars['Float'];
  totalSubMeterSubmittedByCurrentYearMonth: Scalars['Float'];
  latestMeterReadingUpdatedDate?: Maybe<Scalars['DateTime']>;
};


export type LeaseMeterMeterTypeDataTotalMasterMeterReadingArgs = {
  PropertyId: Scalars['Float'];
};


export type LeaseMeterMeterTypeDataTotalSubMeterUsageArgs = {
  PropertyId: Scalars['Float'];
};


export type LeaseMeterMeterTypeDataTotalUnitMeterWithRentalArgs = {
  PropertyId: Scalars['Float'];
};


export type LeaseMeterMeterTypeDataTotalSubMeterSubmittedByCurrentYearMonthArgs = {
  PropertyId: Scalars['Float'];
};


export type LeaseMeterMeterTypeDataLatestMeterReadingUpdatedDateArgs = {
  PropertyId: Scalars['Float'];
};

export type LeaseMeterMeterXRefData = {
  __typename?: 'LeaseMeterMeterXRefData';
  meterXRefId: Scalars['Float'];
  meterId: Scalars['Float'];
  parentMeterId?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId: Scalars['Float'];
  apportionMode?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  unitId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  meterTypeId?: Maybe<Scalars['Float']>;
};

export type LeaseOperaCheckData = {
  __typename?: 'LeaseOperaCheckData';
  checkId: Scalars['Float'];
  checkTime?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  checkBy?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['Float']>;
  checkDetail?: Maybe<Array<LeaseOperaCheckDetailData>>;
};

export type LeaseOperaCheckDetailData = {
  __typename?: 'LeaseOperaCheckDetailData';
  checkDetailId: Scalars['Float'];
  unitId?: Maybe<Scalars['Float']>;
  checkId?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  checkItemId: Scalars['Float'];
  point?: Maybe<Scalars['Float']>;
  forfeit?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  isPoint?: Maybe<Scalars['String']>;
  isForfeit?: Maybe<Scalars['String']>;
  checkBy?: Maybe<Scalars['String']>;
  checkTime?: Maybe<Scalars['DateTime']>;
  typeId?: Maybe<Scalars['Float']>;
  checkObjectId?: Maybe<Scalars['Float']>;
  tenant?: Maybe<CommonSetupAccountData>;
  category?: Maybe<PopupLstElementEntity>;
  checkData?: Maybe<LeaseOperaCheckData>;
  checkItem?: Maybe<LeaseOperaCheckItemData>;
  unit?: Maybe<LeaseProSetUnitData>;
  checkDetailAttachments?: Maybe<Array<DocExtendOutput>>;
};

export type LeaseOperaCheckItemData = {
  __typename?: 'LeaseOperaCheckItemData';
  checkItemId: Scalars['Float'];
  typeId?: Maybe<Scalars['Float']>;
  item?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  point?: Maybe<Scalars['Float']>;
  forfeit?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  propertyId?: Maybe<Scalars['Float']>;
};

export type LeaseProSetBlockData = {
  __typename?: 'LeaseProSetBlockData';
  blockId: Scalars['Float'];
  blockNo: Scalars['String'];
  blockName: Scalars['String'];
  blockHeight?: Maybe<Scalars['Float']>;
  floorHeight?: Maybe<Scalars['Float']>;
  totalFloors?: Maybe<Scalars['Float']>;
  blockAddress?: Maybe<Scalars['String']>;
  aboveGroundFloors?: Maybe<Scalars['Float']>;
  belowGroundFloors?: Maybe<Scalars['Float']>;
  fitnessDate?: Maybe<Scalars['DateTime']>;
  landArea?: Maybe<Scalars['Float']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  usableArea?: Maybe<Scalars['Float']>;
  pilingArea?: Maybe<Scalars['Float']>;
  publicArea?: Maybe<Scalars['Float']>;
  accessory?: Maybe<Scalars['String']>;
  designer?: Maybe<Scalars['String']>;
  supervisor?: Maybe<Scalars['String']>;
  lift?: Maybe<Scalars['String']>;
  others?: Maybe<Scalars['String']>;
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  recordStatus: Scalars['String'];
  areaName?: Maybe<Scalars['String']>;
  unitNoFormatId?: Maybe<Scalars['Float']>;
  zoneId?: Maybe<Scalars['Float']>;
  hasPropertyCard?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  property: LeaseProSetPropertyData;
  floor: Array<LeaseProSetFloorData>;
  leaseProSetUnitData: Array<LeaseProSetUnitData>;
  totalUnitLeasableArea: Scalars['Float'];
};

export type LeaseProSetFloorData = {
  __typename?: 'LeaseProSetFloorData';
  floorId: Scalars['Float'];
  blockId?: Maybe<Scalars['Float']>;
  floor?: Maybe<Scalars['Float']>;
  floorNo?: Maybe<Scalars['String']>;
  blockMapId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  block: LeaseProSetBlockData;
};

export type LeaseProSetImageDataEntity = {
  __typename?: 'LeaseProSetImageDataEntity';
  imageId: Scalars['Float'];
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
  imageTypeId?: Maybe<Scalars['Float']>;
  imageSaveDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  tempGuid?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  resources?: Maybe<CommonSetupProjectResData>;
  property?: Maybe<LeaseProSetPropertyData>;
  imageGalleryProperty?: Maybe<LeaseProSetPropertyData>;
};

export type LeaseProSetImageDataEntityExtension = {
  __typename?: 'LeaseProSetImageDataEntityExtension';
  imageId: Scalars['Float'];
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['Float']>;
  imageTypeId?: Maybe<Scalars['Float']>;
  imageSaveDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  tempGuid?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  resources?: Maybe<CommonSetupProjectResData>;
  property?: Maybe<LeaseProSetPropertyData>;
  imageGalleryProperty?: Maybe<LeaseProSetPropertyData>;
  filePath?: Maybe<Scalars['String']>;
};

export type LeaseProSetPropertyData = {
  __typename?: 'LeaseProSetPropertyData';
  propertyId: Scalars['Float'];
  companyId: Scalars['Float'];
  propertyNo: Scalars['String'];
  propertyName: Scalars['String'];
  propertyDesc?: Maybe<Scalars['String']>;
  landArea?: Maybe<Scalars['Float']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  addressId?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  propertyLogoId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  businessOpenTime?: Maybe<Scalars['DateTime']>;
  businessCloseTime?: Maybe<Scalars['DateTime']>;
  arInterestSpecId?: Maybe<Scalars['Float']>;
  arReminderSpecId?: Maybe<Scalars['Float']>;
  arFinanceSpecId?: Maybe<Scalars['Float']>;
  monthlyDaysCode?: Maybe<Scalars['String']>;
  isGenerateFreeBill: Scalars['String'];
  generateBillTypeCode?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['DateTime']>;
  purchaseAmt?: Maybe<Scalars['Float']>;
  purchaseBy?: Maybe<Scalars['String']>;
  bankAccountId?: Maybe<Scalars['Float']>;
  ceaseOperationDate?: Maybe<Scalars['DateTime']>;
  rentalExpiryAlertDays?: Maybe<Scalars['Float']>;
  billingDay?: Maybe<Scalars['Float']>;
  debtorCode?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  adjustmentCode?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  rentalAreaType?: Maybe<Scalars['String']>;
  measureUnitType?: Maybe<Scalars['String']>;
  companyData?: Maybe<CommonSetupCompanyDataEntity>;
  leaseProSetBlockData: Array<LeaseProSetBlockData>;
  debtor?: Maybe<Array<LeaseArDebtorData>>;
  resources?: Maybe<CommonSetupProjectResData>;
  imageData?: Maybe<LeaseProSetImageDataEntity>;
  moveUnit: LeaseIoMoveUnit;
  turnover: TurnoverSummaryEntity;
  posSubmission?: Maybe<Array<PosSubmissionEntity>>;
  arInterestSpec: LeaseArSpecData;
  imageGallery?: Maybe<Array<LeaseProSetImageDataEntity>>;
  meterTypeListing: Array<LeaseMeterMeterTypeData>;
  ActiveRentalContract?: Maybe<Array<LeaseArDebtorData>>;
  MonthlySales?: Maybe<DailySalesOutput>;
  LatestCompletedSales?: Maybe<DailySalesOutput>;
  MonthlyCompletedSales?: Maybe<Array<DailySalesOutput>>;
  CompletedSalesByDate?: Maybe<Array<DailySalesOutput>>;
  DailyCompletedSales?: Maybe<Array<DailySalesOutput>>;
  DailySubmittedSales?: Maybe<Array<DailySalesOutput>>;
  totalMeterOutstanding: Scalars['Float'];
  totalRoutineInspectCount: Scalars['Float'];
  imageGalleries?: Maybe<Array<LeaseProSetImageDataEntityExtension>>;
  unitStatusSummary?: Maybe<UnitStatusSummary>;
  AgeingAnalysis: Array<AgeingAnalysisOutput>;
  AgeingAnalysisTableView: Array<AgeingAnalysisOutput>;
  BookingStatistics: Array<BookingStatistics>;
  OccupancyStatistics: Array<OccupancyStatistics>;
  Next12MonthsOccupancyProjection: Array<Next12MonthsOccupancyOutput>;
  RentalIncomeProjection: Array<BusinessInsightOutput>;
  TenantSalesCollectionAnalysis: Array<BusinessInsightOutput>;
  Top10RentalContribution: Array<BusinessInsightOutput>;
  TopTenOutstanding: Array<TopTenOutstanding>;
  ActiveContractReport: Array<ActiveContractReport>;
  ExpiringContractReport: Array<ExpiringContractReport>;
  ContractsAndOpportunities: Array<ContractsAndOpportunities>;
  ContractsAndOpportunitiesTable: Array<ContractsAndOpportunitiesTable>;
  DailySalesSubmissionReport: Array<BusinessInsightOutput>;
  getUnitDetailsByBlock: Array<UnitDetail>;
  getUnitDetailsByContDate: Array<UnitDetail>;
  BookingSummary?: Maybe<BookingSummary>;
};


export type LeaseProSetPropertyDataPosSubmissionArgs = {
  SubmissionId?: Maybe<Scalars['Float']>;
  Status?: Maybe<Array<Scalars['String']>>;
  Date?: Maybe<Scalars['DateTime']>;
};


export type LeaseProSetPropertyDataMonthlyCompletedSalesArgs = {
  year?: Maybe<Scalars['Float']>;
  startMonth?: Maybe<Scalars['Float']>;
};


export type LeaseProSetPropertyDataCompletedSalesByDateArgs = {
  Date: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataDailyCompletedSalesArgs = {
  Date: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataDailySubmittedSalesArgs = {
  FilterDate?: Maybe<Scalars['Float']>;
};


export type LeaseProSetPropertyDataAgeingAnalysisArgs = {
  queryDate: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataAgeingAnalysisTableViewArgs = {
  queryDate: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataTop10RentalContributionArgs = {
  QueryDate: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataActiveContractReportArgs = {
  queryEndDate: Scalars['DateTime'];
  queryStartDate: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataExpiringContractReportArgs = {
  queryEndDate: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataContractsAndOpportunitiesTableArgs = {
  defaultExpiryDateMore: Scalars['String'];
  defaultExpiryDateLess: Scalars['String'];
  defaultStartDate: Scalars['String'];
};


export type LeaseProSetPropertyDataGetUnitDetailsByBlockArgs = {
  floorId: Scalars['Float'];
  blockId: Scalars['Float'];
  queryDate: Scalars['DateTime'];
};


export type LeaseProSetPropertyDataGetUnitDetailsByContDateArgs = {
  floorIds: Scalars['Float'];
  blockId: Scalars['Float'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type LeaseProSetUnitData = {
  __typename?: 'LeaseProSetUnitData';
  unitId: Scalars['Float'];
  blockId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  unitTypeId?: Maybe<Scalars['Float']>;
  billSchemeId?: Maybe<Scalars['Float']>;
  roomCode?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
  cellNo?: Maybe<Scalars['Float']>;
  roomNo?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Float']>;
  floorNo?: Maybe<Scalars['String']>;
  unitHeight?: Maybe<Scalars['Float']>;
  shapeId?: Maybe<Scalars['Float']>;
  useId?: Maybe<Scalars['Float']>;
  sceneryId?: Maybe<Scalars['Float']>;
  directionId?: Maybe<Scalars['Float']>;
  typeId?: Maybe<Scalars['Float']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  address?: Maybe<Scalars['String']>;
  colSpan?: Maybe<Scalars['Float']>;
  splitLevel?: Maybe<Scalars['Float']>;
  buildUpArea?: Maybe<Scalars['Float']>;
  usableArea?: Maybe<Scalars['Float']>;
  actualBuildUpArea?: Maybe<Scalars['Float']>;
  interiorArea?: Maybe<Scalars['Float']>;
  actualInteriorArea?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  carParkArea?: Maybe<Scalars['Float']>;
  undergroundArea?: Maybe<Scalars['Float']>;
  apportionArea?: Maybe<Scalars['Float']>;
  actualApportionArea?: Maybe<Scalars['Float']>;
  atticArea?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  pointX?: Maybe<Scalars['Float']>;
  pointY?: Maybe<Scalars['Float']>;
  hotSpotWidth?: Maybe<Scalars['Float']>;
  hotSpotHeight?: Maybe<Scalars['Float']>;
  hotspotShape?: Maybe<Scalars['Float']>;
  interiorAreaPrice?: Maybe<Scalars['Float']>;
  buildUpAreaPrice?: Maybe<Scalars['Float']>;
  totalAmt?: Maybe<Scalars['Float']>;
  adZoneLocation?: Maybe<Scalars['String']>;
  adZoneTypeId?: Maybe<Scalars['Float']>;
  adZoneDimension?: Maybe<Scalars['String']>;
  adZonePrice?: Maybe<Scalars['Float']>;
  noOfAd?: Maybe<Scalars['Float']>;
  adZoneIntro?: Maybe<Scalars['String']>;
  adZoneImageId?: Maybe<Scalars['Float']>;
  adZoneName?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  propertyCompanyId?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['String']>;
  afterUsePlan?: Maybe<Scalars['String']>;
  businessTypeId?: Maybe<Scalars['Float']>;
  saleDate?: Maybe<Scalars['DateTime']>;
  houseNo?: Maybe<Scalars['String']>;
  unitSeq?: Maybe<Scalars['Float']>;
  additiveTypeId?: Maybe<Scalars['Float']>;
  unitCategory?: Maybe<Scalars['String']>;
  rentalArea?: Maybe<Scalars['Float']>;
  actualRentalArea?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  leaseContRentalUnitData: Array<LeaseContRentalUnitData>;
  meters: Array<LeaseMeterMeterMasterData>;
  block: LeaseProSetBlockData;
  businessType?: Maybe<PopupLstElementEntity>;
  bookItems?: Maybe<LeaseMercBookItemData>;
};

export type LeaseStCreditCardTemp = {
  __typename?: 'LeaseStCreditCardTemp';
  creditCardTempId: Scalars['Float'];
  creditCardId: Scalars['Float'];
  tempName: Scalars['String'];
  tempDesc?: Maybe<Scalars['String']>;
  floorRate?: Maybe<Scalars['Float']>;
  marginRate?: Maybe<Scalars['Float']>;
  rounding?: Maybe<Scalars['String']>;
  roundType?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  rates: CcRate;
};

export type LetterPrintLetterData = {
  __typename?: 'LetterPrintLetterData';
  letterId: Scalars['Float'];
  letterTypeId?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
};

export type MeterAttachmentPopUpOutput = {
  __typename?: 'MeterAttachmentPopUpOutput';
  MeterId: Scalars['Float'];
  unitNo?: Maybe<Scalars['String']>;
  meterNo?: Maybe<Scalars['String']>;
  actualMeterNo?: Maybe<Scalars['String']>;
  readingDate?: Maybe<Scalars['DateTime']>;
  Attachment?: Maybe<AttachementOutput>;
};

export type MeterBillByDebtorId = {
  __typename?: 'MeterBillByDebtorId';
  debtorId: Scalars['Float'];
  billId: Scalars['Float'];
  documentNo: Scalars['Float'];
  documentAmt: Scalars['Float'];
  allocAmt: Scalars['Float'];
  cNAmt: Scalars['Float'];
  balanceAmt: Scalars['Float'];
};

export type MeterBillByPropertyId = {
  __typename?: 'MeterBillByPropertyId';
  debtorId: Scalars['Float'];
  propertyId: Scalars['Float'];
  billItemId: Scalars['Float'];
  billId: Scalars['Float'];
  documentNo: Scalars['Float'];
  documentAmt: Scalars['Float'];
  allocAmt: Scalars['Float'];
  cNAmt: Scalars['Float'];
  balanceAmt: Scalars['Float'];
};

export type MeterBillByRentalId = {
  __typename?: 'MeterBillByRentalID';
  billId: Scalars['Float'];
  documentNo: Scalars['Float'];
  documentAmt: Scalars['Float'];
  allocAmt: Scalars['Float'];
  cNAmt: Scalars['Float'];
  balanceAmt: Scalars['Float'];
};

export type MeterChargeByYearMonth = {
  __typename?: 'MeterChargeByYearMonth';
  lastPostedDate: Scalars['DateTime'];
  totalUsage: Scalars['Float'];
  totalCharges: Scalars['Float'];
  isPaid: Scalars['Boolean'];
};

export type MeterChargeXRefView = {
  __typename?: 'MeterChargeXRefView';
  RefRecordID: Scalars['Float'];
  UnitID: Scalars['Float'];
  AccountID: Scalars['Float'];
  CurrentReading: Scalars['Float'];
  PreviousReading: Scalars['Float'];
  UsageRate: Scalars['Float'];
  MaxReading: Scalars['Float'];
  MultiplyFactor: Scalars['Float'];
  CreateDate: Scalars['DateTime'];
  RentalID?: Maybe<Scalars['Float']>;
  BillScheduleID?: Maybe<Scalars['Float']>;
  MeterID: Scalars['String'];
};

export type MeterDetail = {
  __typename?: 'MeterDetail';
  MeterID: Scalars['Float'];
  PropertyID: Scalars['Float'];
  UnitID: Scalars['Float'];
  UnitNo: Scalars['String'];
  BlockID: Scalars['Float'];
  UnitTypeID: Scalars['Float'];
  AccountID: Scalars['Float'];
  Name?: Maybe<Scalars['String']>;
  ShopName?: Maybe<Scalars['String']>;
  BillItemDetailID: Scalars['Float'];
  MeterTypeID: Scalars['Float'];
  TypeName: Scalars['String'];
  MultiplyFactor: Scalars['Float'];
  Wastage: Scalars['Float'];
  MeterNo: Scalars['String'];
  MeterCode?: Maybe<Scalars['String']>;
  PreviousReading: Scalars['Float'];
  PreviousDate: Scalars['DateTime'];
  CurrentReading?: Maybe<Scalars['Float']>;
  CurrentDate?: Maybe<Scalars['DateTime']>;
  IsActive: Scalars['String'];
  MaxReading: Scalars['Float'];
  PurposeType: Scalars['String'];
  RentalID: Scalars['Float'];
  AlertMethod: Scalars['String'];
  AlertReading: Scalars['Float'];
  AlertRate: Scalars['Float'];
  MutuallyCurrentReading?: Maybe<Scalars['Float']>;
  UsageRate?: Maybe<Scalars['Float']>;
  PriceMode: Scalars['String'];
  MinimumCharges: Scalars['Float'];
  BillItemID: Scalars['Float'];
  Rounding: Scalars['String'];
  RoundType: Scalars['String'];
  DebtorID?: Maybe<Scalars['Float']>;
  ItemCode: Scalars['String'];
};

export type MeterListing = {
  __typename?: 'MeterListing';
  meterTypeId: Scalars['Float'];
  typeName?: Maybe<Scalars['String']>;
  itemCode: Scalars['String'];
  ListOfMeterCharges?: Maybe<Array<MeterChargeByYearMonth>>;
};

export type MeterListingByDebtor = {
  __typename?: 'MeterListingByDebtor';
  debtorId: Scalars['Float'];
  meterListing?: Maybe<Array<MeterListing>>;
};

export type MeterListingByRental = {
  __typename?: 'MeterListingByRental';
  rentalId: Scalars['Float'];
  meterListing?: Maybe<Array<MeterListing>>;
};

export type MeterMasterDetail = {
  __typename?: 'MeterMasterDetail';
  MeterID: Scalars['Float'];
  PropertyID: Scalars['Float'];
  UnitID: Scalars['Float'];
  UnitNo?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Float']>;
  Name?: Maybe<Scalars['String']>;
  BillItemDetailID?: Maybe<Scalars['Float']>;
  MeterTypeID: Scalars['Float'];
  TypeName: Scalars['String'];
  MultiplyFactor: Scalars['Float'];
  Wastage: Scalars['Float'];
  MeterNo: Scalars['String'];
  MeterCode?: Maybe<Scalars['String']>;
  PreviousReading: Scalars['Float'];
  PreviousDate: Scalars['DateTime'];
  PreviousDates: Scalars['DateTime'];
  CurrentReading?: Maybe<Scalars['Float']>;
  CurrentDate?: Maybe<Scalars['DateTime']>;
  CurrentDates?: Maybe<Scalars['DateTime']>;
  IsActive: Scalars['String'];
  MaxReading: Scalars['Float'];
  PurposeType?: Maybe<Scalars['String']>;
  PriceMode?: Maybe<Scalars['String']>;
  MinimumCharges: Scalars['Float'];
  BillItemID: Scalars['Float'];
  Rounding: Scalars['String'];
  RoundType: Scalars['String'];
  ApportionMethod: Scalars['String'];
  ApportionMethodStringCode: Scalars['String'];
  BillID?: Maybe<Scalars['Float']>;
  CalculateMethod: Scalars['String'];
  CalculateMethodStringCode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  MeterName: Scalars['String'];
  PurposeTypeName: Scalars['String'];
  RentalID?: Maybe<Scalars['Float']>;
  ItemCode: Scalars['String'];
};

export type MeterReadingInputModel = {
  meterId: Scalars['Float'];
  currentReading: Scalars['Float'];
  currentReadingDate: Scalars['DateTime'];
  attachments?: Maybe<Array<Scalars['Upload']>>;
};

export type MeterSummary = {
  __typename?: 'MeterSummary';
  outstandingAmt: Scalars['Float'];
  noOfMeter: Scalars['Float'];
};

export type MeterXRefUseTotalsView = {
  __typename?: 'MeterXRefUseTotalsView';
  UnitID: Scalars['Float'];
  UnitNo?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Float']>;
  MeterTypeID: Scalars['Float'];
  PropertyID: Scalars['Float'];
  RefRecordID: Scalars['Float'];
  RentalID?: Maybe<Scalars['Float']>;
  DebtorID?: Maybe<Scalars['Float']>;
  BuildUpArea?: Maybe<Scalars['Float']>;
};

export type MeterXRefView = {
  __typename?: 'MeterXRefView';
  MeterXRefID: Scalars['Float'];
  ApportionModeStringCode?: Maybe<Scalars['String']>;
  UnitID: Scalars['Float'];
  UnitNo: Scalars['String'];
  AccountID?: Maybe<Scalars['Float']>;
  Name?: Maybe<Scalars['String']>;
  MeterTypeID: Scalars['Float'];
  MultiplyFactor: Scalars['Float'];
  MeterNo: Scalars['String'];
  PreviousReading: Scalars['Float'];
  PreviousDate: Scalars['DateTime'];
  CurrentReading?: Maybe<Scalars['Float']>;
  CurrentDate?: Maybe<Scalars['DateTime']>;
  ActiveStringCode: Scalars['String'];
  PropertyID: Scalars['Float'];
  RefTable: Scalars['String'];
  RefRecordID: Scalars['Float'];
  MeterID: Scalars['Float'];
  RentalID?: Maybe<Scalars['Float']>;
  DebtorID?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  CreateActivity: Scalars['Boolean'];
  AddNewContact: Scalars['Boolean'];
  createBooking: Scalars['Boolean'];
  createOpportunityBooking: Scalars['Boolean'];
  RejectDailySales: Scalars['Boolean'];
  ApproveDailySales: Scalars['Boolean'];
  addPosSubmission: Scalars['Boolean'];
  updatePosSubmission: Scalars['Boolean'];
  generateDocNum: Scalars['String'];
  GenerateSerialNumber: Array<Scalars['String']>;
  SaveMeterReading: Scalars['Boolean'];
  SaveMeterMasterReading: Scalars['Boolean'];
  updateOpportunity: Scalars['Boolean'];
  CreateAssignment: Scalars['Boolean'];
  DeleteAssignmentById: Scalars['Boolean'];
  AddRoutineInspection: Scalars['Boolean'];
  UpdateReadStatusNotificationByID: Scalars['Boolean'];
  ApproveOrReject: ApproveOrRejectOutput;
  changePassword: Scalars['Boolean'];
};


export type MutationCreateActivityArgs = {
  Input: NewActivityInputType;
  prospectId: Scalars['Float'];
};


export type MutationAddNewContactArgs = {
  AddNewContactInputModel: AddNewContactInputModel;
};


export type MutationCreateBookingArgs = {
  prospectId?: Maybe<Scalars['Float']>;
  bookingForm: BookingFormInputType;
  propertyId: Scalars['Float'];
};


export type MutationCreateOpportunityBookingArgs = {
  opportunityForm: OpportunityFormInputType;
  propertyId: Scalars['Float'];
};


export type MutationRejectDailySalesArgs = {
  Remark: Scalars['String'];
  SubmissionIds: Array<Scalars['Float']>;
};


export type MutationApproveDailySalesArgs = {
  Remark: Scalars['String'];
  SubmissionIds: Array<Scalars['Float']>;
};


export type MutationAddPosSubmissionArgs = {
  PosTradeSalesInput?: Maybe<Array<PosTradeSalesInputType>>;
  PosTrxInput: Array<PosTrxInputType>;
  PosSubmissionInput: PosSubmissionInputType;
};


export type MutationUpdatePosSubmissionArgs = {
  PosTradeSalesInput?: Maybe<Array<PosTradeSalesInputType>>;
  PosTrxInput: Array<PosTrxInputType>;
  PosSubmissionInput: PosSubmissionInputType;
  SubmissionId: Scalars['Float'];
};


export type MutationGenerateDocNumArgs = {
  DocCodeId: Scalars['String'];
  CompanyID: Scalars['Float'];
};


export type MutationGenerateSerialNumberArgs = {
  messageInfo: Scalars['String'];
  isAgain: Scalars['Boolean'];
  serialNumber: Scalars['Float'];
  resourceValue: Scalars['String'];
  docCodeId: Scalars['String'];
  companyId: Scalars['Float'];
};


export type MutationSaveMeterReadingArgs = {
  MeterInput: SaveMeterReadingInputModel;
};


export type MutationSaveMeterMasterReadingArgs = {
  MeterInput: SaveMeterMasterReadingInputModel;
};


export type MutationUpdateOpportunityArgs = {
  targetClosing?: Maybe<Scalars['DateTime']>;
  editOpportunityForm: EditOpportunityFormInputType;
  prospectId: Scalars['Float'];
};


export type MutationCreateAssignmentArgs = {
  prospectId: Scalars['Float'];
  assignmentIds: Array<Scalars['Float']>;
};


export type MutationDeleteAssignmentByIdArgs = {
  assignmentId: Scalars['Float'];
};


export type MutationAddRoutineInspectionArgs = {
  CheckDataInputModel: CheckDataInputModel;
};


export type MutationUpdateReadStatusNotificationByIdArgs = {
  RecordID: Scalars['String'];
};


export type MutationApproveOrRejectArgs = {
  TodoType: Scalars['String'];
  Remark: Scalars['String'];
  UserId: Scalars['Float'];
  Action: Scalars['String'];
  TodoRecord: Array<Scalars['String']>;
};


export type MutationChangePasswordArgs = {
  NewPassword: Scalars['String'];
  OldPassword: Scalars['String'];
};

export type NewActivityInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  followUpType?: Maybe<Scalars['Float']>;
  followUpDate?: Maybe<Scalars['DateTime']>;
  nextFollowUpDate?: Maybe<Scalars['DateTime']>;
  salesPersonnel?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
};

export type Next12MonthsOccupancyOutput = {
  __typename?: 'Next12MonthsOccupancyOutput';
  dateData?: Maybe<Scalars['String']>;
  ActiveContractArea?: Maybe<Scalars['Float']>;
  ProjectionArea?: Maybe<Scalars['Float']>;
  TotalGLAArea?: Maybe<Scalars['Float']>;
  BookedArea?: Maybe<Scalars['Float']>;
  PropertyID?: Maybe<Scalars['Float']>;
};

export type NotiData = {
  __typename?: 'NotiData';
  title?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  recordId?: Maybe<Scalars['String']>;
  recordStatus?: Maybe<Scalars['String']>;
};

export type NumberOfMeterTypeByRental = {
  __typename?: 'NumberOfMeterTypeByRental';
  rentalId: Scalars['Float'];
  noOfMeterType: Scalars['Float'];
};

export type OccupancyStatistics = {
  __typename?: 'OccupancyStatistics';
  UnityTypeID?: Maybe<Scalars['Float']>;
  LeasedCount?: Maybe<Scalars['Float']>;
  LeasedArea?: Maybe<Scalars['Float']>;
  BookedCount?: Maybe<Scalars['Float']>;
  BookedArea?: Maybe<Scalars['Float']>;
  AvailableCount?: Maybe<Scalars['Float']>;
  AvailableArea?: Maybe<Scalars['Float']>;
  ActiveCount?: Maybe<Scalars['Float']>;
  ActiveArea?: Maybe<Scalars['Float']>;
  GrandTotalArea?: Maybe<Scalars['Float']>;
  GrandTotalCount?: Maybe<Scalars['Float']>;
  TitleCN?: Maybe<Scalars['String']>;
  PropertyID?: Maybe<Scalars['Float']>;
};

export type OpportunityFormInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  tenantId?: Maybe<Scalars['Float']>;
  unitList: Array<UnitDetails>;
  tenant?: Maybe<TenantInputType>;
  sourceId: Scalars['Float'];
  brandId?: Maybe<Scalars['Float']>;
  urgency?: Maybe<Scalars['String']>;
  interestLevelId: Scalars['Float'];
  budget: Scalars['Float'];
  spaceArea: Scalars['Float'];
  closingDate?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  remarks: Scalars['String'];
  attachments?: Maybe<Array<AttachmentsInputType>>;
  logoAttachment?: Maybe<Array<AttachmentsInputType>>;
};

export type ParameterDataEntity = {
  __typename?: 'ParameterDataEntity';
  parameterId: Scalars['Float'];
  class?: Maybe<Scalars['String']>;
  applicationCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  titleCn?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['String'];
  createDate: Scalars['String'];
  modifyUserId: Scalars['String'];
  modifyDate: Scalars['String'];
  groupId?: Maybe<Scalars['Float']>;
  localKey?: Maybe<Scalars['String']>;
};

export type PolicyCoverage = {
  __typename?: 'PolicyCoverage';
  pricePolicyId?: Maybe<Scalars['Float']>;
  blockName?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
  floorNo?: Maybe<Scalars['String']>;
  leasableArea?: Maybe<Scalars['Float']>;
  unitRate?: Maybe<Scalars['Float']>;
};

export type PopupLstEleView = {
  __typename?: 'PopupLstEleView';
  popupLstElementId?: Maybe<Scalars['Float']>;
  popupLstId?: Maybe<Scalars['Float']>;
  parentPopupLstElementId?: Maybe<Scalars['Float']>;
  applicationId?: Maybe<Scalars['Float']>;
  isDefault?: Maybe<Scalars['String']>;
  isSystem?: Maybe<Scalars['String']>;
  isSearchable?: Maybe<Scalars['String']>;
  elementCode?: Maybe<Scalars['String']>;
  popType?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Float']>;
  recordStatus?: Maybe<Scalars['String']>;
  titleCn?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleStringCode?: Maybe<Scalars['String']>;
  directChildCount?: Maybe<Scalars['Float']>;
};

export type PopupLstElementEntity = {
  __typename?: 'PopupLstElementEntity';
  popUpLstElementId: Scalars['Float'];
  applicationId?: Maybe<Scalars['Float']>;
  popUpLstId: Scalars['Float'];
  parentPopUpLstElementId?: Maybe<Scalars['Float']>;
  isDefault: Scalars['String'];
  isSystem?: Maybe<Scalars['String']>;
  elementCode?: Maybe<Scalars['String']>;
  titleCn?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleStringCode: Scalars['String'];
  rank?: Maybe<Scalars['Float']>;
  isSearchable: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
  popType?: Maybe<Scalars['String']>;
  rootPopUpLstElementId?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  posTradeSales: Array<PosTradeSalesEntity>;
  chargeDetail: ChargeDetailEntity;
  turnoverCategory: Array<TurnoverCategoryEntity>;
  prospect: Array<LeaseMercProspectData>;
  prospectOfSource: LeaseMercProspectData;
  prospectOfInterestLevel: LeaseMercProspectData;
  accountOfProfession: CommonSetupAccountData;
  activityOfActivityType: LeaseMercActivityData;
  brandOfIndustry?: Maybe<LeaseMercBrandData>;
};

export enum PopupLstTypeEnum {
  SrPublicArea = 'SRPublicArea',
  SrRequestType = 'SRRequestType',
  RtBusinessCategory = 'RTBusinessCategory',
  Nationality = 'Nationality',
  IdentityType = 'IdentityType',
  Nation = 'Nation',
  SexType = 'SexType',
  Industry = 'Industry',
  Profession = 'Profession',
  Relationship = 'Relationship',
  OpportunitySucessRate = 'OpportunitySucessRate',
  Probability = 'Probability',
  OpportunitySource = 'OpportunitySource',
  ActivityType = 'ActivityType',
  Common = 'Common',
  Urgency = 'Urgency'
}

export type PosDebtorEntity = {
  __typename?: 'PosDebtorEntity';
  posId: Scalars['Float'];
  debtorId: Scalars['Float'];
  posName?: Maybe<Scalars['String']>;
  posNumber?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  posTrx?: Maybe<PosTrxEntity>;
};

export type PosDebtorInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  debtorId: Scalars['Float'];
  posName?: Maybe<Scalars['String']>;
  posNumber?: Maybe<Scalars['Float']>;
};

export type PosSubmissionEntity = {
  __typename?: 'PosSubmissionEntity';
  submissionId: Scalars['Float'];
  propertyId: Scalars['Float'];
  accountId: Scalars['Float'];
  debtorId: Scalars['Float'];
  rentalId: Scalars['Float'];
  transactionDate: Scalars['DateTime'];
  totalBillCount?: Maybe<Scalars['Float']>;
  totalVoucherCount?: Maybe<Scalars['Float']>;
  totalNettSalesAmt?: Maybe<Scalars['Float']>;
  totalTaxAmt?: Maybe<Scalars['Float']>;
  totalServiceCharges?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
  remarks?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  rental: LeaseContRentalContractData;
  posTrx?: Maybe<Array<PosTrxEntity>>;
  posTradeSales?: Maybe<Array<PosTradeSalesEntity>>;
  turnover: TurnoverSummaryEntity;
  debtor: LeaseArDebtorData;
  property?: Maybe<LeaseProSetPropertyData>;
  account: CommonSetupAccountData;
  RejectedBy?: Maybe<DailySalesOutput>;
};

export type PosSubmissionInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  propertyId: Scalars['Float'];
  accountId: Scalars['Float'];
  debtorId?: Maybe<Scalars['Float']>;
  rentalId: Scalars['Float'];
  transactionDate: Scalars['DateTime'];
  totalBillCount?: Maybe<Scalars['Float']>;
  totalVoucherCount?: Maybe<Scalars['Float']>;
  totalNettSalesAmt?: Maybe<Scalars['Float']>;
  totalTaxAmt?: Maybe<Scalars['Float']>;
  totalServiceCharges?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
  remarks?: Maybe<Scalars['String']>;
};

export type PosTradeSalesEntity = {
  __typename?: 'PosTradeSalesEntity';
  tradeSalesId: Scalars['Float'];
  submissionId: Scalars['Float'];
  tradeCategoryId: Scalars['Float'];
  salesAmt?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  popUpLstElement: PopupLstElementEntity;
  posSubmission: PosSubmissionEntity;
  chargeDetail: ChargeDetailEntity;
};

export type PosTradeSalesInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  submissionId?: Maybe<Scalars['Float']>;
  tradeCategoryId: Scalars['Float'];
  salesAmt?: Maybe<Scalars['Float']>;
};

export type PosTrxEntity = {
  __typename?: 'PosTrxEntity';
  posTrxId: Scalars['Float'];
  submissionId: Scalars['Float'];
  posId: Scalars['Float'];
  cashAmt?: Maybe<Scalars['Float']>;
  visaAmt?: Maybe<Scalars['Float']>;
  masterAmt?: Maybe<Scalars['Float']>;
  amexAmt?: Maybe<Scalars['Float']>;
  jcbAmt?: Maybe<Scalars['Float']>;
  debitAmt?: Maybe<Scalars['Float']>;
  mallVoucherAmt?: Maybe<Scalars['Float']>;
  othersAmt?: Maybe<Scalars['Float']>;
  billCount?: Maybe<Scalars['Float']>;
  voucherCount?: Maybe<Scalars['Float']>;
  nettSalesAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  serviceCharges?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  posSubmission: PosSubmissionEntity;
  posDebtor?: Maybe<PosDebtorEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  AttachmentsByTrxId?: Maybe<Array<DailySalesOutput>>;
};


export type PosTrxEntityAttachmentsByTrxIdArgs = {
  AttachmentIds?: Maybe<Array<Scalars['Float']>>;
};

export type PosTrxInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  submissionId?: Maybe<Scalars['Float']>;
  posTrxId?: Maybe<Scalars['Float']>;
  posId: Scalars['Float'];
  posName: Scalars['String'];
  posNumber?: Maybe<Scalars['Float']>;
  cashAmt?: Maybe<Scalars['Float']>;
  visaAmt?: Maybe<Scalars['Float']>;
  masterAmt?: Maybe<Scalars['Float']>;
  amexAmt?: Maybe<Scalars['Float']>;
  jcbAmt?: Maybe<Scalars['Float']>;
  debitAmt?: Maybe<Scalars['Float']>;
  mallVoucherAmt?: Maybe<Scalars['Float']>;
  othersAmt?: Maybe<Scalars['Float']>;
  billCount?: Maybe<Scalars['Float']>;
  voucherCount?: Maybe<Scalars['Float']>;
  nettSalesAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  serviceCharges?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  hiddenNettSales?: Maybe<Scalars['String']>;
  hiddenTotalSales?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<AttachmentsInputType>>;
};

export type PrivilAccessDataView = {
  __typename?: 'PrivilAccessDataView';
  RefRecordID?: Maybe<Scalars['Float']>;
  AccessRightName?: Maybe<Scalars['String']>;
  ModifyDate?: Maybe<Scalars['DateTime']>;
  AccessRight?: Maybe<Scalars['Float']>;
  ProspectID?: Maybe<Scalars['Float']>;
  prospect: LeaseMercProspectData;
};

export type Query = {
  __typename?: 'Query';
  getAllAccounts: Array<CommonSetupAccountData>;
  getAccountGroup: Array<CommonSetupAccountGroupData>;
  GetActivityByProspect?: Maybe<Array<LeaseMercActivityData>>;
  GetAgent?: Maybe<Array<LeaseMercAgentData>>;
  GetAgentByUserId?: Maybe<LeaseMercAgentData>;
  GetFilesByRefId: Array<DailySalesOutput>;
  GetAttachmentsByRefTableRefIds?: Maybe<Array<FilesOutput>>;
  GetAttachmentForEdit: Array<AttachementOutput>;
  GetBookingListByPropertyId?: Maybe<Array<LeaseMercBookData>>;
  GetBookingDataById?: Maybe<LeaseMercBookData>;
  GetDesignation?: Maybe<Array<CommonSetupPopuplstElemData>>;
  GetBookingListByProspectId?: Maybe<Array<LeaseMercBookData>>;
  getBrandList: Array<LeaseBrandView>;
  GetBrand?: Maybe<Array<LeaseMercBrandData>>;
  businessDate: Scalars['String'];
  getDailySalesById: TurnoverSummaryEntity;
  getPosSubmissionByDate: Array<PosSubmissionEntity>;
  isHasRejected: Scalars['Boolean'];
  getDocNumFormatByCompanyID?: Maybe<CommonConfigDocCodeFormatData>;
  getDocNumFormatByCompanyID2?: Maybe<Array<CommonConfigDocCodeFormatData>>;
  getLastRunNumByCompanyIDWithLock?: Maybe<CommonConfigDocCodeTempData>;
  GetLetter?: Maybe<Scalars['String']>;
  GetCommonSetupPopupData: Array<CommonSetupPopuplstElemData>;
  popupLstElementByPopupType: Array<PopupLstElementEntity>;
  getPopupLstElement?: Maybe<Array<PopupLstEleView>>;
  getBillItemByItemCode: Array<LeaseArBillItemData>;
  getCommonSetup: ParameterDataEntity;
  meterListingByBlockIdAndMeterTypeId: Array<SubMeterListing>;
  meterMasterListingByPropertyIdAndMeterTypeId: Array<LeaseMeterMeterMasterData>;
  meterByIds?: Maybe<Array<MeterDetail>>;
  meterMasterByIds?: Maybe<Array<MeterMasterDetail>>;
  getMeterAttachmentByIds?: Maybe<Array<MeterAttachmentPopUpOutput>>;
  meterTypeByPropertyIdAndMeterTypeId: LeaseMeterMeterTypeData;
  GetOppurtunityByUser?: Maybe<Array<LeaseMercProspectData>>;
  GetOppurtunityByProspectId?: Maybe<LeaseMercProspectData>;
  GetOpportunityAttachment?: Maybe<Array<CommonSetupDocExtendData>>;
  GetAssignmentByProspect?: Maybe<Array<LeaseMercPrivilAccessData>>;
  PropertyById: LeaseProSetPropertyData;
  GetFloorVersionData?: Maybe<FloorVersionData>;
  UnitById: LeaseProSetUnitData;
  UnitByIds: Array<LeaseProSetUnitData>;
  PropertyListByUserIds: Array<CommonSetupProjectResData>;
  unitByPropertyId: Array<LeaseProSetUnitData>;
  ContractByProperty?: Maybe<Array<ContractInfo>>;
  getContractByPropertyId?: Maybe<Array<LeaseContRentalContractData>>;
  GetContractByProspect?: Maybe<Array<LeaseContRentalContractData>>;
  getContractDetailsByContractId?: Maybe<ContractDetailsOutput>;
  getCustomerContactDetails?: Maybe<CustomerView>;
  GetContractAttachment?: Maybe<Array<CommonSetupDocExtendData>>;
  GetContractAttachmentByRentalId?: Maybe<Array<ContractAttachments>>;
  GetContCharges?: Maybe<Array<ContChargesView>>;
  GetChargeDetail?: Maybe<Array<ChargeDetailView>>;
  getTenantSummaryByDebtorIDs?: Maybe<Array<TenantSummaryView>>;
  GetRoutineInspectionListingByPropertyId?: Maybe<Array<RoutineInspectionListing>>;
  GetTotalRoutineInspectionCountByPropertyId?: Maybe<RoutineInspectCount>;
  GetRoutineInspectionDetailByCheckId?: Maybe<Array<LeaseOperaCheckDetailData>>;
  GetRoutineInspectionAttachmentByCheckDetaildId?: Maybe<Array<RoutineInspectionAttachments>>;
  GetFdbFileContentByFileId?: Maybe<FdbFileContent>;
  GetInspectionCategory?: Maybe<Array<PopupLstElementEntity>>;
  GetInspectionItemsByPropertyByTypeId?: Maybe<Array<LeaseOperaCheckItemData>>;
  GetActiveUnitsByPropertyId?: Maybe<Array<ActiveUnits>>;
  debtorByIds: Array<LeaseArDebtorData>;
  GetTenantPaymentTransactionsGatewayByPropertyId: Array<TenantPaymentTransactionsOutput>;
  GetUserById?: Maybe<CommonSetupUserData>;
  GetTodoById?: Maybe<CoreTodoRecordData>;
  GetTodoByTodoRecord?: Maybe<CoreTodoRecordData>;
  GetTodoByUserID?: Maybe<Array<CoreTodoRecordData>>;
  GetTodoOuterListByUserID?: Maybe<Array<TodosOuterList>>;
  GetTodoListChildByTodoTypeCode?: Maybe<Array<TodoItems>>;
  GetTodoListByUserID?: Maybe<Array<TodosList>>;
  GetFileDataById?: Maybe<FileOutput>;
  GetBrandIntentionById?: Maybe<LeaseMercBrandIntentionData>;
  GetBrandProvideFormatById?: Maybe<LeaseMercBrandProvideFormatData>;
  GetBrandAllocDuringPrepById?: Maybe<Array<BrandAllocDuringPrepData>>;
  GetContractById?: Maybe<LeaseContRentalContractData>;
  GetRentReviewById?: Maybe<LeaseContRentReviewData>;
  GetContractClosureById?: Maybe<LeaseCtSettlement>;
  GetPolicyById?: Maybe<LeaseLpLeaseClauseData>;
  GetLeasingPolicyById?: Maybe<LeaseLpLeaseClauseData>;
  GetPricingPolicyById?: Maybe<LeaseLpPricePolicyData>;
  GetRevenueTargetingPolicyById?: Maybe<LeaseLpRevenueQuotaData>;
  GetRebateById?: Maybe<LeaseArDiscountData>;
  GetBillAdjById?: Maybe<LeaseArTrxData>;
  GetRefundReqById?: Maybe<LeaseArJournalData>;
  GetTodoAndNotiCountByUserID?: Maybe<TodoAndNotiCount>;
  GetRenovationByID?: Maybe<LeaseDecoraFitoutData>;
  GetEventByID?: Maybe<LeaseMarCampaignData>;
  GetNotificationByUserID?: Maybe<Array<NotiData>>;
  userByIds: Array<CommonSetupUserData>;
  userByPropertyId: Array<CommonSetupUserData>;
  verifyUser: UserOutput;
  getAllUsers: Array<CommonSetupUserData>;
  getUsersByLoginName: Array<CommonSetupUserData>;
};


export type QueryGetActivityByProspectArgs = {
  prospectId: Scalars['Float'];
};


export type QueryGetFilesByRefIdArgs = {
  posTrxId: Array<Scalars['Float']>;
  refTable: Scalars['String'];
};


export type QueryGetAttachmentsByRefTableRefIdsArgs = {
  refTable: Scalars['String'];
  refRecordId: Scalars['Float'];
};


export type QueryGetAttachmentForEditArgs = {
  refTable: Scalars['String'];
  refRecordId: Scalars['Float'];
};


export type QueryGetBookingListByPropertyIdArgs = {
  PropertyID: Scalars['Float'];
};


export type QueryGetBookingDataByIdArgs = {
  BookID: Scalars['Float'];
};


export type QueryGetBookingListByProspectIdArgs = {
  ProspectID: Scalars['Float'];
};


export type QueryGetDailySalesByIdArgs = {
  TurnoverSummaryId: Scalars['Float'];
};


export type QueryGetPosSubmissionByDateArgs = {
  RecordStatus: Array<Scalars['String']>;
  Date: Scalars['DateTime'];
  PropertyId: Scalars['Float'];
};


export type QueryIsHasRejectedArgs = {
  Date: Scalars['DateTime'];
  PropertyId: Scalars['Float'];
};


export type QueryGetDocNumFormatByCompanyIdArgs = {
  DocCodeID: Scalars['String'];
  CompanyID: Scalars['Float'];
};


export type QueryGetDocNumFormatByCompanyId2Args = {
  DocCodeID: Scalars['String'];
  CompanyID: Scalars['Float'];
};


export type QueryGetLastRunNumByCompanyIdWithLockArgs = {
  like: Scalars['String'];
  DocCodeID: Scalars['String'];
  CompanyID: Scalars['Float'];
};


export type QueryGetLetterArgs = {
  rentalId: Scalars['Float'];
};


export type QueryGetCommonSetupPopupDataArgs = {
  CommonSetupPopuplstTypeEnum: CommonSetupPopuplstTypeEnum;
};


export type QueryPopupLstElementByPopupTypeArgs = {
  PopupLstTypeEnum: PopupLstTypeEnum;
  Application: ApplicationEnum;
};


export type QueryGetPopupLstElementArgs = {
  Application: ApplicationEnum;
  popType: PopupLstTypeEnum;
};


export type QueryGetBillItemByItemCodeArgs = {
  ItemCode?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetCommonSetupArgs = {
  name: CommonSetupName;
  applicationCode: ApplicationEnum;
  class: CommonSetupClass;
};


export type QueryMeterListingByBlockIdAndMeterTypeIdArgs = {
  MeterTypeId: Scalars['Float'];
  BlockId: Scalars['Float'];
};


export type QueryMeterMasterListingByPropertyIdAndMeterTypeIdArgs = {
  MeterTypeId: Scalars['Float'];
  PropertyId: Scalars['Float'];
};


export type QueryMeterByIdsArgs = {
  MeterIds: Array<Scalars['Float']>;
};


export type QueryMeterMasterByIdsArgs = {
  MeterIds: Array<Scalars['Float']>;
};


export type QueryGetMeterAttachmentByIdsArgs = {
  MeterIds: Array<Scalars['Float']>;
};


export type QueryMeterTypeByPropertyIdAndMeterTypeIdArgs = {
  MeterTypeId: Scalars['Float'];
  PropertyId: Scalars['Float'];
};


export type QueryGetOppurtunityByUserArgs = {
  propertyId: Scalars['Float'];
};


export type QueryGetOppurtunityByProspectIdArgs = {
  prospectId: Scalars['Float'];
};


export type QueryGetOpportunityAttachmentArgs = {
  prospectId: Scalars['Float'];
};


export type QueryGetAssignmentByProspectArgs = {
  prospectId: Scalars['Float'];
};


export type QueryPropertyByIdArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryGetFloorVersionDataArgs = {
  floorId: Scalars['Float'];
  blockId: Scalars['Float'];
};


export type QueryUnitByIdArgs = {
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  UnitId: Scalars['Float'];
};


export type QueryUnitByIdsArgs = {
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  UnitIds: Array<Scalars['Float']>;
};


export type QueryUnitByPropertyIdArgs = {
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  PropertyId: Scalars['Float'];
};


export type QueryContractByPropertyArgs = {
  ContractbyPropertyInput: ContractbyPropertyInput;
};


export type QueryGetContractByPropertyIdArgs = {
  propertyId: Scalars['Float'];
};


export type QueryGetContractByProspectArgs = {
  prospectId: Scalars['Float'];
};


export type QueryGetContractDetailsByContractIdArgs = {
  rentalId: Scalars['Float'];
};


export type QueryGetCustomerContactDetailsArgs = {
  contactId: Scalars['Float'];
};


export type QueryGetContractAttachmentArgs = {
  rentalId: Scalars['Float'];
};


export type QueryGetContractAttachmentByRentalIdArgs = {
  referenceTable?: Maybe<Scalars['String']>;
  rentalId: Scalars['Float'];
};


export type QueryGetContChargesArgs = {
  contractChargeId?: Maybe<Scalars['Float']>;
  mode?: Maybe<Scalars['String']>;
  rentalId?: Maybe<Scalars['Float']>;
};


export type QueryGetChargeDetailArgs = {
  contractChargeId: Scalars['Float'];
};


export type QueryGetTenantSummaryByDebtorIDsArgs = {
  debtorIds: Scalars['String'];
};


export type QueryGetRoutineInspectionListingByPropertyIdArgs = {
  IsSearch: Scalars['Boolean'];
  TenantName: Scalars['String'];
  CheckIds: Array<Scalars['Float']>;
  PropertyId: Scalars['Float'];
};


export type QueryGetTotalRoutineInspectionCountByPropertyIdArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryGetRoutineInspectionDetailByCheckIdArgs = {
  checkId: Scalars['Float'];
};


export type QueryGetRoutineInspectionAttachmentByCheckDetaildIdArgs = {
  checkDetailId: Scalars['Float'];
};


export type QueryGetFdbFileContentByFileIdArgs = {
  FileID: Scalars['String'];
};


export type QueryGetInspectionCategoryArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryGetInspectionItemsByPropertyByTypeIdArgs = {
  TypeId: Scalars['Float'];
  PropertyId: Scalars['Float'];
};


export type QueryGetActiveUnitsByPropertyIdArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryDebtorByIdsArgs = {
  DebtorIds: Array<Scalars['Float']>;
};


export type QueryGetTenantPaymentTransactionsGatewayByPropertyIdArgs = {
  lPropId: Scalars['Float'];
};


export type QueryGetUserByIdArgs = {
  UserID: Scalars['Float'];
};


export type QueryGetTodoByIdArgs = {
  TodoID: Scalars['String'];
};


export type QueryGetTodoByTodoRecordArgs = {
  TodoRecord: Scalars['String'];
};


export type QueryGetTodoByUserIdArgs = {
  UserID: Scalars['Float'];
};


export type QueryGetTodoOuterListByUserIdArgs = {
  PropertyID: Scalars['Float'];
  UserID: Scalars['Float'];
};


export type QueryGetTodoListChildByTodoTypeCodeArgs = {
  TodoTypeCode: Scalars['String'];
  PropertyID: Scalars['Float'];
  UserID: Scalars['Float'];
};


export type QueryGetTodoListByUserIdArgs = {
  PropertyID: Scalars['Float'];
  UserID: Scalars['Float'];
};


export type QueryGetFileDataByIdArgs = {
  FileID: Scalars['String'];
};


export type QueryGetBrandIntentionByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetBrandProvideFormatByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetBrandAllocDuringPrepByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetContractByIdArgs = {
  RentalID: Scalars['Float'];
};


export type QueryGetRentReviewByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetContractClosureByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetPolicyByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetLeasingPolicyByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetPricingPolicyByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetRevenueTargetingPolicyByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetRebateByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetBillAdjByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetRefundReqByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetTodoAndNotiCountByUserIdArgs = {
  PropertyID: Scalars['Float'];
  UserID: Scalars['Float'];
};


export type QueryGetRenovationByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetEventByIdArgs = {
  ID: Scalars['Float'];
};


export type QueryGetNotificationByUserIdArgs = {
  PropertyID: Scalars['Float'];
  UserID: Scalars['Float'];
};


export type QueryUserByIdsArgs = {
  UserIds: Array<Scalars['Float']>;
};


export type QueryUserByPropertyIdArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryVerifyUserArgs = {
  Password: Scalars['String'];
  LoginName: Scalars['String'];
};


export type QueryGetUsersByLoginNameArgs = {
  LoginNames: Array<Scalars['String']>;
};

export type RenoData = {
  __typename?: 'RenoData';
  fitoutId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  contractNo?: Maybe<Scalars['String']>;
};

export type RentFreeOutput = {
  __typename?: 'RentFreeOutput';
  rentlId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  rentFreeStartDate?: Maybe<Scalars['DateTime']>;
  rentFreeEndDate?: Maybe<Scalars['DateTime']>;
};

export type RoutineInspectCount = {
  __typename?: 'RoutineInspectCount';
  routineInspectCount?: Maybe<Scalars['Float']>;
};

export type RoutineInspectionAttachments = {
  __typename?: 'RoutineInspectionAttachments';
  base64File?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
};

export type RoutineInspectionFileContent = {
  __typename?: 'RoutineInspectionFileContent';
  fileId?: Maybe<Scalars['String']>;
  base64File?: Maybe<Scalars['String']>;
};

export type RoutineInspectionListing = {
  __typename?: 'RoutineInspectionListing';
  checkId?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
  tenantName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
};

export type SaveMeterMasterReadingInputModel = {
  propertyId: Scalars['Float'];
  meterId: Scalars['Float'];
  currentReading: Scalars['Float'];
  currentReadingDate: Scalars['DateTime'];
  attachments?: Maybe<Array<Scalars['Upload']>>;
};

export type SaveMeterReadingInputModel = {
  propertyId: Scalars['Float'];
  meterReading: Array<MeterReadingInputModel>;
};

export type SubMeterListing = {
  __typename?: 'SubMeterListing';
  Name?: Maybe<Scalars['String']>;
  RentalID: Scalars['Float'];
  TotalUsageRate?: Maybe<Scalars['Float']>;
  TotalPreviousReading?: Maybe<Scalars['Float']>;
  UnitNo: Scalars['String'];
  MeterCode?: Maybe<Scalars['String']>;
  MeterID: Scalars['String'];
  PreviousDate: Scalars['DateTime'];
  ItemCode: Scalars['String'];
  TypeName: Scalars['String'];
  AttachmentCount: Scalars['Float'];
};

export type TenantGtoOutput = {
  __typename?: 'TenantGtoOutput';
  rentalId?: Maybe<Scalars['Float']>;
  gtoCount?: Maybe<Scalars['Float']>;
};

export type TenantInputType = {
  recordStatus?: Maybe<Scalars['String']>;
  createUserId?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['DateTime']>;
  modifyUserId?: Maybe<Scalars['Float']>;
  modifyDate?: Maybe<Scalars['DateTime']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  tenantName?: Maybe<Scalars['String']>;
  tenantPhone?: Maybe<Scalars['String']>;
  tenantEmail?: Maybe<Scalars['String']>;
  tenantIdType?: Maybe<Scalars['Float']>;
  tenantIdNo?: Maybe<Scalars['String']>;
  tenantNationality?: Maybe<Scalars['Float']>;
  tenantRace?: Maybe<Scalars['Float']>;
  tenantGender?: Maybe<Scalars['Float']>;
  tenantDob?: Maybe<Scalars['DateTime']>;
  tenantIndustry?: Maybe<Scalars['Float']>;
  tenantDesignation?: Maybe<Scalars['Float']>;
  tenantWebsite?: Maybe<Scalars['String']>;
  tenantGstNo?: Maybe<Scalars['String']>;
  tenantGroup?: Maybe<Scalars['Float']>;
  tenantRemarks?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<Array<ContactPersonInputType>>;
};

export type TenantPaymentTransactionsOutput = {
  __typename?: 'TenantPaymentTransactionsOutput';
  amount: Scalars['Float'];
  count: Scalars['Float'];
  month: Scalars['String'];
};

export type TenantSummaryView = {
  __typename?: 'TenantSummaryView';
  DebtorID?: Maybe<Scalars['Float']>;
  TenantName?: Maybe<Scalars['String']>;
  contractLotNo?: Maybe<Scalars['String']>;
  recordstatus?: Maybe<Scalars['String']>;
  ContractStart?: Maybe<Scalars['String']>;
  ContractEnd?: Maybe<Scalars['String']>;
};

export type TodoAndNotiCount = {
  __typename?: 'TodoAndNotiCount';
  todoCount?: Maybe<Scalars['Float']>;
  notiCount?: Maybe<Scalars['Float']>;
};

export type TodoItems = {
  __typename?: 'TodoItems';
  parentTitle?: Maybe<Scalars['String']>;
  tid?: Maybe<Scalars['Float']>;
  todoTypeCode?: Maybe<Scalars['String']>;
  todoRecord?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  detail1?: Maybe<Scalars['String']>;
  detail2?: Maybe<Scalars['String']>;
  detail3?: Maybe<Scalars['Float']>;
};

export type Todos = {
  __typename?: 'Todos';
  TodoList?: Maybe<Array<Scalars['String']>>;
};

export type TodosList = {
  __typename?: 'TodosList';
  title?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
  routingUrl?: Maybe<Scalars['String']>;
  child?: Maybe<Array<TodoItems>>;
};

export type TodosOuterList = {
  __typename?: 'TodosOuterList';
  title?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
  routingUrl?: Maybe<Scalars['String']>;
  todoTypeCode?: Maybe<Scalars['String']>;
  child?: Maybe<Array<TodoItems>>;
};

export type TopTenOutstanding = {
  __typename?: 'TopTenOutstanding';
  AccountName?: Maybe<Scalars['String']>;
  TotalDue?: Maybe<Scalars['Float']>;
  Deposit?: Maybe<Scalars['Float']>;
  PropertyID?: Maybe<Scalars['Float']>;
};

export type Total = {
  __typename?: 'Total';
  pricePolicyId?: Maybe<Scalars['Float']>;
  blockName?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  leasableArea?: Maybe<Scalars['Float']>;
  unitRate?: Maybe<Scalars['Float']>;
};

export type Transactions = {
  __typename?: 'Transactions';
  ID: Scalars['Float'];
  TransactionID?: Maybe<Scalars['String']>;
  Amount?: Maybe<Scalars['Float']>;
  TransactionDate?: Maybe<Scalars['DateTime']>;
  RefNo?: Maybe<Scalars['String']>;
  DebtorID: Scalars['Float'];
  IsDeposit?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  receiptID?: Maybe<Scalars['Float']>;
  RecordStatus?: Maybe<Scalars['String']>;
  CreateUserID?: Maybe<Scalars['Float']>;
  CreateDate: Scalars['DateTime'];
  ModifyUserID?: Maybe<Scalars['Float']>;
  ModifyDate?: Maybe<Scalars['DateTime']>;
};

export type TransactionsDetails = {
  __typename?: 'TransactionsDetails';
  ID: Scalars['Float'];
  TransactionDetailsID: Scalars['String'];
  TransactionID: Scalars['String'];
  Amount?: Maybe<Scalars['Float']>;
  BillID?: Maybe<Scalars['Float']>;
  RecordStatus?: Maybe<Scalars['String']>;
  CreateUserID?: Maybe<Scalars['Float']>;
  CreateDate: Scalars['DateTime'];
  ModifyUserID?: Maybe<Scalars['Float']>;
  ModifyDate: Scalars['DateTime'];
};

export type TurnOverOutput = {
  __typename?: 'TurnOverOutput';
  rentlId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  contractLotNo?: Maybe<Scalars['String']>;
  billItem?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  differenceMethod?: Maybe<Scalars['String']>;
};

export type TurnoverCategoryEntity = {
  __typename?: 'TurnoverCategoryEntity';
  turnoverCategoryId: Scalars['Float'];
  turnoverSummaryId: Scalars['Float'];
  categoryId: Scalars['Float'];
  nettSalesAmt?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  turnover: TurnoverSummaryEntity;
  popUpLstElement?: Maybe<PopupLstElementEntity>;
};

export type TurnoverSummaryEntity = {
  __typename?: 'TurnoverSummaryEntity';
  turnoverSummaryId: Scalars['Float'];
  propertyId: Scalars['Float'];
  accountId: Scalars['Float'];
  rentalId: Scalars['Float'];
  rentalUnitId?: Maybe<Scalars['Float']>;
  transactionDate: Scalars['DateTime'];
  billCount?: Maybe<Scalars['Float']>;
  nettSalesAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  serviceCharges?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
  creditCardAmt?: Maybe<Scalars['Float']>;
  creditCardCharges?: Maybe<Scalars['Float']>;
  source: Scalars['String'];
  isEstimated?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refRecordId?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  debtorId: Scalars['Float'];
  voucherCount?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createUserId: Scalars['Float'];
  createDate: Scalars['DateTime'];
  modifyUserId: Scalars['Float'];
  modifyDate: Scalars['DateTime'];
  posSubmission?: Maybe<PosSubmissionEntity>;
  property: Array<LeaseProSetPropertyData>;
  turnoverCategory?: Maybe<Array<TurnoverCategoryEntity>>;
  debtor?: Maybe<LeaseArDebtorData>;
  rentalContract?: Maybe<LeaseContRentalContractData>;
  account?: Maybe<CommonSetupAccountData>;
};

export type UnitDetail = {
  __typename?: 'UnitDetail';
  CompanyID?: Maybe<Scalars['Float']>;
  PropertyID?: Maybe<Scalars['Float']>;
  ZoneID?: Maybe<Scalars['Float']>;
  ZoneNo?: Maybe<Scalars['String']>;
  ZoneName?: Maybe<Scalars['String']>;
  BlockID?: Maybe<Scalars['Float']>;
  BlockNo?: Maybe<Scalars['String']>;
  BlockName?: Maybe<Scalars['String']>;
  Floor?: Maybe<Scalars['Float']>;
  FloorNo?: Maybe<Scalars['String']>;
  UnitID?: Maybe<Scalars['Float']>;
  UnitNo?: Maybe<Scalars['String']>;
  UnitTypeID?: Maybe<Scalars['Float']>;
  UnitType?: Maybe<Scalars['String']>;
  UnitTypeCode?: Maybe<Scalars['String']>;
  BuildUpArea?: Maybe<Scalars['Float']>;
  InteriorArea?: Maybe<Scalars['Float']>;
  UsableArea?: Maybe<Scalars['Float']>;
  RentalArea?: Maybe<Scalars['Float']>;
  ActualRentalArea?: Maybe<Scalars['Float']>;
  LeaseArea?: Maybe<Scalars['Float']>;
  UnitHeight?: Maybe<Scalars['Float']>;
  CellNo?: Maybe<Scalars['Float']>;
  UnitSeq?: Maybe<Scalars['Float']>;
  ColSpan?: Maybe<Scalars['Float']>;
  AdZoneTypeID?: Maybe<Scalars['Float']>;
  AdZoneType?: Maybe<Scalars['String']>;
  AdZoneName?: Maybe<Scalars['String']>;
  AdZoneLocation?: Maybe<Scalars['String']>;
  NoOfAd?: Maybe<Scalars['Float']>;
  AdZoneDimension?: Maybe<Scalars['String']>;
  AdZoneIntro?: Maybe<Scalars['String']>;
  RecordStatus?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  ExpiryDate?: Maybe<Scalars['DateTime']>;
  BusinessTypeID?: Maybe<Scalars['Float']>;
  BusinessType?: Maybe<Scalars['String']>;
  Remark?: Maybe<Scalars['String']>;
  SaleDate?: Maybe<Scalars['DateTime']>;
  HouseNo?: Maybe<Scalars['String']>;
  Price?: Maybe<Scalars['Float']>;
  TotalAmt?: Maybe<Scalars['Float']>;
  AdditiveTypeID?: Maybe<Scalars['Float']>;
  AdditiveType?: Maybe<Scalars['String']>;
  AdditiveTypeCode?: Maybe<Scalars['String']>;
  UnitCategory?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
  BuildUpAreaPrice?: Maybe<Scalars['Float']>;
  OwnerName?: Maybe<Scalars['String']>;
  OwnerNo?: Maybe<Scalars['String']>;
  BusinessRecordStatus?: Maybe<Scalars['String']>;
  LeasedEndDate?: Maybe<Scalars['DateTime']>;
  FloorID?: Maybe<Scalars['Float']>;
  MeasureUnitType?: Maybe<Scalars['String']>;
};

export type UnitDetails = {
  BusinessRecordStatus?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  LeaseArea?: Maybe<Scalars['Float']>;
  RentalArea?: Maybe<Scalars['Float']>;
  UnitHeight?: Maybe<Scalars['Float']>;
  UnitID?: Maybe<Scalars['Float']>;
  UnitNo?: Maybe<Scalars['String']>;
  UnitType?: Maybe<Scalars['String']>;
  isAllowSelect?: Maybe<Scalars['Boolean']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  LeasedEndDate?: Maybe<Scalars['DateTime']>;
  Price?: Maybe<Scalars['Float']>;
  MeasureUnitType?: Maybe<Scalars['String']>;
};

export type UnitStatusSummary = {
  __typename?: 'UnitStatusSummary';
  VacantCount?: Maybe<Scalars['Float']>;
  BookedCount?: Maybe<Scalars['Float']>;
  ContractCount?: Maybe<Scalars['Float']>;
  OpportunityCount?: Maybe<Scalars['Float']>;
};


export type UserOutput = {
  __typename?: 'UserOutput';
  userName?: Maybe<Scalars['String']>;
  handPhone?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
};

export type Attachments = {
  File?: Maybe<Scalars['Upload']>;
};

export type GetUserProfileQueryVariables = Exact<{
  UserId: Scalars['Float'];
}>;


export type GetUserProfileQuery = (
  { __typename?: 'Query' }
  & { User: Array<(
    { __typename?: 'CommonSetupUserData' }
    & Pick<CommonSetupUserData, 'companyName' | 'userName' | 'email' | 'handPhone'>
    & { departmentData?: Maybe<(
      { __typename?: 'CommonSetupDeptData' }
      & Pick<CommonSetupDeptData, 'deptId' | 'name'>
    )> }
  )> }
);

export type ChangePasswordMutationVariables = Exact<{
  OldPassword: Scalars['String'];
  NewPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changePassword'>
);

export type GetMeterTypeListingQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetMeterTypeListingQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & Pick<LeaseProSetPropertyData, 'totalMeterOutstanding'>
    & { meterTypeListing: Array<(
      { __typename?: 'LeaseMeterMeterTypeData' }
      & Pick<LeaseMeterMeterTypeData, 'meterTypeId' | 'itemCode' | 'typeName' | 'totalMasterMeterReading' | 'totalSubMeterUsage'>
    )> }
  ) }
);

export type GetMeterGroupQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  MeterTypeId: Scalars['Float'];
}>;


export type GetMeterGroupQuery = (
  { __typename?: 'Query' }
  & { meterTypeByPropertyIdAndMeterTypeId: (
    { __typename?: 'LeaseMeterMeterTypeData' }
    & Pick<LeaseMeterMeterTypeData, 'totalMasterMeterReading' | 'totalUnitMeterWithRental' | 'totalSubMeterSubmittedByCurrentYearMonth' | 'latestMeterReadingUpdatedDate' | 'meterTypeId' | 'typeName'>
  ), PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { leaseProSetBlockData: Array<(
      { __typename?: 'LeaseProSetBlockData' }
      & Pick<LeaseProSetBlockData, 'blockId' | 'blockName'>
    )> }
  ) }
);

export type GetMeterListingQueryVariables = Exact<{
  MeterTypeId: Scalars['Float'];
  BlockId: Scalars['Float'];
  PropertyId: Scalars['Float'];
}>;


export type GetMeterListingQuery = (
  { __typename?: 'Query' }
  & { meterTypeByPropertyIdAndMeterTypeId: (
    { __typename?: 'LeaseMeterMeterTypeData' }
    & Pick<LeaseMeterMeterTypeData, 'meterTypeId' | 'typeName'>
  ), meterListingByBlockIdAndMeterTypeId: Array<(
    { __typename?: 'SubMeterListing' }
    & Pick<SubMeterListing, 'MeterCode' | 'MeterID' | 'Name' | 'PreviousDate' | 'RentalID' | 'TotalUsageRate' | 'TotalPreviousReading' | 'UnitNo' | 'ItemCode' | 'TypeName' | 'AttachmentCount'>
  )> }
);

export type GetMeterDetailByMeterIdsQueryVariables = Exact<{
  MeterId: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type GetMeterDetailByMeterIdsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'businessDate'>
  & { meterByIds?: Maybe<Array<(
    { __typename?: 'MeterDetail' }
    & Pick<MeterDetail, 'MeterID' | 'DebtorID' | 'RentalID' | 'MaxReading' | 'MeterCode' | 'MeterNo' | 'MultiplyFactor' | 'Name' | 'PreviousDate' | 'PreviousReading' | 'TypeName' | 'UnitNo' | 'Wastage' | 'UsageRate' | 'ItemCode'>
  )>> }
);

export type SaveMeterReadingMutationVariables = Exact<{
  MeterInput: SaveMeterReadingInputModel;
}>;


export type SaveMeterReadingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'SaveMeterReading'>
);

export type GetAttachmentByMeterIdsQueryVariables = Exact<{
  MeterId: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type GetAttachmentByMeterIdsQuery = (
  { __typename?: 'Query' }
  & { getMeterAttachmentByIds?: Maybe<Array<(
    { __typename?: 'MeterAttachmentPopUpOutput' }
    & Pick<MeterAttachmentPopUpOutput, 'MeterId' | 'unitNo' | 'meterNo' | 'actualMeterNo' | 'readingDate'>
    & { Attachment?: Maybe<(
      { __typename?: 'AttachementOutput' }
      & Pick<AttachementOutput, 'base64File' | 'fileName' | 'mediaType' | 'uniqueFileName' | 'suffix'>
    )> }
  )>> }
);

export type GetMeterMasterListingQueryVariables = Exact<{
  MeterTypeId: Scalars['Float'];
  PropertyId: Scalars['Float'];
}>;


export type GetMeterMasterListingQuery = (
  { __typename?: 'Query' }
  & { meterTypeByPropertyIdAndMeterTypeId: (
    { __typename?: 'LeaseMeterMeterTypeData' }
    & Pick<LeaseMeterMeterTypeData, 'meterTypeId' | 'typeName'>
  ), meterMasterListingByPropertyIdAndMeterTypeId: Array<(
    { __typename?: 'LeaseMeterMeterMasterData' }
    & Pick<LeaseMeterMeterMasterData, 'meterId' | 'meterName' | 'meterNo' | 'previousReading' | 'previousDate' | 'apportionMethodCode' | 'calculateMethodCode'>
    & { meterType: (
      { __typename?: 'LeaseMeterMeterTypeData' }
      & Pick<LeaseMeterMeterTypeData, 'typeName' | 'itemCode'>
    ), latestMeterReading?: Maybe<(
      { __typename?: 'LeaseMeterMeterReadingData' }
      & { attachment?: Maybe<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'attachmentId'>
      )> }
    )> }
  )> }
);

export type GetMeterMasterDetailByMeterIdsQueryVariables = Exact<{
  MeterId: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type GetMeterMasterDetailByMeterIdsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'businessDate'>
  & { meterMasterByIds?: Maybe<Array<(
    { __typename?: 'MeterMasterDetail' }
    & Pick<MeterMasterDetail, 'MeterID' | 'MaxReading' | 'MeterCode' | 'MeterNo' | 'MultiplyFactor' | 'MeterName' | 'PreviousDate' | 'PreviousReading' | 'TypeName' | 'Wastage' | 'ItemCode'>
  )>> }
);

export type SaveMeterMasterReadingMutationVariables = Exact<{
  MeterInput: SaveMeterMasterReadingInputModel;
}>;


export type SaveMeterMasterReadingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'SaveMeterMasterReading'>
);

export type GetPropertyListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyListQuery = (
  { __typename?: 'Query' }
  & { PropertyListByUserIds: Array<(
    { __typename?: 'CommonSetupProjectResData' }
    & Pick<CommonSetupProjectResData, 'resourcesId' | 'name'>
    & { property?: Maybe<(
      { __typename?: 'LeaseProSetPropertyData' }
      & Pick<LeaseProSetPropertyData, 'propertyId' | 'landArea' | 'measureUnitType'>
      & { imageData?: Maybe<(
        { __typename?: 'LeaseProSetImageDataEntity' }
        & Pick<LeaseProSetImageDataEntity, 'imageId' | 'fileId' | 'fileName'>
      )> }
    )>, companyData?: Maybe<(
      { __typename?: 'CommonSetupCompanyDataEntity' }
      & Pick<CommonSetupCompanyDataEntity, 'companyId' | 'name'>
      & { currencyData?: Maybe<(
        { __typename?: 'CommonSetupCurrencyDataEntity' }
        & Pick<CommonSetupCurrencyDataEntity, 'symbol'>
      )> }
    )> }
  )> }
);

export type GetDashboardDataQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetDashboardDataQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & Pick<LeaseProSetPropertyData, 'totalMeterOutstanding' | 'totalRoutineInspectCount'>
    & { MonthlySales?: Maybe<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'totalSalesAmt' | 'submittedCount'>
    )> }
  ) }
);

export type GetRoutineInspectionListingByPropertyIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  CheckIds: Array<Scalars['Float']> | Scalars['Float'];
  TenantName: Scalars['String'];
  IsSearch: Scalars['Boolean'];
}>;


export type GetRoutineInspectionListingByPropertyIdQuery = (
  { __typename?: 'Query' }
  & { GetRoutineInspectionListingByPropertyId?: Maybe<Array<(
    { __typename?: 'RoutineInspectionListing' }
    & Pick<RoutineInspectionListing, 'checkId' | 'accountId' | 'unitId' | 'tenantName' | 'category' | 'date'>
  )>> }
);

export type GetRoutineInspectionDetailByCheckIdQueryVariables = Exact<{
  checkId: Scalars['Float'];
}>;


export type GetRoutineInspectionDetailByCheckIdQuery = (
  { __typename?: 'Query' }
  & { GetRoutineInspectionDetailByCheckId?: Maybe<Array<(
    { __typename?: 'LeaseOperaCheckDetailData' }
    & Pick<LeaseOperaCheckDetailData, 'checkDetailId' | 'remark' | 'point' | 'forfeit' | 'checkBy'>
    & { checkData?: Maybe<(
      { __typename?: 'LeaseOperaCheckData' }
      & Pick<LeaseOperaCheckData, 'checkTime'>
    )>, category?: Maybe<(
      { __typename?: 'PopupLstElementEntity' }
      & Pick<PopupLstElementEntity, 'titleCn'>
    )>, tenant?: Maybe<(
      { __typename?: 'CommonSetupAccountData' }
      & Pick<CommonSetupAccountData, 'name'>
    )>, unit?: Maybe<(
      { __typename?: 'LeaseProSetUnitData' }
      & Pick<LeaseProSetUnitData, 'unitNo'>
    )>, checkItem?: Maybe<(
      { __typename?: 'LeaseOperaCheckItemData' }
      & Pick<LeaseOperaCheckItemData, 'createDate' | 'item' | 'point' | 'forfeit' | 'remark'>
    )> }
  )>> }
);

export type GetFileDataByIdQueryVariables = Exact<{
  fileId: Scalars['String'];
}>;


export type GetFileDataByIdQuery = (
  { __typename?: 'Query' }
  & { GetFileDataById?: Maybe<(
    { __typename?: 'FileOutput' }
    & Pick<FileOutput, 'fileName' | 'suffix' | 'base64File'>
  )> }
);

export type GetInspectionCategoryQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetInspectionCategoryQuery = (
  { __typename?: 'Query' }
  & { GetInspectionCategory?: Maybe<Array<(
    { __typename?: 'PopupLstElementEntity' }
    & Pick<PopupLstElementEntity, 'popUpLstElementId' | 'titleCn'>
  )>> }
);

export type GetInspectionItemsByPropertyByTypeIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  TypeId: Scalars['Float'];
}>;


export type GetInspectionItemsByPropertyByTypeIdQuery = (
  { __typename?: 'Query' }
  & { GetInspectionItemsByPropertyByTypeId?: Maybe<Array<(
    { __typename?: 'LeaseOperaCheckItemData' }
    & Pick<LeaseOperaCheckItemData, 'checkItemId' | 'item' | 'point' | 'forfeit'>
  )>> }
);

export type GetActiveUnitsByPropertyIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetActiveUnitsByPropertyIdQuery = (
  { __typename?: 'Query' }
  & { GetActiveUnitsByPropertyId?: Maybe<Array<(
    { __typename?: 'ActiveUnits' }
    & Pick<ActiveUnits, 'unitId' | 'unitNo' | 'floorNo' | 'accountId' | 'tenantName' | 'propertyId' | 'blockId' | 'blockName' | 'rentalId' | 'startDate' | 'expiryDate'>
  )>> }
);

export type AddRoutineInspectionMutationVariables = Exact<{
  CheckDataInputModel: CheckDataInputModel;
}>;


export type AddRoutineInspectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'AddRoutineInspection'>
);

export type GetRoutineInspectionAttachmentByCheckDetaildIdQueryVariables = Exact<{
  checkDetailId: Scalars['Float'];
}>;


export type GetRoutineInspectionAttachmentByCheckDetaildIdQuery = (
  { __typename?: 'Query' }
  & { GetRoutineInspectionAttachmentByCheckDetaildId?: Maybe<Array<(
    { __typename?: 'RoutineInspectionAttachments' }
    & Pick<RoutineInspectionAttachments, 'base64File' | 'fileId' | 'fileName' | 'fileType'>
  )>> }
);

export type GetTotalRoutineInspectionCountByPropertyIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetTotalRoutineInspectionCountByPropertyIdQuery = (
  { __typename?: 'Query' }
  & { GetTotalRoutineInspectionCountByPropertyId?: Maybe<(
    { __typename?: 'RoutineInspectCount' }
    & Pick<RoutineInspectCount, 'routineInspectCount'>
  )> }
);

export type GetTenantSalesListingDataQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetTenantSalesListingDataQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { MonthlySales?: Maybe<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'totalSalesAmt' | 'submittedCount'>
    )>, LatestCompletedSales?: Maybe<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'transactionDate' | 'totalSalesAmt' | 'startMonth'>
    )>, DailySubmittedSales?: Maybe<Array<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'totalSalesAmt' | 'submittedCount' | 'tenantWithGto' | 'everyday'>
    )>> }
  ) }
);

export type GetDailySubmittedSalesQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  FilterDate?: Maybe<Scalars['Float']>;
}>;


export type GetDailySubmittedSalesQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { DailySubmittedSales?: Maybe<Array<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'totalSalesAmt' | 'submittedCount' | 'tenantWithGto' | 'everyday'>
    )>> }
  ) }
);

export type GetPosSubmissionByDateQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  Date: Scalars['DateTime'];
  RecordStatus: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPosSubmissionByDateQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isHasRejected'>
  & { getPosSubmissionByDate: Array<(
    { __typename?: 'PosSubmissionEntity' }
    & Pick<PosSubmissionEntity, 'submissionId' | 'debtorId' | 'recordStatus' | 'totalBillCount' | 'totalSalesAmt' | 'totalVoucherCount'>
    & { posTrx?: Maybe<Array<(
      { __typename?: 'PosTrxEntity' }
      & Pick<PosTrxEntity, 'posTrxId' | 'billCount' | 'voucherCount' | 'totalSalesAmt'>
      & { posDebtor?: Maybe<(
        { __typename?: 'PosDebtorEntity' }
        & Pick<PosDebtorEntity, 'posName'>
      )> }
    )>>, account: (
      { __typename?: 'CommonSetupAccountData' }
      & Pick<CommonSetupAccountData, 'name'>
    ), rental: (
      { __typename?: 'LeaseContRentalContractData' }
      & Pick<LeaseContRentalContractData, 'contractLotNo'>
    ) }
  )> }
);

export type RejectDailySalesMutationVariables = Exact<{
  SubmissionIds: Array<Scalars['Float']> | Scalars['Float'];
  Remark: Scalars['String'];
}>;


export type RejectDailySalesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'RejectDailySales'>
);

export type ApprovedDailySalesMutationVariables = Exact<{
  SubmissionIds: Array<Scalars['Float']> | Scalars['Float'];
  Remark: Scalars['String'];
}>;


export type ApprovedDailySalesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'ApproveDailySales'>
);

export type GetRejectedSalesByDateQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  Date?: Maybe<Scalars['DateTime']>;
  Status?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetRejectedSalesByDateQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { ActiveRentalContract?: Maybe<Array<(
      { __typename?: 'LeaseArDebtorData' }
      & { posSubmission: Array<(
        { __typename?: 'PosSubmissionEntity' }
        & Pick<PosSubmissionEntity, 'submissionId' | 'modifyDate' | 'totalSalesAmt' | 'remarks'>
        & { RejectedBy?: Maybe<(
          { __typename?: 'DailySalesOutput' }
          & Pick<DailySalesOutput, 'name'>
        )> }
      )> }
    )>> }
  ) }
);

export type GetPosSubmissionByIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  SubmissionId: Scalars['Float'];
}>;


export type GetPosSubmissionByIdQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { posSubmission?: Maybe<Array<(
      { __typename?: 'PosSubmissionEntity' }
      & Pick<PosSubmissionEntity, 'transactionDate' | 'totalBillCount' | 'totalVoucherCount' | 'totalNettSalesAmt' | 'totalSalesAmt' | 'totalTaxAmt' | 'recordStatus' | 'remarks' | 'modifyDate'>
      & { posTradeSales?: Maybe<Array<(
        { __typename?: 'PosTradeSalesEntity' }
        & Pick<PosTradeSalesEntity, 'salesAmt'>
        & { popUpLstElement: (
          { __typename?: 'PopupLstElementEntity' }
          & Pick<PopupLstElementEntity, 'popUpLstElementId' | 'titleCn'>
        ) }
      )>>, posTrx?: Maybe<Array<(
        { __typename?: 'PosTrxEntity' }
        & Pick<PosTrxEntity, 'posTrxId' | 'cashAmt' | 'visaAmt' | 'masterAmt' | 'amexAmt' | 'jcbAmt' | 'debitAmt' | 'mallVoucherAmt' | 'othersAmt' | 'billCount' | 'voucherCount' | 'nettSalesAmt' | 'taxAmt' | 'serviceCharges' | 'totalSalesAmt'>
        & { posDebtor?: Maybe<(
          { __typename?: 'PosDebtorEntity' }
          & Pick<PosDebtorEntity, 'posId' | 'posName'>
        )>, AttachmentsByTrxId?: Maybe<Array<(
          { __typename?: 'DailySalesOutput' }
          & Pick<DailySalesOutput, 'refId' | 'attachmentId' | 'uniqueFileName'>
        )>> }
      )>>, account: (
        { __typename?: 'CommonSetupAccountData' }
        & Pick<CommonSetupAccountData, 'name'>
      ), RejectedBy?: Maybe<(
        { __typename?: 'DailySalesOutput' }
        & Pick<DailySalesOutput, 'name'>
      )> }
    )>> }
  ) }
);

export type GetTurnoverSummaryByIdQueryVariables = Exact<{
  TurnoverSummaryId: Scalars['Float'];
}>;


export type GetTurnoverSummaryByIdQuery = (
  { __typename?: 'Query' }
  & { getDailySalesById: (
    { __typename?: 'TurnoverSummaryEntity' }
    & Pick<TurnoverSummaryEntity, 'billCount' | 'nettSalesAmt' | 'recordStatus' | 'refRecordId' | 'refTable' | 'serviceCharges' | 'taxAmt' | 'totalSalesAmt' | 'transactionDate' | 'turnoverSummaryId' | 'voucherCount'>
    & { posSubmission?: Maybe<(
      { __typename?: 'PosSubmissionEntity' }
      & Pick<PosSubmissionEntity, 'recordStatus' | 'submissionId' | 'totalBillCount' | 'totalNettSalesAmt' | 'totalSalesAmt' | 'totalServiceCharges' | 'totalTaxAmt' | 'totalVoucherCount' | 'transactionDate'>
      & { posTrx?: Maybe<Array<(
        { __typename?: 'PosTrxEntity' }
        & Pick<PosTrxEntity, 'posTrxId' | 'cashAmt' | 'visaAmt' | 'masterAmt' | 'amexAmt' | 'jcbAmt' | 'debitAmt' | 'mallVoucherAmt' | 'othersAmt' | 'billCount' | 'voucherCount' | 'nettSalesAmt' | 'taxAmt' | 'serviceCharges' | 'totalSalesAmt'>
        & { posDebtor?: Maybe<(
          { __typename?: 'PosDebtorEntity' }
          & Pick<PosDebtorEntity, 'posId' | 'posName'>
        )>, AttachmentsByTrxId?: Maybe<Array<(
          { __typename?: 'DailySalesOutput' }
          & Pick<DailySalesOutput, 'refId' | 'attachmentId' | 'uniqueFileName'>
        )>> }
      )>> }
    )>, turnoverCategory?: Maybe<Array<(
      { __typename?: 'TurnoverCategoryEntity' }
      & Pick<TurnoverCategoryEntity, 'nettSalesAmt' | 'turnoverCategoryId'>
      & { popUpLstElement?: Maybe<(
        { __typename?: 'PopupLstElementEntity' }
        & Pick<PopupLstElementEntity, 'titleCn'>
      )> }
    )>>, account?: Maybe<(
      { __typename?: 'CommonSetupAccountData' }
      & Pick<CommonSetupAccountData, 'name'>
    )> }
  ) }
);

export type GetFilesByPosTrxIdQueryVariables = Exact<{
  PosTrxId: Array<Scalars['Float']> | Scalars['Float'];
  RefTable: Scalars['String'];
}>;


export type GetFilesByPosTrxIdQuery = (
  { __typename?: 'Query' }
  & { GetFilesByRefId: Array<(
    { __typename?: 'DailySalesOutput' }
    & Pick<DailySalesOutput, 'refId' | 'attachmentId' | 'base64File' | 'uniqueFileName' | 'suffix' | 'filePath' | 'fileName' | 'mediaType'>
  )> }
);

export type GetTenantListWithGtoQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetTenantListWithGtoQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'businessDate'>
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { ActiveRentalContract?: Maybe<Array<(
      { __typename?: 'LeaseArDebtorData' }
      & { activeRentalContract?: Maybe<(
        { __typename?: 'LeaseContRentalContractData' }
        & Pick<LeaseContRentalContractData, 'IsHasGTO' | 'contractLotNo' | 'contractNo' | 'debtorId' | 'rentalId' | 'accountId' | 'defaultStartDate' | 'validDate'>
        & { account: (
          { __typename?: 'CommonSetupAccountData' }
          & Pick<CommonSetupAccountData, 'name'>
        ) }
      )> }
    )>> }
  ) }
);

export type GetTradeSalesByDebtorIdQueryVariables = Exact<{
  DebtorId: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type GetTradeSalesByDebtorIdQuery = (
  { __typename?: 'Query' }
  & { debtorByIds: Array<(
    { __typename?: 'LeaseArDebtorData' }
    & { activeRentalContract?: Maybe<(
      { __typename?: 'LeaseContRentalContractData' }
      & { CategoryNameList?: Maybe<Array<(
        { __typename?: 'DailySalesOutput' }
        & Pick<DailySalesOutput, 'rentalId' | 'categoryName' | 'categoryId'>
      )>>, PosNameList?: Maybe<Array<(
        { __typename?: 'DailySalesOutput' }
        & Pick<DailySalesOutput, 'posId' | 'posName' | 'posNumber'>
      )>> }
    )> }
  )> }
);

export type AddDailySalesMutationVariables = Exact<{
  PosSubmissionInput: PosSubmissionInputType;
  PosTrxInput: Array<PosTrxInputType> | PosTrxInputType;
  PosTradeSalesInput?: Maybe<Array<PosTradeSalesInputType> | PosTradeSalesInputType>;
}>;


export type AddDailySalesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addPosSubmission'>
);

export type UpdateDailySalesMutationVariables = Exact<{
  SubmissionId: Scalars['Float'];
  PosSubmissionInput: PosSubmissionInputType;
  PosTrxInput: Array<PosTrxInputType> | PosTrxInputType;
  PosTradeSalesInput?: Maybe<Array<PosTradeSalesInputType> | PosTradeSalesInputType>;
}>;


export type UpdateDailySalesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePosSubmission'>
);

export type GetMonthlyCompletedSalesQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  StartMonth?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
}>;


export type GetMonthlyCompletedSalesQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { MonthlyCompletedSales?: Maybe<Array<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'totalSalesAmt' | 'transactionDate' | 'totalBillCount' | 'totalVoucherCount'>
    )>> }
  ) }
);

export type GetCompletedSalesByDateQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  Date: Scalars['DateTime'];
}>;


export type GetCompletedSalesByDateQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { CompletedSalesByDate?: Maybe<Array<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'totalSalesAmt' | 'totalBillCount' | 'totalVoucherCount' | 'transactionDate'>
    )>> }
  ) }
);

export type GetDailyCompletedSalesQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  Date: Scalars['DateTime'];
}>;


export type GetDailyCompletedSalesQuery = (
  { __typename?: 'Query' }
  & { PropertyById: (
    { __typename?: 'LeaseProSetPropertyData' }
    & { DailyCompletedSales?: Maybe<Array<(
      { __typename?: 'DailySalesOutput' }
      & Pick<DailySalesOutput, 'turnoverSummaryId' | 'name' | 'transactionDate' | 'totalVoucherCount' | 'totalBillCount' | 'totalSalesAmt'>
    )>> }
  ) }
);

export const GetUserProfileDocument = gql`
    query GetUserProfile($UserId: Float!) {
  User: userByIds(UserIds: [$UserId]) {
    companyName
    userName
    email
    handPhone
    departmentData {
      deptId
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserProfileGQL extends Apollo.Query<GetUserProfileQuery, GetUserProfileQueryVariables> {
    document = GetUserProfileDocument;
    
  }
export const ChangePasswordDocument = gql`
    mutation ChangePassword($OldPassword: String!, $NewPassword: String!) {
  changePassword(OldPassword: $OldPassword, NewPassword: $NewPassword)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    document = ChangePasswordDocument;
    
  }
export const GetMeterTypeListingDocument = gql`
    query GetMeterTypeListing($PropertyId: Float!) {
  PropertyById(PropertyId: $PropertyId) {
    totalMeterOutstanding
    meterTypeListing {
      meterTypeId
      itemCode
      typeName
      totalMasterMeterReading(PropertyId: $PropertyId)
      totalSubMeterUsage(PropertyId: $PropertyId)
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeterTypeListingGQL extends Apollo.Query<GetMeterTypeListingQuery, GetMeterTypeListingQueryVariables> {
    document = GetMeterTypeListingDocument;
    
  }
export const GetMeterGroupDocument = gql`
    query GetMeterGroup($PropertyId: Float!, $MeterTypeId: Float!) {
  meterTypeByPropertyIdAndMeterTypeId(
    MeterTypeId: $MeterTypeId
    PropertyId: $PropertyId
  ) {
    totalMasterMeterReading(PropertyId: $PropertyId)
    totalUnitMeterWithRental(PropertyId: $PropertyId)
    totalSubMeterSubmittedByCurrentYearMonth(PropertyId: $PropertyId)
    latestMeterReadingUpdatedDate(PropertyId: $PropertyId)
    meterTypeId
    typeName
  }
  PropertyById(PropertyId: $PropertyId) {
    leaseProSetBlockData {
      blockId
      blockName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeterGroupGQL extends Apollo.Query<GetMeterGroupQuery, GetMeterGroupQueryVariables> {
    document = GetMeterGroupDocument;
    
  }
export const GetMeterListingDocument = gql`
    query GetMeterListing($MeterTypeId: Float!, $BlockId: Float!, $PropertyId: Float!) {
  meterTypeByPropertyIdAndMeterTypeId(
    MeterTypeId: $MeterTypeId
    PropertyId: $PropertyId
  ) {
    meterTypeId
    typeName
  }
  meterListingByBlockIdAndMeterTypeId(
    MeterTypeId: $MeterTypeId
    BlockId: $BlockId
  ) {
    MeterCode
    MeterID
    Name
    PreviousDate
    RentalID
    TotalUsageRate
    TotalPreviousReading
    UnitNo
    ItemCode
    TypeName
    AttachmentCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeterListingGQL extends Apollo.Query<GetMeterListingQuery, GetMeterListingQueryVariables> {
    document = GetMeterListingDocument;
    
  }
export const GetMeterDetailByMeterIdsDocument = gql`
    query GetMeterDetailByMeterIds($MeterId: [Float!]!) {
  meterByIds(MeterIds: $MeterId) {
    MeterID
    DebtorID
    RentalID
    MaxReading
    MeterCode
    MeterNo
    MultiplyFactor
    Name
    PreviousDate
    PreviousReading
    TypeName
    UnitNo
    Wastage
    UsageRate
    ItemCode
  }
  businessDate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeterDetailByMeterIdsGQL extends Apollo.Query<GetMeterDetailByMeterIdsQuery, GetMeterDetailByMeterIdsQueryVariables> {
    document = GetMeterDetailByMeterIdsDocument;
    
  }
export const SaveMeterReadingDocument = gql`
    mutation SaveMeterReading($MeterInput: SaveMeterReadingInputModel!) {
  SaveMeterReading(MeterInput: $MeterInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveMeterReadingGQL extends Apollo.Mutation<SaveMeterReadingMutation, SaveMeterReadingMutationVariables> {
    document = SaveMeterReadingDocument;
    
  }
export const GetAttachmentByMeterIdsDocument = gql`
    query getAttachmentByMeterIds($MeterId: [Float!]!) {
  getMeterAttachmentByIds(MeterIds: $MeterId) {
    Attachment {
      base64File
      fileName
      mediaType
      uniqueFileName
      mediaType
      suffix
    }
    MeterId
    unitNo
    meterNo
    actualMeterNo
    readingDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttachmentByMeterIdsGQL extends Apollo.Query<GetAttachmentByMeterIdsQuery, GetAttachmentByMeterIdsQueryVariables> {
    document = GetAttachmentByMeterIdsDocument;
    
  }
export const GetMeterMasterListingDocument = gql`
    query GetMeterMasterListing($MeterTypeId: Float!, $PropertyId: Float!) {
  meterTypeByPropertyIdAndMeterTypeId(
    MeterTypeId: $MeterTypeId
    PropertyId: $PropertyId
  ) {
    meterTypeId
    typeName
  }
  meterMasterListingByPropertyIdAndMeterTypeId(
    MeterTypeId: $MeterTypeId
    PropertyId: $PropertyId
  ) {
    meterId
    meterName
    meterNo
    previousReading
    previousDate
    apportionMethodCode
    calculateMethodCode
    meterType {
      typeName
      itemCode
    }
    latestMeterReading {
      attachment {
        attachmentId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeterMasterListingGQL extends Apollo.Query<GetMeterMasterListingQuery, GetMeterMasterListingQueryVariables> {
    document = GetMeterMasterListingDocument;
    
  }
export const GetMeterMasterDetailByMeterIdsDocument = gql`
    query GetMeterMasterDetailByMeterIds($MeterId: [Float!]!) {
  meterMasterByIds(MeterIds: $MeterId) {
    MeterID
    MaxReading
    MeterCode
    MeterNo
    MultiplyFactor
    MeterName
    PreviousDate
    PreviousReading
    TypeName
    Wastage
    ItemCode
  }
  businessDate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeterMasterDetailByMeterIdsGQL extends Apollo.Query<GetMeterMasterDetailByMeterIdsQuery, GetMeterMasterDetailByMeterIdsQueryVariables> {
    document = GetMeterMasterDetailByMeterIdsDocument;
    
  }
export const SaveMeterMasterReadingDocument = gql`
    mutation SaveMeterMasterReading($MeterInput: SaveMeterMasterReadingInputModel!) {
  SaveMeterMasterReading(MeterInput: $MeterInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveMeterMasterReadingGQL extends Apollo.Mutation<SaveMeterMasterReadingMutation, SaveMeterMasterReadingMutationVariables> {
    document = SaveMeterMasterReadingDocument;
    
  }
export const GetPropertyListDocument = gql`
    query GetPropertyList {
  PropertyListByUserIds {
    resourcesId
    name
    property {
      propertyId
      landArea
      measureUnitType
      imageData {
        imageId
        fileId
        fileName
      }
    }
    companyData {
      companyId
      name
      currencyData {
        symbol
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPropertyListGQL extends Apollo.Query<GetPropertyListQuery, GetPropertyListQueryVariables> {
    document = GetPropertyListDocument;
    
  }
export const GetDashboardDataDocument = gql`
    query GetDashboardData($PropertyId: Float!) {
  PropertyById(PropertyId: $PropertyId) {
    totalMeterOutstanding
    MonthlySales {
      totalSalesAmt
      submittedCount
    }
    totalRoutineInspectCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDashboardDataGQL extends Apollo.Query<GetDashboardDataQuery, GetDashboardDataQueryVariables> {
    document = GetDashboardDataDocument;
    
  }
export const GetRoutineInspectionListingByPropertyIdDocument = gql`
    query GetRoutineInspectionListingByPropertyId($PropertyId: Float!, $CheckIds: [Float!]!, $TenantName: String!, $IsSearch: Boolean!) {
  GetRoutineInspectionListingByPropertyId(
    PropertyId: $PropertyId
    CheckIds: $CheckIds
    TenantName: $TenantName
    IsSearch: $IsSearch
  ) {
    checkId
    accountId
    unitId
    tenantName
    category
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoutineInspectionListingByPropertyIdGQL extends Apollo.Query<GetRoutineInspectionListingByPropertyIdQuery, GetRoutineInspectionListingByPropertyIdQueryVariables> {
    document = GetRoutineInspectionListingByPropertyIdDocument;
    
  }
export const GetRoutineInspectionDetailByCheckIdDocument = gql`
    query GetRoutineInspectionDetailByCheckId($checkId: Float!) {
  GetRoutineInspectionDetailByCheckId(checkId: $checkId) {
    checkDetailId
    remark
    checkData {
      checkTime
    }
    point
    forfeit
    category {
      titleCn
    }
    tenant {
      name
    }
    checkBy
    unit {
      unitNo
    }
    checkItem {
      createDate
      item
      point
      forfeit
      remark
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoutineInspectionDetailByCheckIdGQL extends Apollo.Query<GetRoutineInspectionDetailByCheckIdQuery, GetRoutineInspectionDetailByCheckIdQueryVariables> {
    document = GetRoutineInspectionDetailByCheckIdDocument;
    
  }
export const GetFileDataByIdDocument = gql`
    query GetFileDataById($fileId: String!) {
  GetFileDataById(FileID: $fileId) {
    fileName
    suffix
    base64File
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFileDataByIdGQL extends Apollo.Query<GetFileDataByIdQuery, GetFileDataByIdQueryVariables> {
    document = GetFileDataByIdDocument;
    
  }
export const GetInspectionCategoryDocument = gql`
    query GetInspectionCategory($PropertyId: Float!) {
  GetInspectionCategory(PropertyId: $PropertyId) {
    popUpLstElementId
    titleCn
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInspectionCategoryGQL extends Apollo.Query<GetInspectionCategoryQuery, GetInspectionCategoryQueryVariables> {
    document = GetInspectionCategoryDocument;
    
  }
export const GetInspectionItemsByPropertyByTypeIdDocument = gql`
    query GetInspectionItemsByPropertyByTypeId($PropertyId: Float!, $TypeId: Float!) {
  GetInspectionItemsByPropertyByTypeId(PropertyId: $PropertyId, TypeId: $TypeId) {
    checkItemId
    item
    point
    forfeit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInspectionItemsByPropertyByTypeIdGQL extends Apollo.Query<GetInspectionItemsByPropertyByTypeIdQuery, GetInspectionItemsByPropertyByTypeIdQueryVariables> {
    document = GetInspectionItemsByPropertyByTypeIdDocument;
    
  }
export const GetActiveUnitsByPropertyIdDocument = gql`
    query GetActiveUnitsByPropertyId($PropertyId: Float!) {
  GetActiveUnitsByPropertyId(PropertyId: $PropertyId) {
    unitId
    unitNo
    floorNo
    accountId
    tenantName
    propertyId
    blockId
    blockName
    rentalId
    startDate
    expiryDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveUnitsByPropertyIdGQL extends Apollo.Query<GetActiveUnitsByPropertyIdQuery, GetActiveUnitsByPropertyIdQueryVariables> {
    document = GetActiveUnitsByPropertyIdDocument;
    
  }
export const AddRoutineInspectionDocument = gql`
    mutation AddRoutineInspection($CheckDataInputModel: CheckDataInputModel!) {
  AddRoutineInspection(CheckDataInputModel: $CheckDataInputModel)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRoutineInspectionGQL extends Apollo.Mutation<AddRoutineInspectionMutation, AddRoutineInspectionMutationVariables> {
    document = AddRoutineInspectionDocument;
    
  }
export const GetRoutineInspectionAttachmentByCheckDetaildIdDocument = gql`
    query GetRoutineInspectionAttachmentByCheckDetaildId($checkDetailId: Float!) {
  GetRoutineInspectionAttachmentByCheckDetaildId(checkDetailId: $checkDetailId) {
    base64File
    fileId
    fileName
    fileType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoutineInspectionAttachmentByCheckDetaildIdGQL extends Apollo.Query<GetRoutineInspectionAttachmentByCheckDetaildIdQuery, GetRoutineInspectionAttachmentByCheckDetaildIdQueryVariables> {
    document = GetRoutineInspectionAttachmentByCheckDetaildIdDocument;
    
  }
export const GetTotalRoutineInspectionCountByPropertyIdDocument = gql`
    query GetTotalRoutineInspectionCountByPropertyId($PropertyId: Float!) {
  GetTotalRoutineInspectionCountByPropertyId(PropertyId: $PropertyId) {
    routineInspectCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTotalRoutineInspectionCountByPropertyIdGQL extends Apollo.Query<GetTotalRoutineInspectionCountByPropertyIdQuery, GetTotalRoutineInspectionCountByPropertyIdQueryVariables> {
    document = GetTotalRoutineInspectionCountByPropertyIdDocument;
    
  }
export const GetTenantSalesListingDataDocument = gql`
    query GetTenantSalesListingData($PropertyId: Float!) {
  PropertyById(PropertyId: $PropertyId) {
    MonthlySales {
      totalSalesAmt
      submittedCount
    }
    LatestCompletedSales {
      transactionDate
      totalSalesAmt
      startMonth
    }
    DailySubmittedSales {
      totalSalesAmt
      submittedCount
      tenantWithGto
      everyday
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantSalesListingDataGQL extends Apollo.Query<GetTenantSalesListingDataQuery, GetTenantSalesListingDataQueryVariables> {
    document = GetTenantSalesListingDataDocument;
    
  }
export const GetDailySubmittedSalesDocument = gql`
    query GetDailySubmittedSales($PropertyId: Float!, $FilterDate: Float) {
  PropertyById(PropertyId: $PropertyId) {
    DailySubmittedSales(FilterDate: $FilterDate) {
      totalSalesAmt
      submittedCount
      tenantWithGto
      everyday
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDailySubmittedSalesGQL extends Apollo.Query<GetDailySubmittedSalesQuery, GetDailySubmittedSalesQueryVariables> {
    document = GetDailySubmittedSalesDocument;
    
  }
export const GetPosSubmissionByDateDocument = gql`
    query GetPosSubmissionByDate($PropertyId: Float!, $Date: DateTime!, $RecordStatus: [String!]!) {
  getPosSubmissionByDate(
    PropertyId: $PropertyId
    Date: $Date
    RecordStatus: $RecordStatus
  ) {
    submissionId
    debtorId
    recordStatus
    totalBillCount
    totalSalesAmt
    totalVoucherCount
    posTrx {
      posTrxId
      billCount
      voucherCount
      totalSalesAmt
      posDebtor {
        posName
      }
    }
    account {
      name
    }
    rental {
      contractLotNo
    }
  }
  isHasRejected(PropertyId: $PropertyId, Date: $Date)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPosSubmissionByDateGQL extends Apollo.Query<GetPosSubmissionByDateQuery, GetPosSubmissionByDateQueryVariables> {
    document = GetPosSubmissionByDateDocument;
    
  }
export const RejectDailySalesDocument = gql`
    mutation RejectDailySales($SubmissionIds: [Float!]!, $Remark: String!) {
  RejectDailySales(SubmissionIds: $SubmissionIds, Remark: $Remark)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectDailySalesGQL extends Apollo.Mutation<RejectDailySalesMutation, RejectDailySalesMutationVariables> {
    document = RejectDailySalesDocument;
    
  }
export const ApprovedDailySalesDocument = gql`
    mutation ApprovedDailySales($SubmissionIds: [Float!]!, $Remark: String!) {
  ApproveDailySales(SubmissionIds: $SubmissionIds, Remark: $Remark)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApprovedDailySalesGQL extends Apollo.Mutation<ApprovedDailySalesMutation, ApprovedDailySalesMutationVariables> {
    document = ApprovedDailySalesDocument;
    
  }
export const GetRejectedSalesByDateDocument = gql`
    query GetRejectedSalesByDate($PropertyId: Float!, $Date: DateTime, $Status: [String!]) {
  PropertyById(PropertyId: $PropertyId) {
    ActiveRentalContract {
      posSubmission(Status: $Status, Date: $Date) {
        submissionId
        modifyDate
        RejectedBy {
          name
        }
        totalSalesAmt
        remarks
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRejectedSalesByDateGQL extends Apollo.Query<GetRejectedSalesByDateQuery, GetRejectedSalesByDateQueryVariables> {
    document = GetRejectedSalesByDateDocument;
    
  }
export const GetPosSubmissionByIdDocument = gql`
    query GetPosSubmissionById($PropertyId: Float!, $SubmissionId: Float!) {
  PropertyById(PropertyId: $PropertyId) {
    posSubmission(SubmissionId: $SubmissionId) {
      transactionDate
      totalBillCount
      totalVoucherCount
      totalNettSalesAmt
      totalSalesAmt
      totalTaxAmt
      recordStatus
      remarks
      posTradeSales {
        salesAmt
        popUpLstElement {
          popUpLstElementId
          titleCn
        }
      }
      posTrx {
        posTrxId
        cashAmt
        visaAmt
        masterAmt
        amexAmt
        jcbAmt
        debitAmt
        mallVoucherAmt
        othersAmt
        billCount
        voucherCount
        nettSalesAmt
        taxAmt
        serviceCharges
        totalSalesAmt
        posDebtor {
          posId
          posName
        }
        AttachmentsByTrxId {
          refId
          attachmentId
          uniqueFileName
        }
      }
      account {
        name
      }
      RejectedBy {
        name
      }
      modifyDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPosSubmissionByIdGQL extends Apollo.Query<GetPosSubmissionByIdQuery, GetPosSubmissionByIdQueryVariables> {
    document = GetPosSubmissionByIdDocument;
    
  }
export const GetTurnoverSummaryByIdDocument = gql`
    query GetTurnoverSummaryById($TurnoverSummaryId: Float!) {
  getDailySalesById(TurnoverSummaryId: $TurnoverSummaryId) {
    billCount
    nettSalesAmt
    recordStatus
    refRecordId
    refTable
    serviceCharges
    taxAmt
    totalSalesAmt
    transactionDate
    turnoverSummaryId
    voucherCount
    posSubmission {
      recordStatus
      submissionId
      totalBillCount
      totalNettSalesAmt
      totalSalesAmt
      totalServiceCharges
      totalTaxAmt
      totalVoucherCount
      transactionDate
      posTrx {
        posTrxId
        cashAmt
        visaAmt
        masterAmt
        amexAmt
        jcbAmt
        debitAmt
        mallVoucherAmt
        othersAmt
        billCount
        voucherCount
        nettSalesAmt
        taxAmt
        serviceCharges
        totalSalesAmt
        posDebtor {
          posId
          posName
        }
        AttachmentsByTrxId {
          refId
          attachmentId
          uniqueFileName
        }
      }
    }
    turnoverCategory {
      nettSalesAmt
      turnoverCategoryId
      popUpLstElement {
        titleCn
      }
    }
    account {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTurnoverSummaryByIdGQL extends Apollo.Query<GetTurnoverSummaryByIdQuery, GetTurnoverSummaryByIdQueryVariables> {
    document = GetTurnoverSummaryByIdDocument;
    
  }
export const GetFilesByPosTrxIdDocument = gql`
    query GetFilesByPosTrxId($PosTrxId: [Float!]!, $RefTable: String!) {
  GetFilesByRefId(posTrxId: $PosTrxId, refTable: $RefTable) {
    refId
    attachmentId
    base64File
    uniqueFileName
    suffix
    filePath
    fileName
    mediaType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFilesByPosTrxIdGQL extends Apollo.Query<GetFilesByPosTrxIdQuery, GetFilesByPosTrxIdQueryVariables> {
    document = GetFilesByPosTrxIdDocument;
    
  }
export const GetTenantListWithGtoDocument = gql`
    query GetTenantListWithGTO($PropertyId: Float!) {
  PropertyById(PropertyId: $PropertyId) {
    ActiveRentalContract {
      activeRentalContract {
        IsHasGTO
        account {
          name
        }
        contractLotNo
        contractNo
        debtorId
        rentalId
        accountId
        defaultStartDate
        validDate
      }
    }
  }
  businessDate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantListWithGtoGQL extends Apollo.Query<GetTenantListWithGtoQuery, GetTenantListWithGtoQueryVariables> {
    document = GetTenantListWithGtoDocument;
    
  }
export const GetTradeSalesByDebtorIdDocument = gql`
    query GetTradeSalesByDebtorId($DebtorId: [Float!]!) {
  debtorByIds(DebtorIds: $DebtorId) {
    activeRentalContract {
      CategoryNameList {
        rentalId
        categoryName
        categoryId
      }
      PosNameList {
        posId
        posName
        posNumber
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTradeSalesByDebtorIdGQL extends Apollo.Query<GetTradeSalesByDebtorIdQuery, GetTradeSalesByDebtorIdQueryVariables> {
    document = GetTradeSalesByDebtorIdDocument;
    
  }
export const AddDailySalesDocument = gql`
    mutation AddDailySales($PosSubmissionInput: PosSubmissionInputType!, $PosTrxInput: [PosTrxInputType!]!, $PosTradeSalesInput: [PosTradeSalesInputType!]) {
  addPosSubmission(
    PosSubmissionInput: $PosSubmissionInput
    PosTrxInput: $PosTrxInput
    PosTradeSalesInput: $PosTradeSalesInput
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDailySalesGQL extends Apollo.Mutation<AddDailySalesMutation, AddDailySalesMutationVariables> {
    document = AddDailySalesDocument;
    
  }
export const UpdateDailySalesDocument = gql`
    mutation UpdateDailySales($SubmissionId: Float!, $PosSubmissionInput: PosSubmissionInputType!, $PosTrxInput: [PosTrxInputType!]!, $PosTradeSalesInput: [PosTradeSalesInputType!]) {
  updatePosSubmission(
    SubmissionId: $SubmissionId
    PosSubmissionInput: $PosSubmissionInput
    PosTrxInput: $PosTrxInput
    PosTradeSalesInput: $PosTradeSalesInput
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDailySalesGQL extends Apollo.Mutation<UpdateDailySalesMutation, UpdateDailySalesMutationVariables> {
    document = UpdateDailySalesDocument;
    
  }
export const GetMonthlyCompletedSalesDocument = gql`
    query GetMonthlyCompletedSales($PropertyId: Float!, $StartMonth: Float, $Year: Float) {
  PropertyById(PropertyId: $PropertyId) {
    MonthlyCompletedSales(startMonth: $StartMonth, year: $Year) {
      totalSalesAmt
      transactionDate
      totalBillCount
      totalVoucherCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMonthlyCompletedSalesGQL extends Apollo.Query<GetMonthlyCompletedSalesQuery, GetMonthlyCompletedSalesQueryVariables> {
    document = GetMonthlyCompletedSalesDocument;
    
  }
export const GetCompletedSalesByDateDocument = gql`
    query GetCompletedSalesByDate($PropertyId: Float!, $Date: DateTime!) {
  PropertyById(PropertyId: $PropertyId) {
    CompletedSalesByDate(Date: $Date) {
      totalSalesAmt
      totalBillCount
      totalVoucherCount
      transactionDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompletedSalesByDateGQL extends Apollo.Query<GetCompletedSalesByDateQuery, GetCompletedSalesByDateQueryVariables> {
    document = GetCompletedSalesByDateDocument;
    
  }
export const GetDailyCompletedSalesDocument = gql`
    query GetDailyCompletedSales($PropertyId: Float!, $Date: DateTime!) {
  PropertyById(PropertyId: $PropertyId) {
    DailyCompletedSales(Date: $Date) {
      turnoverSummaryId
      name
      transactionDate
      totalVoucherCount
      totalBillCount
      totalSalesAmt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDailyCompletedSalesGQL extends Apollo.Query<GetDailyCompletedSalesQuery, GetDailyCompletedSalesQueryVariables> {
    document = GetDailyCompletedSalesDocument;
    
  }